import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { format } from "date-fns";
import logoURL from "./TextoLogo64"; // Importa logoURL desde TextoLogo64.js
import TextoLogo64COLON from "./TextoLogo64COLON"; // Importa logoURL desde TextoLogo64.js
import logoTop from "./PruebaImgTopFactura"; // Importa logoURL desde TextoLogo64.js
import logoDown from "./PruebaImgDownFactura"; // Importa logoURL desde TextoLogo64.js
import QR from "./QrWsp.js"; // Importa logoURL desde TextoLogo64.js
import jwtDecode from "jwt-decode";

import { abrirFacturaHtml } from "./facturaAfipHtmlGenerator.js";

import { useNavigate } from "react-router-dom";

import Cookies from "js-cookie"; // COOKIE

import jsPDF from "jspdf";
import "jspdf-autotable"; // Importa la función autoTable

import QRCode from "qrcode";
import {
  FACTURA_ID_TO_CBTE,
  calcularTotalesFacturaAfip,
  construirItemsAfip,
  resolverCondicionIvaReceptor,
  resolverDatosDocumentoAfip,
} from "../utils/facturaAfip.js";
import { getFormaPagoAfip } from "../utils/medioPagoAfipMapping.js";

// Importar generador de PDF para tabla de gastos
import { generarPdfTablaGastos } from "./pdf_esqueletos/tablaGastosPdf";
// Importar generador de PDF para tabla de recetas
import { generarPdfTablaReceta } from "./pdf_esqueletos/tablaRecetaPdf";
import { deliverPdf, reservePdfTarget } from "./pdf_esqueletos/helpers/pdfDelivery.js";

// Importar servicio de sincronización WebSocket
import websocketSyncService from "../services/websocketSyncService";

// ############################################################################################################################## FECHAS
// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
// SOLUCION FECHA LOCAL TOMADA DEL NAVEGADOR *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(tz);

// FECHA HORA ACTUAL GLOBAL
// const getFechaHoraActualClient = async () => {
//   return new Date().toLocaleDateString();
// }

function getFechaHoraActualClient(fechahora = null) {
  // Detectar la zona del navegador (ej: "America/Argentina/Buenos_Aires")
  const zona = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Si no se pasa fechahora, usar ahora mismo
  const fecha = fechahora ? dayjs(fechahora).tz(zona) : dayjs().tz(zona);

  // Devolver como string ISO 8601 con offset (ej: 2025-08-06T00:00:00-03:00)
  const fechaFormateada = fecha.format();

  return {
    fechaServidor: fechaFormateada,
    zona: zona,
  };
}

// TIME ZONES:
// America/Argentina/Cordoba
// America/Mexico_City

// EN TODAS LAS VENTANAS DE FILTRO DE FECHAS HAY QUE AGREGAR LA ZONA. PORQUE ESTAMOS CONSTRUYENDO TIMESTAMP:   'DD/MM/YYYY HH:mm:ss' y necesitamos TIMESTAMPZ para que se compare correctamente con el servidor.

// FUNCIONES: ######

// ### dayjs(): devuelve una fecha y hora sin zona explicita. infiere zona UNIVERSAL, UTC.
// osea que al usar dayjs() SIEMPRE debemos especificar la zona:    dayjs(fechaProcesar).tz(zona)

// ejemplo:
//let fechaProcesar = dayjs(ultimaCaja.fecha).tz(zona).add(1, 'day'); :  ultimaCaja.fecha esta en utc, tz(zona) la convierte a zona, no le dice que esta en zona "zona" sino que lo convierte

// ### new Date(): en JavaScript te devuelve la fecha y hora actual del momento exacto en que se ejecuta, representado como un objeto Date. asume UTC

// ### toDate(): el objeto Date pierde la información de zona horaria visual, pero conserva el instante correcto. el server va a grabar la fecha como esta formateada segun toDate() pero va a inferir la zona. lo cual puede llevar a problemas.
// usamos toDate() en el momento en el que vamos a comparar una fecha con otra o usarla en una condicion.

// ---------------------------------
//---------------------------------
// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
// ##############################################################################################################################


// URL GLOBAL - Configurado desde .env
const MODE = process.env.REACT_APP_MODE;
let serverURL;

if (MODE === 'production') {
  serverURL = process.env.REACT_APP_URL_PROD || 'http://localhost:5000';
} else {
  serverURL = process.env.REACT_APP_URL_DEV || 'http://localhost:5000';
}
// console.log('serverURL', serverURL);

// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
// URL GLOBAL
// const serverURL = "http://localhost:5000";
//const serverURL = "https://tours.lutente.com:5001";
//const serverURL = window.location.origin; // → "https://tours.lutente.com"
// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-

// CREAR CONTEXT ***********************************************************************
// CREAR CONTEXT ***********************************************************************
// CREAR CONTEXT ***********************************************************************
export const ErpContext = createContext(); //Se define un contexto global utilizando createContext(), que se utiliza para compartir información a través de la aplicación.
export const ErpProvider = ({ children }) => {
  //La propiedad children representa los componentes hijos que estarán dentro del proveedor.

  // ADMIN CONTEXT ***********************************************************************
  // ADMIN CONTEXT ***********************************************************************
  // ADMIN CONTEXT ***********************************************************************

  // IMPUESTO HARDCODED ***********************************************************************
  const ivaHardcoded = 21;

  // ADMIN UBICACIONES ***********************************************************************

  // AXIOS COOKIE
  // O, si prefieres usar el interceptor global:
  axios.interceptors.request.use((config) => {
    config.withCredentials = true;
    
    // 🔒 Validar cookie de seguridad antes de cada petición
    // Solo validar para rutas que NO sean login (login no necesita cookie)
    if (!config.url.includes("/login")) {
      const tenantCookie = Cookies.get("tenant");
      const savedUser = localStorage.getItem("user");
      const savedToken = localStorage.getItem("token");
      
      // Si hay usuario logueado pero no hay cookie de seguridad
      if (savedUser && !tenantCookie) {
        // Verificar si el token JWT es válido antes de bloquear
        // Puede ser un problema temporal de cookies
        if (savedToken) {
          try {
            const decodedToken = jwtDecode(savedToken);
            const currentTime = Date.now() / 1000;
            
            // Solo bloquear si el token también expiró
            if (decodedToken.exp && decodedToken.exp < currentTime) {
              console.error("⚠️ Petición bloqueada: cookie tenant y token JWT expirados");
              return Promise.reject(new Error("Sesión de seguridad expirada"));
            }
            // Si el token es válido pero falta cookie, permitir la petición
            // Puede ser un problema temporal de cookies del navegador
            console.warn("⚠️ Cookie tenant no encontrada pero token válido - permitiendo petición");
          } catch (error) {
            // Si no se puede decodificar el token, bloquear
            console.error("⚠️ Petición bloqueada: error al decodificar token");
            return Promise.reject(new Error("Sesión de seguridad expirada"));
          }
        } else {
          // Hay usuario pero no token ni cookie - bloquear
          console.error("⚠️ Petición bloqueada: cookie tenant no existe y no hay token");
          return Promise.reject(new Error("Sesión de seguridad expirada"));
        }
      }
    }
    
    return config;
  }, (error) => {
    return Promise.reject(error);
  });

  // FECHA HORA ACTUAL GLOBAL
  /* const getFechaHoraActualClient = async () => {
    return new Date().toLocaleDateString();
  };*/
  const [ubicaciones, arrayUbicaciones] = useState([]); //Define el estado ubicaciones con su función setUbicaciones. Inicialmente es un array vacío y contendrá las ubicaciones que se obtengan desde la API.
  const [formatoNumericoGlobal, setFormatoNumericoGlobal] = useState(null); // Locale numérico configurado a nivel tenant

  // Función para obtener ubicaciones
  const getUbicacion = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getUbicacion");
      arrayUbicaciones(response.data); //setea el array
      return response.data;
    } catch (error) {
      console.error("Error fetching ubicaciones:", error);
    }
  };

  // Función para crear una nueva ubicación
  const postUbicacion = async (descripcionUbicacion, esDestino = null) => {
    try {
      await axios.post(serverURL + "/adminAPI/postUbicacion", {
        descripcion: descripcionUbicacion,
        esDestino: esDestino,
      });
      getUbicacion(); // Actualizar la lista de ubicaciones
    } catch (error) {
      console.error("Error creating ubicacion:", error);
    }
  };

  // Función para actualizar una ubicación
  const updateUbicacion = async (id, descripcion, esDestino = undefined) => {
    try {
      const data = { id, descripcion };
      if (esDestino !== undefined) {
        data.esDestino = esDestino;
      }
      await axios.put(serverURL + "/adminAPI/updateUbicacion", data);
      getUbicacion(); // Actualizar la lista de ubicaciones
    } catch (error) {
      console.error("Error updating ubicacion:", error);
      throw error;
    }
  };

  // Función para eliminar una ubicación (soft delete)
  const deleteUbicacion = async (id) => {
    try {
      await axios.post(serverURL + "/adminAPI/deleteUbicacion", {
        id,
      });
      getUbicacion(); // Actualizar la lista de ubicaciones
    } catch (error) {
      console.error("Error deleting ubicacion:", error);
      throw error;
    }
  };

  // ADMIN NEGOCIO ***********************************************************************

  const [negocios, arrayNegocios] = useState([]);

  // Función para obtener negocios
  const getNegocio = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getNegocio");
      arrayNegocios(response.data); //setea el array
      return response.data;
    } catch (error) {
      console.error("Error fetching ubicaciones:", error);
    }
  };

  // Función para crear un nuevo negocio
  const postNegocio = async (descripcionUbicacion) => {
    try {
      await axios.post(serverURL + "/adminAPI/postNegocio", {
        descripcion: descripcionUbicacion,
      });
      getNegocio(); // Actualizar la lista de negocios
    } catch (error) {
      console.error("Error creating ubicacion:", error);
    }
  };

  // Función para actualizar un negocio
  const updateNegocio = async (id, descripcion) => {
    try {
      await axios.put(serverURL + "/adminAPI/updateNegocio", {
        id,
        descripcion,
      });
      getNegocio(); // Actualizar la lista de negocios
    } catch (error) {
      console.error("Error updating negocio:", error);
      throw error;
    }
  };

  // Función para eliminar un negocio (soft delete)
  const deleteNegocio = async (id) => {
    try {
      await axios.post(serverURL + "/adminAPI/deleteNegocio", {
        id,
      });
      getNegocio(); // Actualizar la lista de negocios
    } catch (error) {
      console.error("Error deleting negocio:", error);
      throw error;
    }
  };

  // ADMIN TIPO ENTIDAD ***********************************************************************
  const [tipoEntidades, arrayTipoEntidad] = useState([]);

  // Función para obtener negocios
  const getTipoEntidad = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getTipoEntidad");
      arrayTipoEntidad(response.data); //setea el array
    } catch (error) {
      console.error("Error fetching ubicaciones:", error);
    }
  };

  // Función para crear un nuevo negocio
  const postTipoEntidad = async (descripcionTipoEntidad) => {
    try {
      await axios.post(serverURL + "/adminAPI/postTipoEntidad", {
        descripcion: descripcionTipoEntidad,
      });
      getTipoEntidad(); // Actualizar la lista de negocios
    } catch (error) {
      console.error("Error creating ubicacion:", error);
    }
  };

  // Función para actualizar un tipo de entidad
  const updateTipoEntidad = async (id, descripcion) => {
    try {
      await axios.put(serverURL + "/adminAPI/updateTipoEntidad", {
        id,
        descripcion,
      });
      getTipoEntidad(); // Actualizar la lista de tipos de entidad
    } catch (error) {
      console.error("Error updating tipoEntidad:", error);
      throw error;
    }
  };

  // Función para eliminar un tipo de entidad (soft delete)
  const deleteTipoEntidad = async (id) => {
    try {
      await axios.post(serverURL + "/adminAPI/deleteTipoEntidad", {
        id,
      });
      getTipoEntidad(); // Actualizar la lista de tipos de entidad
    } catch (error) {
      console.error("Error deleting tipoEntidad:", error);
      throw error;
    }
  };

  // ADMIN CONDICION IVA ***********************************************************************
  const [condicionIva, arrayCondicionIva] = useState([]);

  // Función para obtener condicionIva
  const getCondicionIva = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getCondicionIva");
      arrayCondicionIva(response.data); //setea el array
      return response.data;
    } catch (error) {
      console.error("Error fetching condicionIva:", error);
    }
  };

  // Función para obtener condicionIva por entidad
  const getCondicionIvaByEntidad = async (idEntidad) => {
    try {
      const response = await axios.get(
        serverURL + `/adminAPI/getCondicionIvaByEntidad/${idEntidad}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching condicionIva by entidad:", error);
      return null;
    }
  };

  const getEntidadFilterTipoEntidad = async (
    idTipoEntidad, 
    page,
    limit,
    filters = {}
  ) => {
    try {
      const hasPagination = page !== undefined && limit !== undefined;
      const params = {};

      // Solo incluir paginación si fue solicitada explícitamente
      if (hasPagination) {
        params.page = page;
        params.limit = limit;
      }

      // Incluir filtros solo cuando vienen con valor
      if (filters.searchId) params.searchId = filters.searchId;
      if (filters.searchNombre) params.searchNombre = filters.searchNombre;
      if (filters.searchApellido) params.searchApellido = filters.searchApellido;
      if (filters.searchDni) params.searchDni = filters.searchDni;

      const response = await axios.get(
        serverURL + `/adminAPI/getEntidadFilterTipoEntidad/${idTipoEntidad}`,
        { params }
      );

      // Si se solicitó paginación, devolver también metadatos
      if (hasPagination) {
        const data = Array.isArray(response.data?.data)
          ? response.data.data
          : Array.isArray(response.data)
            ? response.data
            : [];

        return {
          data,
          currentPage: response.data?.currentPage ?? page ?? 1,
          totalPages: response.data?.totalPages ?? 1,
          total: response.data?.total ?? data.length,
        };
      }

      // Respuesta sin paginación → array plano
      if (Array.isArray(response.data)) {
        return response.data;
      }

      if (Array.isArray(response.data?.data)) {
        return response.data.data;
      }

      return [];
    } catch (error) {
      console.error("Error fetching entidades:", error);
      throw error;
    }
  };

  const getProveedoresConCuentaCorriente = async () => {
    try {
      const response = await axios.get(
        serverURL + "/adminAPI/getProveedoresConCuentaCorriente"
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener proveedores con cuenta corriente:", error);
      throw error;
    }
  };

  const getDetalleProveedorCuentaCorriente = async (idEntidad) => {
    try {
      const response = await axios.get(
        serverURL + `/adminAPI/getDetalleProveedorCuentaCorriente/${idEntidad}`
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener detalle proveedor CC:", error);
      throw error;
    }
  };

  const revertirServicioBOM = async (payload) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/revertirServicioBOM", payload);
      return response.data;
    } catch (error) {
      console.error("Error al revertir servicio BOM:", error);
      throw error;
    }
  };

  const revertirTransaccionProveedor = async (idTransaccion, opcion, montoDevolucion = null) => {
    try {
      const payload = { idTransaccion, opcion };
      if (montoDevolucion != null && montoDevolucion > 0) {
        payload.montoDevolucion = montoDevolucion;
      }
      const response = await axios.post(serverURL + "/adminAPI/revertirTransaccionProveedor", payload);
      return response.data;
    } catch (error) {
      console.error("Error al revertir transacción proveedor:", error);
      throw error;
    }
  };

  // ADMIN ENTIDAD ***********************************************************************
  const [entidades, arrayEntidad] = useState([]);

  // Función para actualizar la columna 'eliminado' en los registros seleccionados
  const updateEliminarEntidad = async (selectionModel) => {
    try {
      await axios.put("http://localhost:5000/adminAPI/putEntidad", {
        ids: selectionModel,
      });
      getEntidad(); // Refrescar los datos después de la eliminación
    } catch (error) {
      console.error("Error al eliminar entidades:", error);
    }
  };

  const updateDevolverEntidad = async (selectionModel) => {
    try {
      await axios.put("http://localhost:5000/adminAPI/putEntidadDevolver", {
        ids: selectionModel,
      });
      getEntidad(); // Refrescar los datos después de la eliminación
    } catch (error) {
      console.error("Error al eliminar entidades:", error);
    }
  };

  const getEntidad = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getEntidad");
      arrayEntidad(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching entidades:", error);
      return [];
    }
  };

  const getEntidadByID = async (idEntidad) => {
    try {
      if (idEntidad === undefined || idEntidad === null || idEntidad === "undefined") {
        console.warn("getEntidadByID llamado sin idEntidad válido:", idEntidad);
        return null;
      }
      // console.log("idEntidad" + idEntidad);
      const response = await axios.get(
        serverURL + `/adminAPI/getEntidadByID/${idEntidad}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching entidades:", error);
    }
  };

  const getEntidadByDNI = async (dniEntidad) => {
    try {
      // console.log("dniEntidad" + dniEntidad);
      const response = await axios.get(
        serverURL + `/adminAPI/getEntidadByDNI/${dniEntidad}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching entidades:", error);
    }
  };

  const existeProveedorConDNI = async (dni, idExcluir = null) => {
    try {
      if (!dni || !String(dni).trim()) return false;
      const params = new URLSearchParams({ dni: String(dni).trim() });
      if (idExcluir) params.append("idExcluir", idExcluir);
      const response = await axios.get(
        serverURL + `/adminAPI/existeProveedorConDNI?${params}`,
      );
      return !!response?.data?.existe;
    } catch (error) {
      console.error("Error verificando DNI proveedor:", error);
      return false;
    }
  };

  const [entidadesTipoEntidad, arrayEntidadesTipoEntidad] = useState([]);

  const getEntidadByTipoEntidad = async (idTipoEnt) => {
    try {
      // console.log("idTipoEntidad " + idTipoEnt);
      const response = await axios.get(
        serverURL + `/adminAPI/getEntidadByTipoEntidad/${idTipoEnt}`,
      );
      arrayEntidadesTipoEntidad(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching entidades:", error);
    }
  };

  const postEntidad = async (
    descripcionEntidad,
    apellidoEntidad,
    telefonoEntidad,
    emailEntidad,
    dniCuitCuilEntidad,
    direccionEntidad,
    localidadEntidad,
    provinciaEntidad,
    idTipoEntidadEntidad,
    idCondicionIvaEntidad,
        // NUEVOS PARÁMETROS
        sexoEntidad,
        fechaNacimientoEntidad,
        paisEntidad,
        codigoPostalEntidad,
        observacionesEntidad,
        esTutorEntidad,
        nombreTutorEntidad,
        apellidoTutorEntidad,
        telefonoTutorEntidad,
        // DATOS BANCARIOS
        nombreBancoEntidad,
        numeroCuentaEntidad,
        cbuCvuCuentaEntidad,
        aliasCuentaEntidad,
        esVendedorEntidad,
        extraOptions = null,
        adjuntosEntidad = null,
  ) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/postEntidad", {
        descripcion: descripcionEntidad,
        apellido: apellidoEntidad,
        telefono: telefonoEntidad,
        email: emailEntidad,
        dniCuitCuil: dniCuitCuilEntidad,
        direccion: direccionEntidad,
        localidad: localidadEntidad,
        provincia: provinciaEntidad,
        idTipoEntidad: idTipoEntidadEntidad,
        idCondicionIva: idCondicionIvaEntidad,
          // NUEVOS CAMPOS
          sexo: sexoEntidad,
          fechaNacimiento: fechaNacimientoEntidad,
          pais: paisEntidad,
          codigoPostal: codigoPostalEntidad,
          observaciones: observacionesEntidad,
          esTutor: esTutorEntidad,
          nombreTutor: nombreTutorEntidad,
          apellidoTutor: apellidoTutorEntidad,
          telefonoTutor: telefonoTutorEntidad,
          // DATOS BANCARIOS
          nombreBanco: nombreBancoEntidad,
          numeroCuenta: numeroCuentaEntidad,
          cbuCvuCuenta: cbuCvuCuentaEntidad,
          aliasCuenta: aliasCuentaEntidad,
          esVendedor: esVendedorEntidad,
          validacionCapacidadViaje: extraOptions?.validacionCapacidadViaje || null,
          adjuntos: adjuntosEntidad && adjuntosEntidad.length > 0 ? JSON.stringify(adjuntosEntidad) : null,
      });

      // if (!response.ok) {
      //   // Lanza un error si la respuesta no es exitosa
      //   throw new Error(`Error al crear la entidad: ${response.statusText}`);
      // }

      // Si la respuesta es exitosa (código 2xx)
      // if (response.status >= 200 && response.status < 300) {
      // console.log("Entidad creada con éxito:", response.data);
      return response.data;
      // return { success: true, data: response.data }; // puedes retornar algo si lo necesitas
      // }
    } catch (error) {
      console.error("Error creating entidad:", error);
      throw error;
    }
  };

  // ADMIN UPDATE ENTIDAD ***********************************************************************

  const updateEntidad = async (
    idEntidad,
    descripcionEntidad,
    apellidoEntidad,
    telefonoEntidad,
    emailEntidad,
    dniCuitCuilEntidad,
    direccionEntidad,
    localidadEntidad,
    provinciaEntidad,
    idTipoEntidadEntidad,
    idCondicionIvaEntidad,
      // NUEVOS PARÁMETROS
      sexoEntidad,
      fechaNacimientoEntidad,
      paisEntidad,
      codigoPostalEntidad,
      observacionesEntidad,
      esTutorEntidad,
      nombreTutorEntidad,
      apellidoTutorEntidad,
      telefonoTutorEntidad,
      // DATOS BANCARIOS
      nombreBancoEntidad,
      numeroCuentaEntidad,
      cbuCvuCuentaEntidad,
      aliasCuentaEntidad,
      esVendedorEntidad,
      adjuntosEntidad = null,
  ) => {
    try {
      const response = await axios.put(serverURL + "/adminAPI/updateEntidad", {
        idEntidad,
        descripcion: descripcionEntidad,
        apellido: apellidoEntidad,
        telefono: telefonoEntidad,
        email: emailEntidad,
        dniCuitCuil: dniCuitCuilEntidad,
        direccion: direccionEntidad,
        localidad: localidadEntidad,
        provincia: provinciaEntidad,
        idTipoEntidad: idTipoEntidadEntidad,
        idCondicionIva: idCondicionIvaEntidad,
          // NUEVOS CAMPOS
          sexo: sexoEntidad,
          fechaNacimiento: fechaNacimientoEntidad,
          pais: paisEntidad,
          codigoPostal: codigoPostalEntidad,
          observaciones: observacionesEntidad,
          esTutor: esTutorEntidad,
          nombreTutor: nombreTutorEntidad,
          apellidoTutor: apellidoTutorEntidad,
          telefonoTutor: telefonoTutorEntidad,
          // DATOS BANCARIOS
          nombreBanco: nombreBancoEntidad,
          numeroCuenta: numeroCuentaEntidad,
          cbuCvuCuenta: cbuCvuCuentaEntidad,
          aliasCuenta: aliasCuentaEntidad,
          esVendedor: esVendedorEntidad !== undefined ? esVendedorEntidad : false,
          adjuntos: adjuntosEntidad && adjuntosEntidad.length > 0 ? JSON.stringify(adjuntosEntidad) : null,
      });

      // if (!response.ok) {
      //   // Lanza un error si la respuesta no es exitosa
      //   throw new Error(`Error al actualizar la entidad: ${response.statusText}`);
      // }

      getEntidad();
    } catch (error) {
      console.error("Error actualizar entidad:", error);
    }
  };

  // Update only email for Entidad
  const updateEntidadEmail = async (idEntidad, email) => {
    try {
      if (!idEntidad) throw new Error("idEntidad requerido");
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email || !emailRegex.test(email)) throw new Error("Email inválido");
      const response = await axios.put(
        `${serverURL}/adminAPI/updateEntidadEmail`,
        { idEntidad, email },
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error actualizando email de entidad:",
        error?.response?.data || error.message,
      );
      throw error;
    }
  };

  // Verificar si un cliente puede ser eliminado
  const verificarEliminacionCliente = async (idEntidad) => {
    try {
      const response = await axios.get(
        `${serverURL}/adminAPI/verificarEliminacionCliente/${idEntidad}`
      );
      return response.data;
    } catch (error) {
      console.error('Error al verificar eliminación de cliente:', error);
      throw error;
    }
  };

  // Eliminar cliente (eliminación lógica)
  const deleteEntidadCliente = async (idEntidad) => {
    try {
      const response = await axios.delete(
        `${serverURL}/adminAPI/deleteEntidadCliente/${idEntidad}`
      );
      return response.data;
    } catch (error) {
      console.error('Error al eliminar cliente:', error);
      throw error;
    }
  };

  // Eliminar proveedor (soft delete) - solo si Monto, Consumido y Saldo son 0
  const deleteEntidadProveedor = async (idEntidad) => {
    try {
      const response = await axios.delete(
        `${serverURL}/adminAPI/deleteEntidadProveedor/${idEntidad}`
      );
      return response.data;
    } catch (error) {
      console.error('Error al eliminar proveedor:', error);
      throw error;
    }
  };

  const getCountServiciosByProveedor = async (idEntidad) => {
    try {
      const response = await axios.get(
        `${serverURL}/adminAPI/countServiciosByProveedor/${idEntidad}`
      );
      return { count: response.data?.count ?? 0, servicios: response.data?.servicios ?? [] };
    } catch (error) {
      console.error('Error al listar servicios por proveedor:', error);
      throw error;
    }
  };

  const updateUsuario = async (
    idUsuario,
    user,
    nombreUsuario,
    apellidoUsuario,
    telefonoUsuario,
    emailUsuario,
    dniCuitCuilUsuario,
    direccionUsuario,
    localidadUsuario,
    provinciaUsuario,
    password,
    rol,
  ) => {
    try {
      const response = await axios.put(serverURL + "/adminAPI/updateUsuario", {
        idUsuario,
        usuario: user,
        nombre: nombreUsuario,
        apellido: apellidoUsuario,
        telefono: telefonoUsuario,
        email: emailUsuario,
        dniCuitCuil: dniCuitCuilUsuario,
        direccion: direccionUsuario,
        localidad: localidadUsuario,
        provincia: provinciaUsuario,
        password: password,
        rol: rol,
      });
      if (response.status >= 200 && response.status < 300) {
        getUsuario();
        // console.log("Entidad actualizada con éxito:", response.data);
        return { success: true, data: response.data }; // puedes retornar algo si lo necesitas
      }
    } catch (error) {
      console.error("Error actalizar entidad:", error);
    }
  };

  // ADMIN ENTIDAD TRES LETRAS***********************************************************************

  const [entidadesClientesTresLetras, arrayEntidadesClientesTresLetras] =
    useState([]);

  const getEntidadesClientesTresLetras = async (
    searchTextCliente,
    tipoEntidad,
    verEnCaja = false,
    verEnGasto = false,
  ) => {
    try {
      const params = {
        search: searchTextCliente,
      };
      
      // Solo agregar tipoEntidad si tiene un valor válido
      if (tipoEntidad !== null && tipoEntidad !== undefined) {
        params.tipoEntidad = tipoEntidad;
      }
      
      // Solo agregar verEnCaja si es true
      if (verEnCaja === true) {
        params.verEnCaja = 'true';
      }
      
      // Solo agregar verEnGasto si es true
      if (verEnGasto === true) {
        params.verEnGasto = 'true';
      }
      
      const response = await axios.get(
        serverURL + `/adminAPI/getEntidadClienteTresLetras`,
        { params }
      );
      arrayEntidadesClientesTresLetras(response.data);
      return response.data; //setea el array
    } catch (error) {
      console.error("Error fetching entidades:", error);
    }
  };

  // ADMIN USUARIO ***********************************************************************

  const [usuarios, arrayUsuario] = useState([]);

  const getUsuario = async (page = 1, limit = 10, searchUsuario = "") => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getUsuario", {
        params: {
          page,
          limit,
          searchUsuario
        }
      });
      
      // Mantener compatibilidad con el array de usuarios para otros componentes
      if (response.data.data) {
        arrayUsuario(response.data.data);
      }
      
      return response.data;
    } catch (error) {
      console.error("Error fetching usuarios:", error);
      throw error;    
    }
  };

  const postUsuario = async (
    usuario,
    nombre,
    apellido,
    telefono,
    email,
    direccion,
    localidad,
    provincia,
    password,
    rol,
    dniCuitCuil,
  ) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/postUsuario", {
        usuario: usuario,
        nombre: nombre,
        apellido: apellido,
        telefono: telefono,
        email: email,
        direccion: direccion,
        localidad: localidad,
        provincia: provincia,
        password: password,
        rol: rol,
        dniCuitCuil: dniCuitCuil,
      });

      await getUsuario();

      return { success: true, data: response.data }; // puedes retornar algo si lo necesitas
    } catch (error) {
      console.error("Error creating usuario:", error);
    }
  };

  const getRolUsuario = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getRolUsuario");
      return response.data; //setea el array
    } catch (error) {
      console.error("Error fetching roles de usuario:", error);
    }
  };

  const deleteUsuarioSoft = async (idUsuario) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/deleteUsuarioSoft", { idUsuario });
      await getUsuario();
      return response.data;
    } catch (error) {
      console.error("Error eliminando usuario:", error);
      throw error;
    }
  };

  const postRolUsuario = async (descripcion) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/postRolUsuario", {
        descripcion: descripcion,
      });
      return response.data;
    } catch (error) {
      console.error("Error creating rol de usuario:", error);
      throw error;
    }
  };

  const updateRolUsuario = async (id, descripcion) => {
    try {
      const response = await axios.put(serverURL + "/adminAPI/updateRolUsuario", {
        id: id,
        descripcion: descripcion,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating rol de usuario:", error);
      throw error;
    }
  };

  const getUsuariosByRol = async (idRol) => {
    try {
      const response = await axios.get(serverURL + `/adminAPI/getUsuariosByRol/${idRol}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching usuarios por rol:", error);
      throw error;
    }
  };

  const deleteRolYUsuarios = async (idRol) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/deleteRolYUsuarios", {
        idRol: idRol,
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting rol y usuarios:", error);
      throw error;
    }
  };

  const getMenuAcceso = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getMenuAcceso");
      return response.data; //setea el array
    } catch (error) {
      console.error("Error fetching menu de acceso:", error);
    }
  };

  const getRolAccesoByIdRol = async (idRol) => {
    try {
      const response = await axios.get(
        serverURL + `/adminAPI/rolAcceso/${idRol}`,
      );
      return response.data; //setea el array
    } catch (error) {
      console.error("Error fetching menu de acceso:", error);
    }
  };

  const actualizarRolAccesos = async (idRol, accesos) => {
    try {
      await axios.post(`${serverURL}/adminAPI/actualizarRolAccesos`, {
        idRolUsuario: idRol,
        accesos: accesos, // [{ id, label, activo }]
      });
      return { success: true };
    } catch (error) {
      // console.error("Error al actualizar accesos:", error);
      throw error;
    }
  };

   // MenuFuncionalidadAcceso methods (anteriormente ComponenteSector)
   const getComponenteSector = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getComponenteSector");
      return response.data;
    } catch (error) {
      console.error("Error fetching componentes sector:", error);
      throw error;
    }
  };

  const getComponenteSectorByMenuAcceso = async (idMenuAcceso) => {
    try {
      const response = await axios.get(serverURL + `/adminAPI/getComponenteSectorByMenuAcceso/${idMenuAcceso}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching componentes sector por menú:", error);
      throw error;
    }
  };

  const postComponenteSector = async (id, idMenuAcceso, descripcion, tipo, meta) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/postComponenteSector", {
        id,
        idMenuAcceso,
        descripcion,
        tipo,
        meta,
      });
      return response.data;
    } catch (error) {
      console.error("Error creando componente sector:", error);
      throw error;
    }
  };

  const updateComponenteSector = async (id, descripcion, tipo, meta) => {
    try {
      const response = await axios.put(serverURL + "/adminAPI/updateComponenteSector", {
        id,
        descripcion,
        tipo,
        meta,
      });
      return response.data;
    } catch (error) {
      console.error("Error actualizando componente sector:", error);
      throw error;
    }
  };

  const deleteComponenteSector = async (id) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/deleteComponenteSector", { id });
      return response.data;
    } catch (error) {
      console.error("Error eliminando componente sector:", error);
      throw error;
    }
  };

  // RolFuncionalidadAcceso methods (anteriormente RolSectorAcceso)
  const getRolSectorAccesoByIdRol = async (idRol) => {
    try {
      const response = await axios.get(serverURL + `/adminAPI/getRolSectorAccesoByIdRol/${idRol}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching accesos de sector del rol:", error);
      throw error;
    }
  };

  const actualizarRolSectorAccesos = async (idRol, accesos) => {
    try {
      await axios.post(`${serverURL}/adminAPI/actualizarRolSectorAccesos`, {
        idRolUsuario: idRol,
        accesos: accesos, // [{ idSector, idMenuAcceso, activo }]
      });
      return { success: true };
    } catch (error) {
      console.error("Error al actualizar accesos de sector:", error);
      throw error;
    }
  };

  // Verifica si el usuario tiene acceso a una funcionalidad específica dentro de un menú
  const tieneAccesoFuncionalidad = (user, idMenuAcceso, idFuncionalidad) => {
    if (!user || !user.accesosFuncionalidad || !Array.isArray(user.accesosFuncionalidad)) {
      return false;
    }
    return user.accesosFuncionalidad.some(
      (acceso) =>
        String(acceso.idMenuAcceso).trim() === String(idMenuAcceso).trim() &&
        String(acceso.idSector).trim() === String(idFuncionalidad).trim() &&
        acceso.eliminado === false
    );
  };

  // TRANSACCION CONTEXT ***********************************************************************
  // TRANSACCION CONTEXT ***********************************************************************
  // TRANSACCION CONTEXT ***********************************************************************

  // TRANSACCION MONEDA ***********************************************************************
  const [monedas, arrayMonedas] = useState([]);

  // Función para obtener negocios
  const getMoneda = async () => {
    try {
      const response = await axios.get(serverURL + "/transaccionAPI/getMoneda");
      arrayMonedas(response.data); //setea el array
    } catch (error) {
      console.error("Error fetching moneda:", error);
    }
  };

  // Función para crear un nuevo negocio
  const postMoneda = async (descripcionMoneda) => {
    try {
      await axios.post(serverURL + "/transaccionAPI/postMoneda", {
        descripcion: descripcionMoneda,
      });
      getMoneda(); // Actualizar la lista de negocios
    } catch (error) {
      console.error("Error creating moneda:", error);
    }
  };

  // Función para actualizar una moneda
  const updateMoneda = async (id, descripcionMoneda) => {
    try {
      await axios.put(serverURL + "/transaccionAPI/updateMoneda/" + id, {
        descripcion: descripcionMoneda,
      });
      getMoneda(); // Actualizar la lista de monedas
    } catch (error) {
      console.error("Error updating moneda:", error);
      throw error;
    }
  };

  // Función para eliminar (soft delete) una moneda
  const deleteMoneda = async (id) => {
    try {
      await axios.delete(serverURL + "/transaccionAPI/deleteMoneda/" + id);
      getMoneda(); // Actualizar la lista de monedas
    } catch (error) {
      console.error("Error deleting moneda:", error);
      throw error;
    }
  };

  // TRANSACCION TIPO MEDIO DE PAGO ***********************************************************************
  const [tipoMedioDePago, arrayTipoMedioDePago] = useState([]);

  // Función para obtener negocios
  const getTipoMedioDePago = async (condicionExtra) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTipoMedioDePago",
        {
          params: {
            condicionExtra,
          },
        },
      );
      arrayTipoMedioDePago(response.data); //setea el array
    } catch (error) {
      console.error("Error fetching medio de pago:", error);
    }
  };

  // Función para crear un nuevo negocio
  const postTipoMedioDePago = async (
    descripcionMedioPago,
    verEnCajaMedioPago,
    verEnTransaccionMedioPago,
    esMultiMonedaMedioPago,
    esPagoDiferidoMedioPago,
    userSelect,
  ) => {
    try {
      await axios.post(serverURL + "/transaccionAPI/postTipoMedioDePago", {
        descripcion: descripcionMedioPago,
        verEnCaja: verEnCajaMedioPago,
        verEnTransaccion: verEnTransaccionMedioPago,
        esMultiMoneda: esMultiMonedaMedioPago,
        esPagoDiferido: esPagoDiferidoMedioPago,
        userSelect: userSelect,
      });
      getTipoMedioDePago(); // Actualizar la lista de negocios
    } catch (error) {
      console.error("Error creating medio de pago:", error);
    }
  };

  // Función para actualizar tipo medio de pago
  const updateTipoMedioDePago = async (id, datos) => {
    try {
      await axios.put(serverURL + "/transaccionAPI/updateTipoMedioDePago/" + id, datos);
      getTipoMedioDePago();
    } catch (error) {
      console.error("Error updating tipo medio de pago:", error);
      throw error;
    }
  };

  // Función para eliminar tipo medio de pago
  const deleteTipoMedioDePago = async (id) => {
    try {
      await axios.delete(serverURL + "/transaccionAPI/deleteTipoMedioDePago/" + id);
      getTipoMedioDePago();
    } catch (error) {
      console.error("Error deleting tipo medio de pago:", error);
      throw error;
    }
  };

  // TRANSACCION MEDIO DE PAGO ***********************************************************************
  const [medioDePago, arrayMedioDePago] = useState([]);

  // Función para obtener negocios
  const getMedioDePago = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getMedioDePago",
      );
      arrayMedioDePago(response.data); //setea el array
    } catch (error) {
      console.error("Error fetching medio de pago:", error);
    }
  };

  // Función para crear un nuevo negocio
  const postMedioDePago = async (idTipoMedioDePago, descripcionMedioDePago) => {
    try {
      await axios.post(serverURL + "/transaccionAPI/postMedioDePago", {
        idTipoMedioDePago: idTipoMedioDePago,
        descripcion: descripcionMedioDePago,
      });

      await getMedioDePagoConDescripcion();
    } catch (error) {
      console.error("Error creating medio de pago:", error);
    }
  };

  // Función para actualizar medio de pago
  const updateMedioDePago = async (id, datos) => {
    try {
      await axios.put(serverURL + "/transaccionAPI/updateMedioDePago/" + id, datos);
      await getMedioDePago();
      await getMedioDePagoConDescripcion();
    } catch (error) {
      console.error("Error updating medio de pago:", error);
      throw error;
    }
  };

  // Función para eliminar medio de pago
  const deleteMedioDePago = async (id) => {
    try {
      await axios.delete(serverURL + "/transaccionAPI/deleteMedioDePago/" + id);
      await getMedioDePago();
      await getMedioDePagoConDescripcion();
    } catch (error) {
      console.error("Error deleting medio de pago:", error);
      throw error;
    }
  };

  const [medioDePagoConDescripcion, arrayMedioDePagoConDescripcion] = useState(
    [],
  );

  // Función para obtener negocios
  const getMedioDePagoConDescripcion = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getMedioDePagoConDescripcion",
      );
      arrayMedioDePagoConDescripcion(response.data); //setea el array
    } catch (error) {
      console.error("Error fetching medio de pago:", error);
    }
  };

  const [medioDePagoIdTipoEspecifico, arrayMedioDePagoIdTipoEspecifico] =
    useState([]);

  const getMedioDePagoIdTipoEspecifico = async (selectedTipoMedioDePago) => {
    try {
      // Si no hay tipo de medio de pago seleccionado, limpiar el array y retornar
      if (!selectedTipoMedioDePago || !selectedTipoMedioDePago.id) {
        arrayMedioDePagoIdTipoEspecifico([]);
        return [];
      }

      const response = await axios.get(
        serverURL +
          `/transaccionAPI/getMedioDePagoConDescripcion/${selectedTipoMedioDePago.id}`,
      );
      arrayMedioDePagoIdTipoEspecifico(response.data); //setea el array

      return response.data; // Devolver la lista de medios de pago directamente
    } catch (error) {
      console.error("Error fetching medio de pago:", error);
    }
  };

  const getMedioDePagoById = async (id) => {
    try {
      if (!id) return null;
      const response = await axios.get(
        serverURL + `/transaccionAPI/getMedioDePagoById/${id}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching medio de pago por ID:", error);
      return null;
    }
  };

  // TRANSACCION CUENTA CORRIENTE ***********************************************************************

  const [cuentasCorrientes, setCuentasCorrientes] = useState([]);

  const getCuentaCorriente = async () => {
    try {
      const response = await axios.get(
        serverURL + `/transaccionAPI/cuentaCorriente`,
      );
      setCuentasCorrientes(response.data); // Esto actualiza el estado para futuras referencias
      return response.data; // Devolver la lista de cuentas corrientes directamente
    } catch (error) {
      console.error("Error al obtener cuentas corrientes:", error);
      return []; // Devuelve un arreglo vacío en caso de error
    }
  };

  const getCuentaCorrienteByIdEntidad = async (idEntidad) => {
    try {
      const response = await axios.get(
        serverURL +
          `/transaccionAPI/getCuentaCorrienteByIdEntidad/${idEntidad}`,
      );
      return response.data; // Devolver la lista de cuentas corrientes directamente
    } catch (error) {
      console.error("Error al obtener cuentas corrientes:", error);
      return []; // Devuelve un arreglo vacío en caso de error
    }
  };

  const postCuentaCorriente = async (idEntidad, monto, idTipoTransaccion) => {
    try {
      const response = await axios.post(
        serverURL + "/transaccionAPI/cuentaCorriente",
        { idEntidad, monto, idTipoTransaccion },
      );
      return response.data;
    } catch (error) {
      console.error("Error al crear la cuenta corriente:", error);
    }
  };

  const updateCuentaCorriente = async (idEntidad, monto, idTipoTransaccion, usarOperacionCaja = false) => {
    try {
      const response = await axios.put(
        serverURL + `/transaccionAPI/cuentaCorriente/${idEntidad}`,
        { monto, idTipoTransaccion, usarOperacionCaja },
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar la cuenta corriente:", error);
    }
  };

  // TRANSACCION CATEGORIA ***********************************************************************
  const [categoriaTransaccion, arrayCategoriaTransaccion] = useState([]);

  const getCategoriaTransaccion = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getCategoriaTransaccion",
      );
      arrayCategoriaTransaccion(response.data);
    } catch (error) {
      console.error("Error fetching Categoria:", error);
    }
  };

  const postCategoriaTransaccion = async (descripcionCategoriaTransaccion) => {
    try {
      await axios.post(serverURL + "/transaccionAPI/postCategoriaTransaccion", {
        descripcion: descripcionCategoriaTransaccion,
      });
      getCategoriaTransaccion();
    } catch (error) {
      console.error("Error creating Categoria:", error);
      throw error;
    }
  };

  const updateCategoriaTransaccion = async (id, descripcion) => {
    try {
      await axios.put(serverURL + `/transaccionAPI/updateCategoriaTransaccion/${id}`, {
        descripcion,
      });
      getCategoriaTransaccion();
    } catch (error) {
      console.error("Error updating Categoria:", error);
      throw error;
    }
  };

  const deleteCategoriaTransaccion = async (id) => {
    try {
      await axios.delete(serverURL + `/transaccionAPI/deleteCategoriaTransaccion/${id}`);
      getCategoriaTransaccion();
    } catch (error) {
      console.error("Error deleting Categoria:", error);
      throw error;
    }
  };

  // TRANSACCION SUB CATEGORIA ***********************************************************************
  const [subCategoriaTransaccion, arraySubCategoriaTransaccion] = useState([]);

  const getSubCategoriaTransaccion = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getSubCategoriaTransaccion",
      );
      arraySubCategoriaTransaccion(response.data);
    } catch (error) {
      console.error("Error fetching SubCat:", error);
    }
  };

  const getGastosTransacciones = async ({
    page = 1,
    limit = 100,
    categoria = null,
    idSubCategoria = null,
    idEntidad = null,
    startDate = null,
    endDate = null,
    sortField = null,
    sortOrder = null,
  } = {}) => {
    // Construyo params exactamente con las claves que envía el front
    const params = { page, limit };

    if (categoria !== null) params.categoria = categoria;
    if (idSubCategoria !== null) params.idSubCategoria = idSubCategoria;
    if (idEntidad !== null) params.idEntidad = idEntidad;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (sortField) params.sortField = sortField;
    if (sortOrder) params.sortOrder = sortOrder;

    const { data } = await axios.get(
      `${serverURL}/transaccionAPI/getGastosTransacciones`,
      { params },
    );

    // data viene como { data: [...], totalCount, totalPages, currentPage }
    return {
      data: data.data,
      totalCount: data.totalCount,
      totalPages: data.totalPages,
      currentPage: data.currentPage,
      totalMontoGastos: data.totalMontoGastos ?? 0,
    };
  };

  // Función auxiliar para obtener TODOS los gastos sin paginación (para PDF)
  const getAllGastosForPDF = async (filtros) => {
    const params = { 
      page: 1, 
      limit: 99999, // Sin límite para obtener todos
      categoria: filtros.categoria?.id || null,
      idSubCategoria: filtros.subcategoria?.id || null,
      idEntidad: filtros.entidad?.id || null,
      startDate: filtros.startDate ? filtros.startDate.startOf("day").toISOString() : null,
      endDate: filtros.endDate ? filtros.endDate.endOf("day").toISOString() : null,
    };
    
    const { data } = await axios.get(
      `${serverURL}/transaccionAPI/getGastosTransacciones`,
      { params }
    );
    
    return {
      gastos: data.data,
      totalMontoGastos: data.totalMontoGastos ?? 0,
    };
  };

  // Función para generar el PDF de gastos
  const generarPdfGastos = async (filtros, logoBase64, deliveryContext) => {
    try {
      const targetWindow = deliveryContext?.targetWindow ?? reservePdfTarget()
      const { gastos, totalMontoGastos } = await getAllGastosForPDF(filtros);
      
      // Transformar datos para el PDF (aplanar descripciones)
      const gastosParaPdf = gastos.map((g) => ({
        id: g.id,
        fecha: new Date(g.fecha).toLocaleDateString("es-AR"),
        montoTotal: g.montoTotal,
        proveedor: g.entidad?.descripcion || "Sin proveedor",
        descripcion: g.descripcion || "",
        categoria: g.subCategoria?.categoria?.descripcion || "",
        subcategoria: g.subCategoria?.descripcion || "",
      }));
      
      generarPdfTablaGastos({ 
        gastos: gastosParaPdf, 
        filtros, 
        totalMontoGastos, 
        logoBase64,
        deliveryContext: { targetWindow },
      });
    } catch (error) {
      console.error("Error al generar PDF de gastos:", error);
      throw error;
    }
  };

  // Obtener todas las recetas con filtros actuales para PDF (sin paginación)
  const getAllRecetasForPDF = async (filtros) => {
    const idReceta = filtros?.idReceta ?? null;
    const idMateriaPrima = filtros?.idMateriaPrima ?? null;
    const idDestino = filtros?.idDestino ?? null;
    const rawDesde = filtros?.fechaViajeDesde ?? filtros?.fechaCreacionDesde ?? null;
    const rawHasta = filtros?.fechaViajeHasta ?? filtros?.fechaCreacionHasta ?? null;
    const rawInicio = filtros?.fechaInicio ?? null;
    const fechaViajeDesde = rawDesde?.toDate?.() ?? rawDesde;
    const fechaViajeHasta = rawHasta?.toDate?.() ?? rawHasta;
    const fechaInicio = rawInicio?.toDate?.() ?? rawInicio;
    let cerrado = null;
    if (filtros?.cerrado === true) cerrado = true;
    else if (filtros?.cerrado === false) cerrado = false;

    const cancelado = filtros?.cancelado ?? null;

    const response = await getTablaRecetaDatos(
      fechaViajeDesde,
      fechaViajeHasta,
      idReceta,
      idMateriaPrima,
      idDestino,
      1,
      99999,
      null,
      null,
      fechaInicio,
      cerrado,
      cancelado,
      true,
      "fechaInicio",
      "desc"
    );

    const recetasData = response?.data ?? response ?? [];
    const mapReceta = (receta) => {
      const idPaq = receta.idPaquete ?? receta.id;
      return {
        id: receta.id,
        idPaquete: idPaq,
        codigoProductoTerminado: receta.codigoProductoTerminado ?? "Sin código",
        destino: receta.ubicacion?.descripcion ?? receta.destino ?? "Sin destino",
        butacas: Number(receta.butacas ?? receta.inventario ?? 0) || 0,
        fechaInicio: receta.fechaInicio ? dayjs(receta.fechaInicio).format("DD/MM/YYYY") : "N/A",
        fechaCreacion: receta.createdAt ? dayjs(receta.createdAt).format("DD/MM/YYYY") : "N/A",
        observaciones: receta.observaciones ?? "",
        vendedor: receta.vendedor ?? null,
        monto: receta.monto ?? 0,
        totalIngredientes: 0,
        pasajeros: 0,
      };
    };
    const recetas = recetasData.map(mapReceta);
    const idPaquetes = recetasData.map((r) => r.id ?? r.idPaquete).filter(Boolean);
    if (idPaquetes.length > 0) {
      try {
        const { financieros } = await getTablaRecetaFinancieros(idPaquetes);
        recetas.forEach((r) => {
          const fin = financieros[r.id] ?? financieros[r.idPaquete];
          if (fin) {
            r.pasajeros = Number(fin.pasajeros ?? 0);
            r.totalIngredientes = Number(fin.cantidadServicios ?? 0);
            r.monto = r.monto ?? fin.precioPaquete;
            r.cantidadVendedoresBom = Number(fin.cantidadVendedores ?? 0);
            r.primerVendedorBom = fin.primerVendedorBom ?? null;
            r.vendedoresBomNombres = Array.isArray(fin.vendedoresBomNombres) ? fin.vendedoresBomNombres : [];
          }
        });
      } catch (err) {
        console.error("Error al cargar financieros para PDF recetas:", err);
      }
    }
    return { recetas };
  };

  const generarPdfRecetas = async (filtros, logoBase64, usuario, deliveryContext) => {
    try {
      const targetWindow = deliveryContext?.targetWindow ?? reservePdfTarget()
      const { recetas } = await getAllRecetasForPDF(filtros);
      const partes = [];
      if (filtros?.receta?.descripcion || filtros?.receta?.label) {
        partes.push(`Grupo: ${filtros.receta.descripcion || filtros.receta.label}`);
      }
      if (filtros?.destino?.descripcion || filtros?.destino?.label) {
        partes.push(`Destino: ${filtros.destino.descripcion || filtros.destino.label}`);
      }
      if (filtros?.fechaViajeDesde || filtros?.fechaViajeHasta || filtros?.fechaCreacionDesde || filtros?.fechaCreacionHasta) {
        const rawDesde = filtros?.fechaViajeDesde ?? filtros?.fechaCreacionDesde;
        const rawHasta = filtros?.fechaViajeHasta ?? filtros?.fechaCreacionHasta;
        const desde = rawDesde ? dayjs(rawDesde).format("DD/MM/YYYY") : "N/A";
        const hasta = rawHasta ? dayjs(rawHasta).format("DD/MM/YYYY") : "N/A";
        partes.push(`Fechas viaje: ${desde} - ${hasta}`);
      }
      if (filtros?.fechaInicio) {
        partes.push(`Fecha viaje: ${dayjs(filtros.fechaInicio).format("DD/MM/YYYY")}`);
      }
      if (filtros?.cerrado === true) partes.push("Estado: Cerrado");
      else if (filtros?.cerrado === false) partes.push("Estado: Abierto");
      const filtrosTexto = partes.length ? partes.join(" | ") : "Sin filtros aplicados";
      generarPdfTablaReceta({ recetas, filtros: filtrosTexto, logoBase64, usuario: usuario || "Usuario", deliveryContext: { targetWindow } });
    } catch (error) {
      console.error("Error al generar PDF de recetas:", error);
      throw error;
    }
  };

  const getSubCategoriaTransaccionByCategoria = async (
    idSubCategoria,
    idEntidad,
  ) => {
    try {
      const url =
        `${serverURL}/transaccionAPI/getSubCategoriaTransaccionByCategoria/${idSubCategoria}` +
        (idEntidad ? `?idEntidad=${idEntidad}` : "");
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Error fetching SubCat by Categoria:", error);
      return null;
    }
  };

  const postSubCategoriaTransaccion = async (
    descripcionSubCategoriaTransaccion,
    idCategoriaTransaccion,
  ) => {
    try {
      await axios.post(
        serverURL + "/transaccionAPI/postSubCategoriaTransaccion",
        {
          descripcion: descripcionSubCategoriaTransaccion,
          idCategoriaTransaccion: idCategoriaTransaccion,
        },
      );
      getSubCategoriaTransaccion();
    } catch (error) {
      console.error("Error creating SubCat:", error);
      throw error;
    }
  };

  const updateSubCategoriaTransaccion = async (id, descripcion, idCategoriaTransaccion) => {
    try {
      await axios.put(serverURL + `/transaccionAPI/updateSubCategoriaTransaccion/${id}`, {
        descripcion,
        idCategoriaTransaccion,
      });
      getSubCategoriaTransaccion();
    } catch (error) {
      console.error("Error updating SubCat:", error);
      throw error;
    }
  };

  const deleteSubCategoriaTransaccion = async (id) => {
    try {
      await axios.delete(serverURL + `/transaccionAPI/deleteSubCategoriaTransaccion/${id}`);
      getSubCategoriaTransaccion();
    } catch (error) {
      console.error("Error deleting SubCat:", error);
      throw error;
    }
  };

  // TRANSACCION TIPO TRANSACCION ***********************************************************************
  const [tipoTransaccion, arrayTipoTransaccion] = useState([]);

  const getTipoTransaccion = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTipoTransaccion",
      );
      arrayTipoTransaccion(response.data);
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const postTipoTransaccion = async (descripcionTipoTransaccion, verEnCaja, verEnTransaccion, verEnColumna) => {
    try {
      await axios.post(serverURL + "/transaccionAPI/postTipoTransaccion", {
        descripcion: descripcionTipoTransaccion,
        verEnCaja: verEnCaja,
        verEnTransaccion: verEnTransaccion,
        verEnColumna: verEnColumna,
      });
      getTipoTransaccion();
    } catch (error) {
      console.error("Error creating tipo transaccion:", error);
    }
  };

  const updateTipoTransaccion = async (id, datos) => {
    try {
      const response = await axios.put(
        serverURL + `/transaccionAPI/updateTipoTransaccion/${id}`,
        datos
      );
      arrayTipoTransaccion(response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating tipo transaccion:", error);
      throw error;
    }
  };

  const deleteTipoTransaccion = async (id) => {
    try {
      const response = await axios.delete(
        serverURL + `/transaccionAPI/deleteTipoTransaccion/${id}`
      );
      arrayTipoTransaccion(response.data.data);
      return response.data;
    } catch (error) {
      console.error("Error deleting tipo transaccion:", error);
      throw error;
    }
  };

  // TRANSACCION TRANSACCION PAGO ***********************************************************************
  const getTransaccionesPagoFilter = async (
    startDate,
    page,
    idTipoMedioPago,
    idMedioPago,
    zona,
    idUbicacion,
    idUsuario,
    sortField = null,
    sortOrder = null,
  ) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTransaccionesPagoFilter",
        {
          params: {
            startDate,
            page,
            idTipoMedioPago,
            idMedioPago,
            zona,
            idUbicacion,
            idUsuario,
            sortField,
            sortOrder,
          },
        },
      );

      return response.data;
    } catch (error) {}
  };

  const getAndPostCajaDatos = async (startDate, zona, idUbicacion, createOrUpdate) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getAndPostCajaDatos",
        {
          params: {
            startDate,
            zona,
            idUbicacion,
            createOrUpdate,
          },
        },
      );

      return response.data;
    } catch (error) {}
  };

  const getCajaAndRecalcularCaja = async (fecha, zona, idUbicacion, createOrUpdate) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getAndPostCajaDatos",
        {
          params: {
            startDate: fecha,
            zona,
            idUbicacion,
            createOrUpdate,
          },
        },
      );

      return response.data;
    } catch (error) {}
  };

  // TEST 8N8 ***********************************************************************

  const resumenVentasN8N = async (fecha) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/resumenVentasN8N",
        {
          fecha,
        },
      );

      return response.data;
    } catch (error) {}
  };

  // TRANSACCION TRANSACCION ITEM ***********************************************************************
  const [transaccionItem, arrayTransaccionItem] = useState([]);

  const getTransaccionItem = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTransaccionItem",
      );
      arrayTransaccionItem(response.data);
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const getTransaccionItemByTipoTransaccion = async (params) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTransaccionItemByTipoTransaccion",
        {
          params,
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const getClientePaqueteDetalle = async (params) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/clientePaqueteDetalle",
        {
          params,
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo cliente/paquete:", error);
      throw error;
    }
  };

  const getClientePaqueteMovimientos = async (params) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/clientePaqueteDetalleMovimientos",
        {
          params,
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo movimientos cliente/grupo:", error);
      throw error;
    }
  };

  // NUEVO: para gráficas, esto utiliza el filtro de ventas pero no tiene en cuenta el paginado
  const getTransaccionItemByTipoTransaccionAllData = async (params) => {
    try {
      const response = await axios.get(
        serverURL +
          "/transaccionAPI/getTransaccionItemByTipoTransaccionAllData",
        {
          params,
        },
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error al obtener TODOS los detalles de transacciones para gráficas:",
        error,
      );
      throw error;
    }
  };

  const getParametrosGlobales = async (parametros) => {
    try {
      const response = await axios.post(
        serverURL + "/adminAPI/getParametrosGlobales",
        { parametros },
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const getParametrosGlobalesMenu = async () => {
    try {
      const response = await axios.get(
        serverURL + "/adminAPI/getParametrosGlobalesMenu"
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching parámetros globales del menú:", error);
      throw error;
    }
  };

  const updateParametroGlobal = async (nombreParametro, valorParametro) => {
    try {
      const response = await axios.put(
        serverURL + "/adminAPI/updateParametroGlobal",
        { nombreParametro, valorParametro }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating parámetro global:", error);
      throw error;
    }
  };

  const exportarPLUsBalanza = async (ubicacion) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/exportarPLUsBalanza?ubicacion=${ubicacion}`,
        {
          responseType: "blob", // Importante para descargar archivos
        },
      );

      // Crear un enlace temporal para descargar el archivo
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // Extraer el nombre del archivo del header Content-Disposition
      const contentDisposition = response.headers["content-disposition"];
      let filename = "plus_balanza.csv";
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      // Limpiar
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return { success: true, message: "Archivo exportado correctamente" };
    } catch (error) {
      console.error("Error al exportar PLUs de balanza:", error);
      throw error;
    }
  };

  const postTransaccionItem = async (
    idTransaccion,
    idItem,
    cantidad,
    precio,
    porcentajeDescuento,
  ) => {
    try {
      const payload = {
        idTransaccion: idTransaccion,
        idItem: idItem,
        cantidad: cantidad,
        precio: precio,
        montoTotal: precio * cantidad * (1 - (porcentajeDescuento || 0) / 100),
        porcentajeDescuento: porcentajeDescuento,
      };
      
      const response = await axios.post(serverURL + "/transaccionAPI/postTransaccionItem", payload);
      return response;
    } catch (error) {
      console.error("Error creando TransaccionItem:", error);
      throw error;
    }
  };

  const postTransaccionItemDevolucion = async (
    idTransaccion,
    idItem,
    cantidad,
    precio,
    porcentajeDescuento,
    signo,
  ) => {
    try {
      // Calcular el monto total basado en el signo
      let montoTotal;
      if (signo === "-") {
        montoTotal = precio * cantidad * (1 - (porcentajeDescuento || 0) / 100);
      } else {
        montoTotal = precio * cantidad;
      }

      // Hacer la solicitud POST con el objeto correctamente estructurado
      await axios.post(
        serverURL + "/transaccionAPI/postTransaccionItemDevolucion",
        {
          idTransaccion: idTransaccion,
          idItem: idItem,
          cantidad: cantidad,
          precio: precio,
          montoTotal: montoTotal, // Incluye el monto calculado aquí
          porcentajeDescuento: porcentajeDescuento || 0, // Manejar caso undefined
          signo: signo,
        },
      );
    } catch (error) {
      console.error("Error creating tipo transaccion:", error);
    }
  };

  // TRANSACCION TRANSACCION ***********************************************************************
  const [transaccion, arrayTransaccion] = useState([]);

  const getTransaccion = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTransaccion",
      );

      // Accede a la propiedad `data` de la respuesta
      const transacciones = response.data; // Cambiar aquí para acceder a `data`

      const formattedTransacciones = transacciones.map((transaccion) => ({
        ...transaccion,
        createdAt: transaccion.createdAt
          ? format(new Date(transaccion.createdAt), "dd/MM/yyyy")
          : "",
      }));

      // Aquí asumo que `arrayTransaccion` es un setter para el estado
      arrayTransaccion(formattedTransacciones); // Cambiar aquí también
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const updateDeleteTransaccion = async (id) => {
    try {
      await axios.put(
        serverURL + `/transaccionAPI/updateDeleteTransaccion/${id}`,
      );
    } catch (error) {
      console.error("Error al eliminar transaccion:", error);
    }
  };

  const revertirGasto = async (idTransaccion) => {
    const response = await axios.post(
      serverURL + "/transaccionAPI/revertirGasto",
      { idTransaccion }
    );
    return response;
  };

  const [transaccionFilter, setTransaccionFilter] = useState([]);

  const getTransaccionFilter = async (idTransaccion) => {
    try {
      // console.log(idTransaccion);
      const response = await axios.get(
        serverURL + `/transaccionAPI/getTransaccionFilter/${idTransaccion}`,
      );

      // console.log(response.data);
      return response.data;

      // Accede a la propiedad `data` de la respuesta

      /*const formattedTransacciones = transacciones.map((transaccion) => ({
        ...transaccion,
        createdAt: transaccion.createdAt
          ? format(new Date(transaccion.createdAt), "dd/MM/yyyy")
          : "",
      }));*/
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const [transaccionTransformed, arrayTransaccionTransformed] = useState([]);

  const getTransaccionTransformed = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTransaccionTransformed",
      );

      // Accede a la propiedad `data` de la respuesta
      const transacciones = response.data; // Cambiar aquí para acceder a `data`

      arrayTransaccionTransformed(transacciones); // Cambiar aquí también
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  // Nueva función para obtener TODOS los datos de ventas sin paginado (para gráficas)
  const getTransaccionTransformedVentasAllData = async (
    tipoTransaccion,
    fecha,
    formattedDate2,
    dniCliente = "",
    selectedUbicacion = "",
    valorMin = "",
    valorMax = "",
    mostrarEliminados = false,
    idTransaccionSearch = "",
    traerDevolucion = "",
    buscarCAE = "",
    tipoTransaccionFiltro = "",
    canalEntidad = "",
  ) => {
    try {
      const params = new URLSearchParams({
        fecha,
        formattedDate2,
        dniCliente,
        selectedUbicacion,
        valorMin,
        valorMax,
        mostrarEliminados: mostrarEliminados.toString(),
        idTransaccionSearch,
        traerDevolucion,
        buscarCAE,
        tipoTransaccionFiltro,
        canalEntidad,
      });

      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTransaccionTransformedVentasAllData/${tipoTransaccion}?${params}`,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error al obtener TODOS los datos de ventas para gráficas:",
        error,
      );
      throw error;
    }
  };

  // Nueva función para obtener TODOS los datos de presupuestos sin paginado (para gráficas)
  const getTransaccionTransformedPresupuestosAllData = async (
    tipoTransaccion,
    fecha,
    formattedDate2,
    dniCliente = "",
    selectedUbicacion = "",
    valorMin = "",
    valorMax = "",
    mostrarEliminados = false,
    idTransaccionSearch = "",
    traerDevolucion = "",
    buscarCAE = "",
    tipoTransaccionFiltro = "",
    canalEntidad = "",
  ) => {
    try {
      const params = new URLSearchParams({
        fecha,
        formattedDate2,
        dniCliente,
        selectedUbicacion,
        valorMin,
        valorMax,
        mostrarEliminados: mostrarEliminados.toString(),
        idTransaccionSearch,
        traerDevolucion,
        buscarCAE,
        tipoTransaccionFiltro,
        canalEntidad,
      });

      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTransaccionTransformedPresupuestosAllData/${tipoTransaccion}?${params}`,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error al obtener TODOS los datos de presupuestos para gráficas:",
        error,
      );
      throw error;
    }
  };

  const getTransaccionMontoTotalByTipoTransaccion = async (
    idTipoTransaccion,
  ) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTransaccionMontoTotalByTipoTransaccion/${idTipoTransaccion}`,
      );

      return response.data; // Cambiar aquí para acceder a `data`
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const getTransaccionTransformedVentas = async (
    tipoTransaccion,
    date,
    page = 1,
    limit = 100,
    options = {},
    formattedDate2,
    dniCliente,
    selectedUbicacion,
    valorMin,
    valorMax,
    mostrarEliminados,
    idTransaccionSearch,
    traerDevolucion,
    buscarCAE,
    tipoTransaccionFiltro,
    canalEntidad,
    soloFacturadas = false,
    idTipoMedioPago = null,
    idMedioPago = null,
    sortField = null,
    sortOrder = null,
  ) => {
    try {
// console.log("Frontend - soloFacturadas:", soloFacturadas, "type:", typeof soloFacturadas);

      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTransaccionTransformedVentas/${tipoTransaccion}`,
        {
          params: {
            fecha: date,
            page: page,
            limit: limit,
            formattedDate2: formattedDate2,
            dniCliente: dniCliente,
            selectedUbicacion: selectedUbicacion,
            valorMin: valorMin,
            valorMax: valorMax,
            mostrarEliminados: mostrarEliminados,
            idTransaccionSearch: idTransaccionSearch,
            traerDevolucion: traerDevolucion,
            buscarCAE: buscarCAE,
            tipoTransaccionFiltro: tipoTransaccionFiltro,
            canalEntidad: canalEntidad,
            soloFacturadas: soloFacturadas,
            idTipoMedioPago: idTipoMedioPago,
            idMedioPago: idMedioPago,
            sortField: sortField,
            sortOrder: sortOrder,
          },
          signal: options.signal,
        },
      );

      if (!response || response.status < 200 || response.status >= 300) {
        throw new Error("Network response was not ok");
      }

      // console.log(response.data);

      return response.data; // API devuelve { total, totalPages, currentPage, data }
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const getTransaccionTransformedCompras = async (
    tipoTransaccion,
    startDate,
    endDate,
    page,
    limit,
    options,
    idProveedor,
    idUbicacion,
    valorMin,
    valorMax,
    idEstado,
    mostrarDeletes,
    idTransaccionSearch,
  ) => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("startDate", startDate);
      queryParams.append("endDate", endDate);
      queryParams.append("page", page.toString());
      queryParams.append("limit", limit.toString());
      if (idProveedor) queryParams.append("idProveedor", idProveedor);
      if (idUbicacion) queryParams.append("idUbicacion", idUbicacion);
      if (idEstado != null && idEstado !== "")
        queryParams.append("idEstado", idEstado);

      if (Number(valorMin) !== 0 || Number(valorMax) !== 0) {
        queryParams.append("valorMin", valorMin.toString());
        queryParams.append("valorMax", valorMax.toString());
      }
      queryParams.append("mostrarDeletes", mostrarDeletes);
      queryParams.append("idTransaccionSearch", idTransaccionSearch);

      const response = await axios.get(
        serverURL +
          `/transaccionAPI/getTransaccionTransformedCompras/${tipoTransaccion}?${queryParams.toString()}`,
        options,
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const getTransaccionTransformedPresupuesto = async (
    tipoTransaccion,
    date,
    page = 1,
    limit = 100,
    options = {},
    formattedDate2,
    dniCliente,
    selectedUbicacion,
    valorMin,
    valorMax,
    mostrarEliminados,
    idTransaccionSearch,
    traerDevolucion,
    buscarCAE,
    tipoTransaccionFiltro,
    canalEntidad,
  ) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTransaccionTransformedPresupuesto/${tipoTransaccion}`,
        {
          params: {
            fecha: date,
            page: page,
            limit: limit,
            formattedDate2: formattedDate2,
            dniCliente: dniCliente,
            selectedUbicacion: selectedUbicacion,
            valorMin: valorMin,
            valorMax: valorMax,
            mostrarEliminados: mostrarEliminados,
            idTransaccionSearch: idTransaccionSearch,
            traerDevolucion: traerDevolucion,
            buscarCAE: buscarCAE,
            tipoTransaccionFiltro: tipoTransaccionFiltro,
            canalEntidad: canalEntidad,
          },
          signal: options.signal,
        },
      );
      return response.data;
    } catch (error) {
      if (options.signal?.aborted) {
        console.warn("Solicitud abortada");
      } else {
        console.error("Error fetching presupuestos:", error);
      }
      throw error;
    }
  };

  const postTransaccion = async (
    montoTotal,
    idTipoTransaccion,
    idEntidad,
    idSubCategoriaTransaccion,
    descripcion,
    idUsuario,
    idUbicacion,
    idNegocio,
    montoDescuento,
    porcentajeDescuento,
    transaccionAsociada = null,
    fecha = null,
    afectaCuentaCorriente = false,
    clientOS = null, // Nuevo parámetro para el SO del cliente
    viaja = true, // Default: true según el modelo
    liberado = false, // Default: false según el modelo
    cuotas = null, // Default: null según el modelo
    operacionParaCuentaCorriente = null, // 'operacionCC' | 'adelantoCC' | 'operacionCaja' | null
    archivosAdjunto = null,
  ) => {
    try {
      const fechaTransaccion = fecha ? fecha : new Date();
      
      // Si no se proporciona clientOS, intentar detectarlo
      let detectedOS = clientOS;
      if (!detectedOS) {
        try {
          // Detección simple inline si no se importó la utilidad
          const platform = navigator.platform.toLowerCase();
          if (platform.includes('win')) detectedOS = 'windows';
          else if (platform.includes('mac')) detectedOS = 'macos';
          else if (platform.includes('linux')) detectedOS = 'linux';
          else detectedOS = 'unknown';
        } catch (e) {
          detectedOS = 'unknown';
        }
      }
      
      const transaccionResponse = await axios.post(
        serverURL + "/transaccionAPI/postTransaccion",
        {
          fecha: fechaTransaccion, // Fecha hardcodeada,  *HARDCODED* 
          montoTotal: montoTotal,
          idTipoTransaccion: idTipoTransaccion,
          idEntidad: idEntidad,
          idCategorizacion: idSubCategoriaTransaccion,
          descripcion: descripcion,
          fechaHoraCreacion: new Date(),
          idUsuario: idUsuario,
          idUbicacion: idUbicacion,
          idNegocio: idNegocio,
          transaccionAsociada: transaccionAsociada,
          montoDescuento: montoDescuento, // Enviar valor de descuento total
          porcentajeDescuento: porcentajeDescuento, // Enviar porcentaje de descuento
          afectaCuentaCorriente: afectaCuentaCorriente, // Enviar si afecta cuenta corriente
          clientOS: detectedOS, // Enviar SO del cliente para instrucciones de impresión
          viaja: viaja, // Enviar si viaja
          liberado: liberado, // Enviar si está liberado
          cuotas: cuotas, // Enviar cantidad de cuotas
          operacionParaCuentaCorriente: operacionParaCuentaCorriente, // Tipo de operación CC
          ...(archivosAdjunto !== null ? { archivosAdjunto } : {}),
        },
      );
      return transaccionResponse;
    } catch (error) {
      console.error("Error creating tipo transaccion:", error);
    }
  };

  // Crear transferencia interna (crea 2 transacciones vinculadas)
  const postTransferenciaInterna = async (
    montoTotal,
    idUbicacionOrigen,
    idUbicacionDestino,
    idMedioDePago,
    descripcion,
    idUsuario,
    idNegocio,
    fecha = null,
  ) => {
    try {
      const fechaTransaccion = fecha ? fecha : new Date();
      
      // 1. Crear transacción ORIGEN (Egreso - Tipo 9)
      const transaccionOrigenResponse = await postTransaccion(
        montoTotal,
        9, // Tipo 9: Transferencia Interna Origen
        null, // idEntidad (no aplica)
        null, // idSubCategoriaTransaccion
        descripcion,
        idUsuario,
        idUbicacionOrigen,
        idNegocio,
        0, // montoDescuento
        0, // porcentajeDescuento
        null, // transaccionAsociada (se actualiza después)
        fechaTransaccion,
        false, // afectaCuentaCorriente
        null, // clientOS
        true, // viaja
        false, // liberado
        null, // cuotas
        null, // operacionParaCuentaCorriente
      );

      const idTransaccionOrigen = transaccionOrigenResponse.data.id;

      // 2. Crear transacción DESTINO (Ingreso - Tipo 10)
      const transaccionDestinoResponse = await postTransaccion(
        montoTotal,
        10, // Tipo 10: Transferencia Interna Destino
        null, // idEntidad (no aplica)
        null, // idSubCategoriaTransaccion
        descripcion,
        idUsuario,
        idUbicacionDestino,
        idNegocio,
        0, // montoDescuento
        0, // porcentajeDescuento
        idTransaccionOrigen, // transaccionAsociada (apunta al origen)
        fechaTransaccion,
        false, // afectaCuentaCorriente
        null, // clientOS
        true, // viaja
        false, // liberado
        null, // cuotas
        null, // operacionParaCuentaCorriente
      );

      const idTransaccionDestino = transaccionDestinoResponse.data.id;

      // 3. Actualizar transacción ORIGEN para que apunte al DESTINO (vinculación bidireccional)
      await putTransaccion(
        idTransaccionOrigen,
        montoTotal,
        9, // idTipoTransaccion
        null, // idEntidad
        null, // idCategorizacion
        descripcion,
        idUsuario,
        idUbicacionOrigen,
        idNegocio,
        0, // montoDescuento
        0, // porcentajeDescuento
        null, // viaja
        null, // liberado
        null, // cuotas
        idTransaccionDestino, // transaccionAsociada (ahora apunta al destino)
        fechaTransaccion, // fecha
      );

      // 4. Crear pagos para ambas transacciones
      const pagoOrigen = await postCrearPago(1, 1, idMedioDePago, montoTotal);
      await postTransaccionPago(idTransaccionOrigen, pagoOrigen.data.id);

      const pagoDestino = await postCrearPago(1, 1, idMedioDePago, montoTotal);
      await postTransaccionPago(idTransaccionDestino, pagoDestino.data.id);

      return {
        transaccionOrigen: transaccionOrigenResponse.data,
        transaccionDestino: transaccionDestinoResponse.data,
      };
    } catch (error) {
      console.error("Error creando transferencia interna:", error);
      throw error;
    }
  };

  // Obtener clientes/pasajeros asociados a un grupo y destino
  const getClientesPorGrupoYDestino = async (idItem, idUbicacion) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getClientesPorGrupoYDestino/${idItem}/${idUbicacion}`
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo clientes por grupo y destino:", error);
      return [];
    }
  };

  // Contar pasajeros liberados por grupo (item) y destino (ubicación)
  const contarPasajerosLiberados = async (idItem, idUbicacion) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/contarPasajerosLiberados/${idItem}/${idUbicacion}`
      );
      return response.data?.count || 0;
    } catch (error) {
      console.error("Error contando pasajeros liberados:", error);
      return 0;
    }
  };

  // Crear cuotas en cuenta corriente para un pasajero (ACTUALIZADO - usa postPlanCuotaPasajero)
  const postCuentaCorrienteCuotas = async (idEntidad, idItem, idUbicacion, montoTotal, cuotas) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/postPlanCuotaPasajero`,
        {
          idEntidad,
          idItem,
          idUbicacion,
          montoTotal,
          cuotas,
          override: false
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error creando cuotas en cuenta corriente:", error);
      throw error;
    }
  };

  const postCuentaCorrienteCuotasDetalle = async (payload) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/postPlanCuotaPasajero`,
        {
          ...payload,
          override: payload.override !== undefined ? payload.override : true
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error creando cuotas detalladas en cuenta corriente:", error);
      throw error;
    }
  };

  // Obtener cuotas de cuenta corriente
  const getCuentaCorrienteCuotas = async (idEntidad, idItem, idUbicacion) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getPlanCuotaPasajero/${idEntidad}/${idItem}/${idUbicacion}`
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo cuotas de cuenta corriente:", error);
      return { cuotas: [], total: 0, pagadas: 0, pendientes: 0, liberado: false };
    }
  };

  const getPlanCuotaPasajeroByIdEntidad = async (idEntidad) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getPlanCuotaPasajeroByIdEntidad/${idEntidad}`
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo cuotas por entidad:", error);
      return [];
    }
  };

  const getPlanCuotaPasajeroByTransaccionIds = async (ids = []) => {
    const idsParam = (Array.isArray(ids) ? ids : [])
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id))
      .join(",");
    if (!idsParam) return [];
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getPlanCuotaPasajeroByTransaccionIds`,
        { params: { ids: idsParam } }
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo cuotas por transacción:", error);
      return [];
    }
  };

  const getPlanCuotas = async (idItem, idUbicacion) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/cuotaPlan/${idItem}/${idUbicacion}`
      );
      return response.data.plan;
    } catch (error) {
      console.error("Error obteniendo plan de cuotas:", error);
      throw error;
    }
  };

  const postPlanCuotas = async (payload) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/cuotaPlan`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error guardando plan de cuotas:", error);
      throw error;
    }
  };

  const aplicarPlanCuotas = async (idPlan, pasajeros) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/cuotaPlan/${idPlan}/aplicar`,
        { pasajeros }
      );
      return response.data;
    } catch (error) {
      console.error("Error aplicando plan de cuotas:", error);
      throw error;
    }
  };

  // Actualizar idTransaccion de una cuota en cuenta corriente
  const updateCuentaCorrienteCuota = async (cuotaNro, idEntidad, idItem, idUbicacion, idTransaccion) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/updatePlanCuotaPasajero`,
        { cuotaNro, idEntidad, idItem, idUbicacion, idTransaccion }
      );
      return response.data;
    } catch (error) {
      console.error("Error actualizando cuota de cuenta corriente:", error);
      throw error;
    }
  };

  // Revertir pago de cuota
  const revertirPagoCuota = async (cuotaNro, idEntidad, idItem, idUbicacion, mediosDePago, montoDevolver) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/revertirPagoCuota`,
        { cuotaNro, idEntidad, idItem, idUbicacion, mediosDePago, montoDevolver }
      );
      return response.data;
    } catch (error) {
      console.error("Error al revertir pago de cuota:", error);
      throw error;
    }
  };

  const postTransaccionDevolucion = async (
    montoTotal,
    idTipoTransaccion,
    idEntidad,
    idSubCategoriaTransaccion,
    descripcion,
    idUsuario,
    idUbicacion,
    idNegocio,
    transaccionAsociada,
    montoDescuento,
    porcentajeDescuento,
  ) => {
    // console.log(
    //   "Datos enviados:",
    //   "montoTotal " + montoTotal,
    //   "idTipoTransaccion " + idTipoTransaccion,
    //   "idEntidad " + idEntidad,
    //   "idSubCategoriaTransaccion " + idSubCategoriaTransaccion,
    //   "descripcion " + descripcion,
    //   "idUsuario " + idUsuario,
    //   "idUbicacion " + idUbicacion,
    //   "idNegocio " + idNegocio
    // );

    try {
      const transaccionResponse = await axios.post(
        serverURL + "/transaccionAPI/postTransaccionDevolucion",
        {
          fecha: new Date(), // Fecha hardcodeada, *HARDCODED* 
          montoTotal: montoTotal,
          idTipoTransaccion: idTipoTransaccion,
          idEntidad: idEntidad,
          idCategorizacion: idSubCategoriaTransaccion,
          descripcion: descripcion,
          fechaHoraCreacion: new Date(),
          idUsuario: idUsuario,
          idUbicacion: idUbicacion,
          idNegocio: idNegocio,
          transaccionAsociada: transaccionAsociada,
          montoDescuento: montoDescuento, // Enviar valor de descuento total
          porcentajeDescuento: porcentajeDescuento, // Enviar porcentaje de descuento
        },
      );
      return transaccionResponse;
    } catch (error) {
      console.error("Error creating tipo transaccion:", error);
    }
  };

  const validarDevolucionCanje = async (
    idTransaccionOriginal,
    itemsDevolucion,
  ) => {
    try {
      const response = await axios.post(
        serverURL + "/transaccionAPI/validarDevolucionCanje",
        {
          idTransaccionOriginal: idTransaccionOriginal,
          itemsDevolucion: itemsDevolucion,
        },
      );
      return response.data;
    } catch (error) {
      // Si es un error 400 con datos de validación, retornar esos datos
      if (
        error.response?.status === 400 &&
        error.response?.data?.valido !== undefined
      ) {
        return error.response.data;
      }

      // Para otros errores, lanzar la excepción
      console.error("Error en validación de devolución:", error);
      throw error;
    }
  };

  const postTransaccionPago = async (idTransaccion, idPago) => {
    try {
      const transaccionPagoResponse = await axios.post(
        serverURL + "/transaccionAPI/postTransaccionPago",
        {
          idTransaccion: idTransaccion,
          idPago: idPago,
        },
      );
      return transaccionPagoResponse;
    } catch (error) {
      console.error("Error creating transaccion pago:", error);
    }
  };

  const postCrearPago = async (
    idMoneda,
    cotizacion,
    idMedioDePago,
    montoTotal,
  ) => {
    try {
      const transaccionCrearPago = await axios.post(
        serverURL + "/transaccionAPI/postCrearPago",
        {
          idMoneda: idMoneda,
          cotizacion: cotizacion,
          idMedioDePago: idMedioDePago,
          montoTotal: montoTotal,
        },
      );
      return transaccionCrearPago;
    } catch (error) {
      console.error("Error creating transaccion pago:", error);
    }
  };

  const [estados, arrayEstados] = useState([]); //Define el estado ubicaciones con su función setUbicaciones. Inicialmente es un array vacío y contendrá las ubicaciones que

  const getEstadoCompra = async () => {
    try {
      const response = await axios.get(
        serverURL + `/transaccionAPI/getEstadoCompra`,
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const postTransaccionCompraEstado = async (idTransaccion, idEstado) => {
    try {
      const transaccionCrearPago = await axios.post(
        serverURL + "/transaccionAPI/postTransaccionCompraEstado",
        {
          idTransaccion,
          idEstado,
        },
      );
      return transaccionCrearPago;
    } catch (error) {
      console.error("Error creating transaccion pago:", error);
    }
  };

  const postTransaccionCompraItem = async (
    fecha,
    idTransaccion,
    idItem,
    cantidadRecibida,
  ) => {
    try {
      const transaccionCrearPago = await axios.post(
        serverURL + "/transaccionAPI/postTransaccionCompraItem",
        {
          fecha,
          idTransaccion,
          idItem,
          cantidadRecibida,
        },
      );
      return transaccionCrearPago;
    } catch (error) {
      console.error("Error creating transaccion pago:", error);
    }
  };

  const updateTransaccionCompraEstado = async (idTransaccion, idEstado) => {
    try {
      const updateCompraEstado = await axios.put(
        serverURL + "/transaccionAPI/updateTransaccionCompraEstado",
        {
          idTransaccion, // ✅ este nombre sí lo reconoce el backend
          idEstado,
        },
      );
      return updateCompraEstado;
    } catch (error) {
      console.error("Error actualizando estado de compra:", error);
    }
  };

  const putTransaccion = async (
    idTransaccion,
    montoTotal,
    idTipoTransaccion,
    idEntidad,
    idCategorizacion,
    descripcion,
    idUsuario,
    idUbicacion,
    idNegocio,
    montoDescuento,
    porcentajeDescuento,
    viaja = null, // Opcional: si es null no se actualiza
    liberado = null, // Opcional: si es null no se actualiza
    cuotas = null, // Opcional: si es null no se actualiza
    transaccionAsociada = null, // Opcional: para transferencias internas
    fecha = null, // Opcional: para transferencias internas
  ) => {
    // console.log(
    //   "idTransaccion " + idTransaccion,
    //   "montoTotal " + montoTotal,
    //   "idTipoTransaccion " + idTipoTransaccion,
    //   "idEntidad " + idEntidad,
    //   "idSubCategoriaTransaccion " + idSubCategoriaTransaccion,
    //   "descripcion " + descripcion,
    //   "idUsuario " + idUsuario,
    //   "idUbicacion " + idUbicacion,
    //   "idNegocio " + idNegocio,
    //   "montoDescuento " + montoDescuento,
    //   "porcentajeDescuento " + porcentajeDescuento
    // );
    try {
      const updateData = {
        fecha: fecha ? fecha : new Date().toISOString(),
        montoTotal,
        idTipoTransaccion,
        idEntidad,
        idCategorizacion,
        descripcion,
        idUsuario,
        idUbicacion,
        idNegocio,
        montoDescuento,
        porcentajeDescuento,
      };

      // Solo agregar campos si no son null (para permitir actualización parcial)
      if (viaja !== null) updateData.viaja = viaja;
      if (liberado !== null) updateData.liberado = liberado;
      if (cuotas !== null) updateData.cuotas = cuotas;
      if (transaccionAsociada !== null) updateData.transaccionAsociada = transaccionAsociada;

      const transaccionResponse = await axios.put(
        `${serverURL}/transaccionAPI/putTransaccion/${idTransaccion}`,
        updateData,
      );
      return transaccionResponse;
    } catch (error) {
      console.error("Error updating transacción:", error);
    }
  };

  const getTransaccionItemByTransactionAndItem = async (
    idTransaccion,
    idItem,
  ) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTransaccionItemByTransactionAndItem/${idTransaccion}/${idItem}`,
      );
      return response.data; // Devuelve el transaccionItem encontrado
    } catch (error) {
      console.error("Error al obtener transaccionItem:", error);
      return null; // Retorna null si no se encuentra o hay un error
    }
  };

  const updateTransaccionPago = async (
    idTransaccion,
    idMedioDePago,
    montoTotal,
  ) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/updateTransaccionPago`,
        { idTransaccion, idMedioDePago, montoTotal },
      );
      return response.data; // Retorna los datos actualizados
    } catch (error) {
      console.error("Error al actualizar transaccionPago:", error);
    }
  };

  const deleteTransaccionPagoByTransaccion = async (idTransaccion) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/deleteTransaccionPago/${idTransaccion}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error al eliminar transaccionPago:", error);
    }
  };

  const deleteTransaccionPagoItem = async (idTransaccion, idPago) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/deleteTransaccionPago/${idTransaccion}/${idPago}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error al eliminar transaccionPago:", error);
    }
  };

  const updateTransaccionItem = async (idTransaccion, idItem, data) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/actualizarTransaccionExistente/${idTransaccion}/${idItem}`,
        data,
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar transaccionItem:", error);
    }
  };

  const [transaccionItemsPostDelete, setTransaccionItemsPostDelete] = useState(
    [],
  );

  // Función para eliminar un transaccionItem
  const deleteItem = async (idTransaccion, idItem) => {
    try {
      const response = await axios.delete(
        `${serverURL}/transaccionAPI/transaccionItemDelete/${idTransaccion}/${idItem}`,
      );

      // Actualizar la lista de transaccionItems después de eliminar
      setTransaccionItemsPostDelete((prevItems) =>
        prevItems.filter(
          (item) =>
            !(item.idTransaccion === idTransaccion && item.idItem === idItem),
        ),
      );

// console.log("TransaccionItem eliminado exitosamente:", response.data);
    } catch (error) {
      console.error("Error al eliminar transaccionItem:", error);
    }
  };

  // Función para obtener transaccionItems por idTransaccion
  const getTransaccionItemsByTransactionId = async (idTransaccion) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/transaccionItemsById/${idTransaccion}`,
      );
// console.log("TransaccionItems obtenidos exitosamente:", response.data);
      return response.data; // Retorna los ítems si existen
    } catch (error) {
      if (error.response && error.response.status === 404) {
// console.log("No se encontraron transaccionItems para esta transacción");
        return []; // Retorna un array vacío si no existen ítems
      } else {
        console.error("Error al obtener transaccionItems:", error);
        throw error; // Lanza el error para otros errores diferentes a 404
      }
    }
  };

  const deleteTransaccionItemNoLista = async (idTransaccion, idItems) => {
    try {
      await axios.delete(
        `${serverURL}/transaccionAPI/transaccionItemDelete/${idTransaccion}`,
        {
          data: { idItems },
        },
      );
// console.log("TransaccionItems eliminados exitosamente.");
    } catch (error) {
      console.error("Error eliminando transaccionItems:", error);
    }
  };

  const deleteTransaccionItem = async (idTransaccion, idItem) => {
    try {
      await axios.put(
        `${serverURL}/transaccionAPI/deleteTransaccionItem/${idTransaccion}/${idItem}`,
      );
    } catch (error) {
// console.log("Error eliminando deleteTransaccionItem:", error);
    }
  };
  const deleteTransaccionCompraItem = async (idTransaccion, idItem) => {
    try {
      await axios.put(
        `${serverURL}/transaccionAPI/deleteTransaccionCompraItem/${idTransaccion}/${idItem}`,
      );
    } catch (error) {
// console.log("Error eliminando transaccionCompraItem:", error);
    }
  };

  // Crear impuesto de item de transacción
  const postTransaccionImpuestoItem = async (
    idTransaccion,
    idItem,
    idImpuesto,
    porcentaje,
    montoTotal,
  ) => {
    try {
      await axios.post(
        serverURL + "/transaccionAPI/postTransaccionImpuestoItem",
        {
          idTransaccion: idTransaccion,
          idItem: idItem,
          idImpuesto: idImpuesto,
          porcentaje: porcentaje,
          montoTotal: montoTotal || null,
        },
      );
    } catch (error) {
      console.error("Error creating impuesto item transaccion:", error);
    }
  };

  // Actualizar impuesto de item de transacción
  const updateTransaccionImpuestoItem = async (idTransaccion, idItem, data) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/updateTransaccionImpuestoItem/${idTransaccion}/${idItem}`,
        data,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error al actualizar impuesto de item de transacción:",
        error,
      );
    }
  };

  // Obtener impuestos de items de una transacción
  const getTransaccionImpuestoItems = async (idTransaccion) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTransaccionImpuestoItems/${idTransaccion}`,
      );
// console.log(        "Impuestos de items de transacción obtenidos exitosamente:",        response.data,      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
// console.log(          "No se encontraron impuestos de items para esta transacción",        );
        return [];
      } else {
        console.error(
          "Error al obtener impuestos de items de transacción:",
          error,
        );
        throw error;
      }
    }
  };

  const fetchFilteredTransactions = async (
    startDate,
    endDate,
    medioDePagoId,
    tipoMedioDePagoId,
    tipoTransaccionId,
    page,
    idUbicacion,
    idDni,
    idGrupo,
    limit = 100,
    sortField = null,
    sortOrder = null,
  ) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/transaccionesFiltered`,
        {
          params: {
            startDate: startDate,
            endDate: endDate,
            medioDePagoId,
            tipoMedioDePagoId,
            tipoTransaccionId,
            page,
            idUbicacion,
            idDni,
            idGrupo,
            limit,
            sortField,
            sortOrder,
          },
        },
      );

      return response.data; // Devuelve los datos para utilizarlos después
      //setTotalPages(response.data.totalPages); // Total de páginas
      //setTotalCount(response.data.totalCount); // Cantidad total de registros
    } catch (error) {
      console.error("Error al obtener transacciones:", error);
    }
  };
  // TRANS CUENTRA CORRIENTE CONTEXT ***********************************************************************

  const [cuentaCorrienteTransformed, arrayCuentaCorrienteTransformed] =
    useState([]);

  const getCuentaCorrienteTransformed = async (
    tipoTransaccion,
    page = 1,
    limit = 100,
    options = {},
    tabActivo = "adelantos", // ✅ Nuevo parámetro
  ) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getCuentaCorrienteTransformed/${tipoTransaccion}`,
        {
          params: {
            page: page,
            limit: limit,
            tabActivo: tabActivo, // ✅ Pasar al backend
          },
          signal: options.signal,
        },
      );

      // Accede a la propiedad `data` de la respuesta
      const transacciones = response.data; // Cambiar aquí para acceder a `data`

      arrayCuentaCorrienteTransformed(transacciones); // Cambiar aquí también
      return transacciones.data;
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  // ITEM CONTEXT ***********************************************************************
  // ITEM CONTEXT ***********************************************************************
  // ITEM CONTEXT ***********************************************************************

  const [itemAndItemUbicacion, arrayItemAndItemUbicacion] = useState([]);

  const getItemAndItemUbicacion = async (
    page = 1,
    limit = 100,
    ubicacionId,
    itemId,
    precio,
    soloStockBajo,
    mostrarUltimosCreados,
    mostrarRecetas,
    proveedorId = null,
    searchText = null, // Nuevo parámetro para búsqueda múltiple
    soloItemsConPLU = false,
    filtrosAtributos = {}, // NUEVO: Filtros dinámicos por atributos
    sortField = null,
    sortOrder = null,
  ) => {
    try {
      // Construir params base
      const params = {
        page,
        limit,
        ubicacionId,
        itemId,
        precio,
        soloStockBajo,
        mostrarUltimosCreados,
        mostrarRecetas,
        proveedorId,
        searchText,
        soloItemsConPLU,
      };

      // Agregar parámetros de ordenamiento si existen
      if (sortField) {
        params.sortField = sortField;
      }
      if (sortOrder) {
        params.sortOrder = sortOrder;
      }

      // NUEVO: Agregar filtros de atributos si existen
      // Serializar como JSON solo si hay filtros activos
      if (filtrosAtributos && Object.keys(filtrosAtributos).length > 0) {
        // Filtrar solo valores no vacíos
        const filtrosActivos = Object.entries(filtrosAtributos)
          .filter(([_, valor]) => valor && valor.trim() !== "")
          .reduce((acc, [campo, valor]) => {
            acc[campo] = valor;
            return acc;
          }, {});
        
        if (Object.keys(filtrosActivos).length > 0) {
          params.filtrosAtributos = JSON.stringify(filtrosActivos);
// console.log('📊 Enviando filtros de atributos al backend:', filtrosActivos);
        }
      }

      const response = await axios.get(
        serverURL + "/itemAPI/getItemAndItemUbicacion",
        { params }
      );
      arrayItemAndItemUbicacion(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };

  // Función específica para SERVICIOS (servicio = true)
  const getItemAndItemUbicacionServicios = async (
    page = 1,
    limit = 100,
    ubicacionId,
    itemId,
    precio,
    soloStockBajo,
    mostrarUltimosCreados,
    mostrarRecetas,
    proveedorId = null,
    searchText = null,
    soloItemsConPLU = false,
    filtrosAtributos = {},
    fechaDesde = null,
    fechaHasta = null,
    sortField = null,
    sortOrder = null,
    filtroEsVendedor = false,
    filtroNoEsVendedor = false,
  ) => {
    try {
      const params = {
        page,
        limit,
        ubicacionId,
        itemId,
        precio,
        soloStockBajo,
        mostrarUltimosCreados,
        mostrarRecetas,
        proveedorId,
        searchText,
        soloItemsConPLU,
      };

      // Solo agregar fechas si tienen valores válidos (no null, no undefined)
      if (fechaDesde) {
        params.fechaDesde = fechaDesde;
      }
      if (fechaHasta) {
        params.fechaHasta = fechaHasta;
      }
      if (sortField) {
        params.sortField = sortField;
      }
      if (sortOrder) {
        params.sortOrder = sortOrder;
      }
      if (typeof filtroEsVendedor === "boolean") {
        params.filtroEsVendedor = filtroEsVendedor;
      }
      if (typeof filtroNoEsVendedor === "boolean") {
        params.filtroNoEsVendedor = filtroNoEsVendedor;
      }


      if (filtrosAtributos && Object.keys(filtrosAtributos).length > 0) {
        const filtrosActivos = Object.entries(filtrosAtributos)
          .filter(([_, valor]) => valor && valor.trim() !== "")
          .reduce((acc, [campo, valor]) => {
            acc[campo] = valor;
            return acc;
          }, {});
        
        if (Object.keys(filtrosActivos).length > 0) {
          params.filtrosAtributos = JSON.stringify(filtrosActivos);
// console.log('📊 Enviando filtros de atributos al backend (servicios):', filtrosActivos);
        }
      }

      const response = await axios.get(
        serverURL + "/itemAPI/getItemAndItemUbicacionServicios",
        { params }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching servicios:", error);
    }
  };

    // Obtener actividades asociadas a un destino específico
    const getActividadesByDestino = async (destinoId) => {
      try {
        const response = await axios.get(
          serverURL + `/itemAPI/getActividadesByDestino/${destinoId}`
        );
        return response.data;
      } catch (error) {
        console.error("Error al obtener actividades por destino:", error);
        throw error;
      }
    };

  const updateItemAtributo = async (payload) => {
    try {
      const response = await axios.put(
        serverURL + "/itemAPI/updateItemAtributo",
        payload,
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar atributos:", error);
    }
  };

  const [itemAtributo, arrayItemAtributo] = useState([]);
  const getItemAtributo = async () => {
    try {
      const response = await axios.get(serverURL + "/itemAPI/getItemAtributo");
      arrayItemAtributo(response.data);
      return response.data; // Devuelve los datos para utilizarlos después
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };

  const [itemAtributoNoEliminados, setItemAtributoNoEliminados] = useState([]);
  // Obtener atributos no eliminados (Atributos de Grupo 1-5)
  const getItemAtributoNoEliminados = async () => {
    try {
      const response = await axios.get(
        serverURL + "/itemAPI/getItemAtributoNoEliminados",
      );
      setItemAtributoNoEliminados(response.data);
    } catch (error) {
      console.error("Error al obtener atributos:", error);
    }
  };

  const [itemAtributoServicioNoEliminados, setItemAtributoServicioNoEliminados] = useState([]);
  // Obtener atributos de servicio no eliminados (Atributos de Servicio 6-10)
  const getItemAtributoServicioNoEliminados = async () => {
    try {
      const response = await axios.get(
        serverURL + "/itemAPI/getItemAtributoServicioNoEliminados",
      );
      setItemAtributoServicioNoEliminados(response.data);
    } catch (error) {
      console.error("Error al obtener atributos de servicio:", error);
    }
  };

  // ITEM CREATE ITEM***********************************************************************
  const [item, arrayItem] = useState([]);
  const [itemTresLetras, arrayItemTresLetras] = useState([]);

  const getItem = async () => {
    try {
      const response = await axios.get(serverURL + "/itemAPI/getItem");
      arrayItem(response.data);
      return response.data; // Devuelve los datos para utilizarlos después
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };

  const getItemById = async (idItem) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/getItemById/${idItem}`,
      );
      return response.data; // Devuelve los datos para utilizarlos después
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };
  const getItemByCodigoItem = async (codigoItem) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/getItemByCodigoItem/${codigoItem}`,
      );
      return response.data; // Devuelve los datos para utilizarlos después
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };

  const getItemTresLetras = async (searchText, soloGrupos, soloServicios) => {
    try {
      let url = serverURL + `/itemAPI/getItemTresLetras?search=${searchText}`;
      if (soloServicios === true) url += '&soloServicios=true';
      else if (soloGrupos === true) url += '&soloGrupos=true';
      const response = await axios.get(url);
      arrayItemTresLetras(response.data.items); // Actualiza la lista de ítems con los resultados de la búsqueda

      // Retornar toda la respuesta para que el frontend pueda acceder a todos los campos
      return {
        items: response.data.items,
        buscadoPorScanner: response.data.buscadoPorScanner,
        buscadoPorBalanza: response.data.buscadoPorBalanza,
        pesoBalanza: response.data.pesoBalanza,
      };
    } catch (error) {
      console.error("Error fetching item:", error);
      return {
        items: [],
        buscadoPorScanner: false,
        buscadoPorBalanza: false,
        pesoBalanza: null,
      };
    }
  };

  const [gruposTresLetras, arrayGruposTresLetras] = useState([]);

  const getGruposTresLetras = async (searchText) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/getGruposTresLetras?search=${searchText}`
      );
      arrayGruposTresLetras(response.data.items);
      return response.data.items;
    } catch (error) {
      console.error("Error fetching grupos:", error);
      return [];
    }
  };

  const postItem = async (
    descripcionItem,
    codigoItem,
    atributos,
    codigoScannerItem,
    pluBalanzaItem = null,
    esServicio,
    descripcionServicio = null,
    esActividad = false,
  ) => {
    try {
      const response = await axios.post(serverURL + "/itemAPI/postItem", {
        descripcion: descripcionItem,
        codigo: codigoItem,
        atributos,
        codigoScanner: codigoScannerItem,
        pluBalanza: pluBalanzaItem,
        esServicio: esServicio,
        descripcionServicio: descripcionServicio,
        esActividad: esActividad,
      });
      return response; // Retornar la respuesta para usarla en handleItemSubmit
    } catch (error) {
      console.error("Error creating item:", error);
    }
  };

  // Actualizar el estado (activo/inactivo)
  const getTop10ItemVentas = async () => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTop10ItemVentas/`,
      );
      return response.data;
    } catch (error) {
      console.error("Error al pedir 10 items mas vendidos:", error);
    }
  };

  const getTop3ItemsLast7Days = async () => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTop10ItemVentas/`,
      );
      return response.data;
    } catch (error) {
      console.error("Error al pedir 10 items mas vendidos:", error);
    }
  };

  // ITEM CREATE ITEM***********************************************************************
  const [itemUbicacion, arrayItemUbicacion] = useState([]);

  const getItemUbicacion = async () => {
    try {
      const response = await axios.get(serverURL + "/itemAPI/getItemUbicacion");

      // Accede a la propiedad `data` de la respuesta
      const itemUbicaciones = response.data; // Cambiar aquí para acceder a `data`

      // Formatear el campo updatedAt
      const formattedItemUbicaciones = itemUbicaciones.map((itemUbi) => ({
        ...itemUbi,
        updatedAt: itemUbi.updatedAt
          ? format(new Date(itemUbi.updatedAt), "dd/MM/yyyy")
          : "", // Formato deseado
      }));

      // Aquí asumo que `arrayItemUbicacion` es un setter para el estado
      arrayItemUbicacion(formattedItemUbicaciones); // Cambiar aquí también
    } catch (error) {
      console.error("Error fetching item ubicacion:", error);
    }
  };

  const getDeletedItemUbicacion = async () => {
    try {
      const response = await axios.get(
        serverURL + "/itemAPI/getDeletedItemUbicacion",
      );

      // Accede a la propiedad `data` de la respuesta
      const itemUbicaciones = response.data; // Cambiar aquí para acceder a `data`

      // Formatear el campo updatedAt
      const formattedItemUbicaciones = itemUbicaciones.map((itemUbi) => ({
        ...itemUbi,
        updatedAt: itemUbi.updatedAt
          ? format(new Date(itemUbi.updatedAt), "dd/MM/yyyy")
          : "", // Formato deseado
      }));

      // Aquí asumo que `arrayItemUbicacion` es un setter para el estado
      arrayItemAndItemUbicacion(formattedItemUbicaciones); // Cambiar aquí también
    } catch (error) {
      console.error("Error fetching item ubicacion:", error);
    }
  };

  const postItemUbicacion = async (
    idItem,
    idUbicacion,
    inventario,
    stockMinimoItem,
  ) => {
    try {
      await axios.post(serverURL + "/itemAPI/postItemUbicacion", {
        idItem: idItem,
        idUbicacion: idUbicacion,
        inventario: inventario,
        stockMinimo: stockMinimoItem,
      });
      getItemUbicacion();
    } catch (error) {
      console.error("Error creating item:", error);
    }
  };

  const getRecetas = async (
    startDate,
    endDate,
    idReceta,
    idMateriaPrima,
    page,
    limit,
  ) => {
    try {
      const response = await axios.get(serverURL + "/itemAPI/getRecetas", {
        params: {
          startDate: startDate,
          endDate: endDate,
          idReceta: idReceta,
          idMateriaPrima: idMateriaPrima,
          page: page,
          limit: limit, // Puedes ajustar la página según sea necesario
        },
      });
      return response.data; // Devuelve los datos de las recetas
    } catch (error) {
      console.error("Error al obtener recetas:", error);
      throw error; // Lanza el error para manejarlo en el componente
    }
  };
  
  // 🚀 NUEVA FUNCIÓN PARA SISTEMA DE VIAJES
  const getRecetasViajes = async (
    startDate,
    endDate,
    idReceta,
    idMateriaPrima,
    destino,
    page,
    limit,
    fechaCreacionDesde = null,
    fechaCreacionHasta = null,
    cerrado = null,
  ) => {
    try {
      const params = {
          page: page,
          limit: limit,
      };
      
      // Agregar filtros solo si están presentes (ahora son opcionales)
      if (startDate) {
        params.startDate = startDate;
      }
      if (endDate) {
        params.endDate = endDate;
      }
      if (idReceta) {
        params.idReceta = idReceta;
      }
      if (idMateriaPrima) {
        params.idMateriaPrima = idMateriaPrima;
      }
      if (destino) {
        params.destino = destino;
      }
      if (cerrado !== null && cerrado !== undefined && cerrado !== "") {
        params.cerrado = cerrado;
      }
      
      // Agregar filtros de fecha de creación si están presentes
      if (fechaCreacionDesde) {
        params.fechaCreacionDesde = fechaCreacionDesde;
      }
      if (fechaCreacionHasta) {
        params.fechaCreacionHasta = fechaCreacionHasta;
      }
      
      const response = await axios.get(serverURL + "/itemAPI/getRecetasViajes", { params });
      return response.data; // Devuelve los datos de las recetas de viajes
    } catch (error) {
      console.error("Error al obtener recetas de viajes:", error);
      throw error; // Lanza el error para manejarlo en el componente
    }
  };

  const getTablaRecetaDatos = async (
    startDate,
    endDate,
    idReceta,
    idMateriaPrima,
    destino,
    page,
    limit,
    fechaCreacionDesde = null,
    fechaCreacionHasta = null,
    fechaInicio = null,
    cerrado = null,
    cancelado = null,
    soloListado = false,    
    sortField = null,
    sortOrder = null,
  ) => {
    try {
      const params = {
        page: page,
        limit: limit,
      };

      if (startDate) {
        params.startDate = startDate;
      }
      if (endDate) {
        params.endDate = endDate;
      }
      if (idReceta) {
        params.idReceta = idReceta;
      }
      if (idMateriaPrima) {
        params.idMateriaPrima = idMateriaPrima;
      }
      if (destino) {
        params.destino = destino;
      }
      if (cerrado !== null && cerrado !== undefined && cerrado !== "") {
        params.cerrado = cerrado;
      }
      if (cancelado !== null && cancelado !== undefined && cancelado !== "") {
        params.cancelado = cancelado;
      }
      if (fechaCreacionDesde) {
        params.fechaCreacionDesde = fechaCreacionDesde;
      }
      if (fechaCreacionHasta) {
        params.fechaCreacionHasta = fechaCreacionHasta;
      }
      if (fechaInicio) {
        params.fechaInicio = fechaInicio;
      }
      if (soloListado === true || soloListado === "1") {
        params.soloListado = "1";
      }
      if (sortField) {
        params.sortField = sortField;
      }
      if (sortOrder) {
        params.sortOrder = sortOrder;
      }

      const response = await axios.get(serverURL + "/itemAPI/getTablaRecetaDatos", { params });
      return response.data;
    } catch (error) {
      console.error("Error al obtener datos de tabla receta:", error);
      throw error;
    }
  };

  const getTablaRecetaFinancieros = async (idPaquetes) => {
    try {
      const ids = Array.isArray(idPaquetes) ? idPaquetes.filter((id) => id != null).join(",") : "";
      if (!ids) return { financieros: {} };
      const response = await axios.get(serverURL + "/itemAPI/getTablaRecetaFinancieros", {
        params: { ids },
      });
      return response.data;
    } catch (error) {
      console.error("Error al obtener financieros de tabla receta:", error);
      throw error;
    }
  };

  const getTablaRecetaTotales = async (
    startDate,
    endDate,
    idReceta,
    idMateriaPrima,
    destino,
    fechaCreacionDesde = null,
    fechaCreacionHasta = null,
    fechaInicio = null,
    cerrado = null,
  ) => {
    try {
      const params = {};

      if (startDate) {
        params.startDate = startDate;
      }
      if (endDate) {
        params.endDate = endDate;
      }
      if (idReceta) {
        params.idReceta = idReceta;
      }
      if (idMateriaPrima) {
        params.idMateriaPrima = idMateriaPrima;
      }
      if (destino) {
        params.destino = destino;
      }
      if (cerrado !== null && cerrado !== undefined && cerrado !== "") {
        params.cerrado = cerrado;
      }
      if (fechaCreacionDesde) {
        params.fechaCreacionDesde = fechaCreacionDesde;
      }
      if (fechaCreacionHasta) {
        params.fechaCreacionHasta = fechaCreacionHasta;
      }
      if (fechaInicio) {
        params.fechaInicio = fechaInicio;
      }

      const response = await axios.get(serverURL + "/itemAPI/getTablaRecetaTotales", { params });
      return response.data;
    } catch (error) {
      console.error("Error al obtener totales de tabla receta:", error);
      throw error;
    }
  };

  const crearGrupoPaqueteApi = async (payload) => {
    try {
      const response = await axios.post(serverURL + "/itemAPI/crearGrupoPaquete", payload);
      return response.data;
    } catch (error) {
      console.error("Error al crear grupo y paquete:", error);
      throw error;
    }
  };

  // Crear o actualizar paquete con sus servicios
  // NOTA: Ahora el backend crea una cabecera Paquete y servicios BOM vinculados
  const crearRecetaApi = async (
    idProductoTerminado,
    ingredientes,
    existeReceta,
    destino, // Parámetro de destino (ubicación del paquete)
    fechaInicio, // Fecha de inicio del paquete (obligatoria)
    fechaFin = null, // Fecha de fin del paquete (opcional)
    noches = null, // Número de noches del viaje (opcional)
    idPaquete = null, // ID del paquete (opcional, para edición directa)
    descripcionPaquete = null, // ✅ NUEVO: Descripción del paquete para gastos automáticos
    monto = null, // ✅ Precio del paquete (se guarda en Paquete.monto)
    observaciones = null, // Observaciones libres del paquete
  ) => {
    try {
      const response = await axios.post(serverURL + "/itemAPI/crearReceta", {
        idProductoTerminado,
        ingredientes,
        existeReceta,
        destino,
        fechaInicio,
        fechaFin,
        noches,
        idPaquete, // Enviar idPaquete si existe (para edición)
        descripcionPaquete, // ✅ NUEVO: Descripción para gastos automáticos
        monto, // ✅ Enviar precio para guardarlo en cabecera Paquete
        observaciones,
      });
      return response.data; // Retorna { message, idPaquete, paqueteCreado }
    } catch (error) {
      console.error("Error al crear paquete:", error);
      throw error;
    }
  };

  // Eliminar paquete (cabecera y servicios)
  const eliminarBomApi = async (idProductoTerminado, destino, idPaquete = null) => {
    try {
      const response = await axios.post(serverURL + "/itemAPI/eliminarBom", {
        idProductoTerminado,
        destino,
        idPaquete, // Puede enviar idPaquete directamente si lo tiene
      });
      return response.data;
    } catch (error) {
      console.error("Error al eliminar paquete:", error);
      throw error;
    }
  };

  // Abrir/Cerrar paquete (estado manual)
  const setCerradoPaqueteApi = async (idPaquete, cerrado) => {
    try {
      const response = await axios.post(serverURL + "/itemAPI/setCerradoPaquete", {
        idPaquete,
        cerrado,
      });
      return response.data;
    } catch (error) {
      console.error("Error al actualizar estado del paquete:", error);
      throw error;
    }
  };

  // Cancelar/Restablecer paquete (estado manual)
  const setCanceladoPaqueteApi = async (idPaquete, cancelado) => {
    try {
      const response = await axios.post(serverURL + "/itemAPI/setCanceladoPaquete", {
        idPaquete,
        cancelado,
      });
      return response.data;
    } catch (error) {
      console.error("Error al actualizar estado cancelado del paquete:", error);
      throw error;
    }
  };

  // Crear o actualizar vendedor del paquete (ahora actualiza Paquete.idVendedor)
  const createOrUpdateVendedorPaquete = async (idItem, idUbicacion, idEntidad, idPaquete = null) => {
    try {
      const response = await axios.post(serverURL + "/itemAPI/createOrUpdateVendedorPaquete", {
        idItem,
        idUbicacion,
        idEntidad: idEntidad || null,
        idPaquete, // Puede enviar idPaquete directamente si lo tiene
      });
      return response.data;
    } catch (error) {
      console.error("Error al actualizar vendedor del paquete:", error);
      throw error;
    }
  };

  // Obtener vendedor del paquete (ahora desde Paquete.idVendedor)
  const getVendedorPaquete = async (idItem, idUbicacion, idPaquete = null) => {
    try {
      // Si tiene idPaquete, usarlo; sino buscar por idItem + idUbicacion
      const url = idPaquete 
        ? serverURL + `/itemAPI/getVendedorPaquete/${idItem}/${idUbicacion}?idPaquete=${idPaquete}`
        : serverURL + `/itemAPI/getVendedorPaquete/${idItem}/${idUbicacion}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { vendedor: null };
      }
      console.error("Error al obtener vendedor del paquete:", error);
      throw error;
    }
  };

  // Obtener paquetes (grupos) que usan un servicio - para bloquear eliminación
  // idUbicacion e idEntidad opcionales: filtran por destino y proveedor (triple combinación)
  const getPaquetesByServicio = async (idServicio, idUbicacion = null, idEntidad = null) => {
    try {
      const params = {};
      if (idUbicacion != null) params.idUbicacion = idUbicacion;
      if (idEntidad != null) params.idEntidad = idEntidad;
      const response = await axios.get(
        serverURL + `/itemAPI/getPaquetesByServicio/${idServicio}`,
        { params }
      );
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Error al obtener paquetes por servicio:", error);
      return [];
    }
  };

  // Obtener servicios de un paquete (ahora incluye info del Paquete)
  const getBomByIdItem = async (idItem, destino = null, idPaquete = null) => {
    try {
      const params = {};
      if (destino) params.destino = destino;
      if (idPaquete) params.idPaquete = idPaquete;
      console.log('[getBomByIdItem CLIENT] request:', { idItem, destino, idPaquete, params });
      const response = await axios.get(
        serverURL + `/itemAPI/getBomByIdItem/${idItem}`,
        { params }
      );
      const data = response.data || [];
      const withEsVendedor = Array.isArray(data) ? data.filter((i) => i?.esVendedor === true).length : 0;
      console.log('[getBomByIdItem CLIENT] response:', { length: Array.isArray(data) ? data.length : 0, withEsVendedor, sample: data[0] ? { idEntidad: data[0].idEntidad, esVendedor: data[0].esVendedor, entidad: data[0].entidad ? 'presente' : 'ausente' } : null });
      return data;
    } catch (error) {
      console.error("Error al obtener paquete:", error);
      return [];
    }
  };

  // Obtener estadísticas por lote para pares (idItem, idUbicacion)
  const getItemUbicacionStatsBatch = async (pairs) => {
    try {
      const response = await axios.post(
        serverURL + "/itemAPI/getItemUbicacionStatsBatch",
        { pairs }
      );
      return response.data?.statsByKey || {};
    } catch (error) {
      console.error("Error obteniendo estadísticas batch de paquetes:", error);
      return {};
    }
  };

  const getCanalEntidad = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getCanalEntidad");
      return response.data;
    } catch (error) {
      console.error("Error fetching canal entidad:", error);
    }
  };

  const postListaMonto = async (
    newItemId,
    idUbicacion,
    entidad,
    precio_costo,
  ) => {
    try {
      await axios.post(serverURL + "/transaccionAPI/postListaMonto", {
        newItemId,
        idUbicacion,
        entidad,
        precio_costo,
      });
    } catch (error) {
      console.error("Error creating item:", error);
    }
  };

  const getTransaccionItemID = async (transaccionId) => {
    try {
      const response = await axios.get(
        serverURL + `/transaccionAPI/getTransaccionItemID/${transaccionId}`,
      ); // Ajusta la URL según tu API
      return response.data; // Suponiendo que esto retorna un arreglo de ítems de la transacción
    } catch (error) {
      console.error("Error al obtener los ítems de la transacción:", error);
      return []; // Retorna un arreglo vacío en caso de error
    }
  };

  const getTransaccionItemIDEnCompras = async (transaccionId) => {
    try {
      const response = await axios.get(
        serverURL +
          `/transaccionAPI/getTransaccionItemIDEnCompras/${transaccionId}`,
      ); // Ajusta la URL según tu API
      return response.data; // Suponiendo que esto retorna un arreglo de ítems de la transacción
    } catch (error) {
      console.error("Error al obtener los ítems de la transacción:", error);
      return []; // Retorna un arreglo vacío en caso de error
    }
  };

  const updateTransaccionCompraItem = async (
    transaccionId,
    idItem,
    cantidadRecibida,
  ) => {
    try {
      const response = await axios.put(
        serverURL + `/transaccionAPI/updateTransaccionCompraItem/`,
        {
          transaccionId,
          idItem,
          cantidadRecibida,
        },
      ); // Ajusta la URL según tu API
      return response.data; // Suponiendo que esto retorna un arreglo de ítems de la transacción
    } catch (error) {
      console.error("Error al obtener los ítems de la transacción:", error);
      return []; // Retorna un arreglo vacío en caso de error
    }
  };

  const updateItemUbicacion = async (
    idItem,
    idUbicacion,
    inventarioItem,
    proviene, // Nueva variable
  ) => {
    // console.log(idItem, idUbicacion, inventarioItem, precioItem, proviene);

    try {
      await axios.put(serverURL + "/itemAPI/putItemUbicacion", {
        idItem: idItem,
        idUbicacion: idUbicacion,
        inventario: inventarioItem,
        proviene: proviene, // Enviamos 'proviene' al backend
      });
    } catch (error) {
      console.error("Error updating item:", error);
    }
  };

  // ITEM FILTER ITEM UBICACION *********************************************
  const [itemUbicacionFilter, arrayItemUbicacionFilter] = useState([]);

  const getItemUbicacionFilter = async (itemID, soloDestinos) => {
    try {
      const params = soloDestinos ? { soloDestinos: 'true' } : {};
      const response = await axios.get(
        serverURL + `/itemAPI/getItemUbicacionFilter/${itemID}`,
        { params }
      );

      arrayItemUbicacionFilter(response.data);
      return response.data;
    } catch (error) {
      console.error("Error al obtener los ítems ubicacion:", error);
      return []; // Retorna un arreglo vacío en caso de error
    }
  };

  const getItemUbicacionFilterByUbicacion = async (itemID, ubicacionID) => {
    try {
      const response = await axios.get(
        serverURL +
          `/itemAPI/getItemUbicacionFilterByUbicacion/${itemID}/${ubicacionID}`,
      ); // Ajusta la URL según tu API

      arrayItemUbicacionFilter(response.data);
      return response.data;
    } catch (error) {
      console.error("Error al obtener los ítems ubicacion:", error);
      return []; // Retorna un arreglo vacío en caso de error
    }
  };

  // Función para actualizar un item
  const updateItem = async (
    itemId,
    descripcion,
    codigo,
    codigoScannerItem,
    atributos,
    eliminado,
    pluBalanzaItem,
    descripcionServicio,
    esActividad,
    archivosAdjunto,
  ) => {
    try {
      const payload = {
        descripcion,
        codigo,
        codigoScannerItem,
        atributos,
        eliminado,
      };

      if (pluBalanzaItem !== undefined) {
        payload.pluBalanza = pluBalanzaItem;
      }

      if (descripcionServicio !== undefined) {
        payload.descripcionServicio = descripcionServicio;
      }

      if (esActividad !== undefined) {
        payload.esActividad = esActividad;
      }

      if (archivosAdjunto !== undefined) {
        payload.archivosAdjunto = archivosAdjunto;
      }

      const response = await axios.put(
        serverURL + `/itemAPI/itemsUpdate/${itemId}`,
        payload,
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar el item:", error);
      throw error;
    }
  };

  // Función para actualizar las ubicaciones asociadas a un item
  const updateItemUbicaciones = async (itemId, ubicacionesData) => {
    try {
      const response = await axios.put(
        serverURL + `/itemAPI/itemUbicacionUpdate/${itemId}`,
        {
          ubicaciones: ubicacionesData,
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar las ubicaciones del item:", error);
      throw error;
    }
  };

  // === FUNCIONES PARA ELIMINACIÓN MASIVA ===
  
  /**
   * Actualizar el estado eliminado de un itemUbicacion específico
   * @param {number} idItem - ID del item
   * @param {number} idUbicacion - ID de la ubicación
   * @param {boolean} eliminado - Nuevo estado eliminado
   */
  const updateItemUbicacionEliminado = async (idItem, idUbicacion, eliminado) => {
    try {
// console.log(`🔄 Actualizando itemUbicacion idItem=${idItem}, idUbicacion=${idUbicacion} a eliminado=${eliminado}`);
      const response = await axios.put(
        serverURL + `/itemAPI/itemUbicacion/${idItem}/${idUbicacion}/eliminado`,
        { eliminado }
      );
      return response.data;
    } catch (error) {
      console.error("❌ Error al actualizar itemUbicacion:", error);
      throw error;
    }
  };

  /**
   * Obtener todas las itemUbicaciones de un item específico
   * @param {number} itemId - ID del item
   */
  const getItemUbicacionesByItemId = async (itemId) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/itemUbicaciones/byItem/${itemId}`
      );
      return response.data;
    } catch (error) {
      console.error("❌ Error al obtener itemUbicaciones:", error);
      throw error;
    }
  };

  /**
   * Eliminar múltiples items en lote (soft delete)
   * @param {number[]} itemIds - Array de IDs de items a eliminar
   * @param {number|null} ubicacionId - ID de ubicación (opcional)
   * @param {number|null} entidadId - ID de proveedor (opcional, junto con ubicacionId elimina solo esa triple)
   * Si ubicacionId existe: solo elimina itemUbicacion específico
   * Si ubicacionId + entidadId: elimina solo ListaDeMontos de esa triple (item+ubicacion+proveedor)
   * Si ubicacionId es null: elimina item completo y todas sus ubicaciones
   */
  const bulkDeleteItems = async (itemIds, ubicacionId = null, entidadId = null) => {
    try {
// console.log(`🗑️ Eliminando items: ${itemIds.length} items, ubicación: ${ubicacionId || 'todas'}, entidad: ${entidadId || 'todas'}`);
      
      const body = { itemIds, ubicacionId };
      if (entidadId != null) body.entidadId = entidadId;
      const response = await axios.post(
        serverURL + `/itemAPI/items/bulk-delete`,
        body
      );
      
// console.log(`✅ Eliminación completada:`, response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Error al eliminar items en lote:", error);
      throw error;
    }
  };

  // IMPUESTOS ***********************************************************************

  const updateIncluirImpuestos = async (dato) => {
    try {
      const response = await axios.put(
        serverURL + `/adminAPI/updateIncluirImpuestos/${dato}`,
      );
      return response.data;
    } catch (error) {}
  };

  const getIncluirImpuestos = async () => {
    try {
      const response = await axios.get(
        serverURL + `/adminAPI/getIncluirImpuestos`,
      );
      return response.data; // Cambiar aquí para acceder a `data`
    } catch (error) {}
  };

  const [impuestos, arrayImpuestos] = useState([]);

  const getImpuestos = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getImpuestos",
      );
      arrayImpuestos(response.data);
    } catch (error) {
      console.error("Error fetching impuestos:", error);
    }
  };

  const postImpuestos = async (descripcionImpuesto, porcentajeImpuesto) => {
    try {
      await axios.post(serverURL + "/transaccionAPI/postImpuestos", {
        descripcion: descripcionImpuesto,
        porcentaje: porcentajeImpuesto,
        incluidoEnPrecio: true, // Incluir en precio por defecto va true por el momento por la logica que agregamos a ultimo momento
      });
      getImpuestos();
    } catch (error) {
      console.error("Error creating impuestos:", error);
    }
  };

  const postTransaccionImpuesto = async (
    idTransaccion,
    idImpuesto,
    porcentajeImpuesto,
    montoImpuesto,
  ) => {
    try {
      // console.log("Enviando datos a postTransaccionImpuesto:", {
      //   idTransaccion,
      //   idImpuesto,
      //   porcentajeImpuesto,
      // });
      await axios.post(serverURL + "/transaccionAPI/postTransaccionImpuesto", {
        idTransaccion: idTransaccion,
        idImpuesto: Number(idImpuesto),
        porcentaje: porcentajeImpuesto,
        montoTotal: montoImpuesto,
      });
    } catch (error) {
      console.error("Error creating transaccion impuestos:", error);
    }
  };

  const [tiposFacturas, arrayTiposFacturas] = useState([]);

  const getTiposFacturas = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTiposFacturas",
      );
      arrayTiposFacturas(response.data);
    } catch (error) {
      console.error("Error fetching tipo facturas:", error);
    }
  };

  const postTransaccionTipoFactura = async (
    idTipoFactura,
    idTransaccion,
    CAE,
    vencimientoCAE,
    idCondicionIva,
    numeroFactura,
    puntoVenta,
    fechaEmision,
  ) => {
    try {
      await axios.post(
        serverURL + "/transaccionAPI/postTransaccionTipoFactura",
        {
          idTipoFactura: idTipoFactura,
          idTransaccion: idTransaccion,
          CAE: CAE,
          vencimientoCAE: vencimientoCAE,
          idCondicionIva: idCondicionIva,
          numeroFactura: numeroFactura,
          puntoVenta: puntoVenta,
          fechaEmision: fechaEmision,
        },
      );
      getTiposFacturas();
    } catch (error) {
      console.error("Error creating impuestos:", error);
    }
  };

  // Función para verificar si una transacción fue facturada y obtener datos de la factura original
  const getTransaccionFacturadaData = async (idTransaccion) => {
    try {
      const response = await axios.get(
        serverURL + `/transaccionAPI/getTransaccionFacturadaData/${idTransaccion}`
      );
      return response.data;
    } catch (error) {
      console.error("Error al verificar datos de facturación:", error);
      throw error;
    }
  };

  // Función para generar nota de crédito en AFIP
  const generarNotaCredito = async (datosFacturaOriginal, datosDevolucion, entidadCliente) => {
    try {

      // VALIDACIÓN 2: Verificar que la transacción original fue facturada
      if (!datosFacturaOriginal.tipoFacturaAFIP) {
        throw new Error("La transacción original no fue facturada, no se requiere Nota de Crédito");
      }

      // Mapear el tipo de factura original al tipo de nota de crédito correspondiente
      let tipoNotaCredito = null;
      if (datosFacturaOriginal.tipoFacturaAFIP === 1) {
        tipoNotaCredito = 3; // Nota de Crédito A
      } else if (datosFacturaOriginal.tipoFacturaAFIP === 6) {
        tipoNotaCredito = 8; // Nota de Crédito B
      } else if (datosFacturaOriginal.tipoFacturaAFIP === 11) {
        tipoNotaCredito = 13; // Nota de Crédito C
      } else if (datosFacturaOriginal.tipoFacturaAFIP === 51) {
        tipoNotaCredito = 53; // Nota de Crédito M
      }

      if (!tipoNotaCredito) {
        throw new Error("No se pudo determinar el tipo de nota de crédito");
      }

      // LÓGICA DE DocTipo/DocNro según tipo de factura y longitud de documento
      let docTipo = 99; // Por defecto: Consumidor Final
      let docNro = 0;
      
      const documentoCliente = entidadCliente.dniCuitCuil || '';
      const documentoLimpio = documentoCliente ? String(documentoCliente).replace(/\D/g, '') : '';
      const documentoNumerico = documentoLimpio ? Number(documentoLimpio) : 0;
      const tipoFacturaOriginalId = datosFacturaOriginal.tipoFacturaAFIP;

      if (tipoFacturaOriginalId === 1) {
        // Factura A -> NC A: siempre requiere CUIT
        if (documentoLimpio.length === 11 && documentoNumerico > 0) {
          docTipo = 80; // CUIT
          docNro = documentoNumerico;
        } else {
          throw new Error("Nota de Crédito A requiere CUIT de 11 dígitos");
        }
      } else if (tipoFacturaOriginalId === 6) {
        // Factura B -> NC B: lógica según longitud del documento
        if (documentoLimpio.length === 11 && documentoNumerico > 0) {
          docTipo = 80; // CUIT
          docNro = documentoNumerico;
        } else if (documentoLimpio.length >= 7 && documentoNumerico > 0) {
          docTipo = 96; // DNI
          docNro = documentoNumerico;
        } else {
          // Sin documento válido, usar Consumidor Final
          docTipo = 99;
          docNro = 0;
        }
      } else if (tipoFacturaOriginalId === 11) {
        // Factura C -> NC C: siempre Consumidor Final
        docTipo = 99;
        docNro = 0;
      }

      // CÁLCULO DE IVA DETALLADO (igual que en GestionGenerarVentaComponent)
      const ivaAFIP = getIvaAFIP();
      const gruposIva = {};
      let impNetoTotal = 0;
      let impIVATotal = 0;

      // Solo procesar items con cantidad > 0 (items devueltos)
      const itemsDevueltos = datosDevolucion.items.filter(item => item.cantidad > 0);

      if (itemsDevueltos.length === 0) {
        throw new Error("No hay items con cantidad > 0 para devolver");
      }

      // Agrupar items por alícuota de IVA
      itemsDevueltos.forEach(item => {
        let porcentajeIva = 21; // Default

        if (item.impuestoData && item.impuestoData.porcentaje !== undefined) {
          porcentajeIva = item.impuestoData.porcentaje;
        } else if (item.ivaPercentage !== undefined) {
          porcentajeIva = item.ivaPercentage;
        }

        // Encontrar el ID de AFIP correspondiente al porcentaje
        const ivaAFIPEncontrado = ivaAFIP.find(iva => Math.abs(iva.porcentaje - porcentajeIva) < 0.01);
        const idAFIP = ivaAFIPEncontrado ? ivaAFIPEncontrado.ivaAFIP : 5; // Default a 21%

        if (!gruposIva[idAFIP]) {
          gruposIva[idAFIP] = {
            id: idAFIP,
            porcentaje: porcentajeIva,
            baseImponible: 0,
            importeIva: 0,
            items: []
          };
        }

        // Calcular importes del item (siempre positivos para NC)
        const importeItem = Math.abs(item.importe || (item.cantidad * item.precio));
        const baseImponibleItem = Math.abs(importeItem / (1 + porcentajeIva / 100));
        const ivaItem = Math.abs(importeItem - baseImponibleItem);

        gruposIva[idAFIP].baseImponible += baseImponibleItem;
        gruposIva[idAFIP].importeIva += ivaItem;
        gruposIva[idAFIP].items.push({
          ...item,
          baseImponibleItem,
          ivaItem,
          importeItem
        });

        impNetoTotal += baseImponibleItem;
        impIVATotal += ivaItem;
      });

      // Convertir a array para AFIP (solo si hay IVA)
      const ivaArray = tipoNotaCredito !== 13 ? Object.values(gruposIva).map(grupo => ({
        Id: grupo.id,
        BaseImp: Number.parseFloat(grupo.baseImponible.toFixed(2)),
        Importe: Number.parseFloat(grupo.importeIva.toFixed(2))
      })) : [];

      const impTotal = Number.parseFloat((impNetoTotal + impIVATotal).toFixed(2));

      // Preparar los datos para la nota de crédito
      const notaCreditoData = {
        PtoVta: datosFacturaOriginal.ptoVta,
        CbteTipo: tipoNotaCredito,
        Concepto: 1, // Productos y Servicios
        DocTipo: docTipo,
        DocNro: docNro,
        CbteFch: dayjs().format('YYYYMMDD'),
        ImpTotal: impTotal, // Importe siempre positivo
        ImpTotConc: 0,
        ImpNeto: Number.parseFloat(impNetoTotal.toFixed(2)), // Importe siempre positivo
        ImpOpEx: 0,
        ImpIVA: Number.parseFloat(impIVATotal.toFixed(2)), // Importe siempre positivo
        ImpTrib: 0,
        MonId: 'PES',
        MonCotiz: 1,
        CondicionIVAReceptorId: datosDevolucion.condicionIVA || 5,
        Iva: ivaArray, // Array de IVA con importes positivos calculados correctamente
        ItemsList: itemsDevueltos, // Solo items con cantidad > 0
        DniCuitCliente: docTipo === 99 ? '' : documentoLimpio,
        ApellidoNombre: entidadCliente.descripcion || 'Consumidor Final',
        direccionCliente: datosDevolucion.direccionCliente || entidadCliente.direccion || '',
        condicionVenta: datosDevolucion.condicionVenta || 'CONTADO',
        condicionIvaCliente: entidadCliente.condicionIvaDescripcion || datosDevolucion.condicionIvaDescripcion || datosDevolucion.condicionIVA || datosDevolucion.CondicionIVAReceptorDescripcion,
        telefonoCliente: datosDevolucion.telefonoCliente || entidadCliente.telefono || '',
        emailCliente: datosDevolucion.emailCliente || entidadCliente.email || '',
        localidadCliente: datosDevolucion.localidadCliente || '',
        provinciaCliente: datosDevolucion.provinciaCliente || '',
        abrirPDF: false,
        // Campos para asociación a factura original (para el endpoint)
        tipoFacturaOriginal: datosFacturaOriginal.tipoFacturaAFIP,
        ptoVtaOriginal: datosFacturaOriginal.ptoVta,
        nroFacturaOriginal: datosFacturaOriginal.nroFactura
      };

// console.log("Datos de la nota de crédito:", notaCreditoData);

      // Enviar a AFIP
      const response = await axios.post(serverURL + "/api/afip/credit-note", notaCreditoData);
      
      if (response.data && response.data.cae) {
// console.log("Nota de crédito generada exitosamente:", response.data);
        
        // ✅ Guardar información de la Nota de Crédito en TransaccionTipoFactura
        try {
          // Determinar el idTipoFactura para la nota de crédito
          let idTipoFacturaNC = null;
          if (tipoNotaCredito === 3) {
            idTipoFacturaNC = 1; // Nota de Crédito A
          } else if (tipoNotaCredito === 8) {
            idTipoFacturaNC = 2; // Nota de Crédito B  
          } else if (tipoNotaCredito === 13) {
            idTipoFacturaNC = 3; // Nota de Crédito C
          } else if (tipoNotaCredito === 53) {
            idTipoFacturaNC = 7; // Nota de Crédito M
          }

          if (idTipoFacturaNC && datosDevolucion.idTransaccion) {
// console.log("Guardando información de Nota de Crédito en TransaccionTipoFactura");
// console.log("idTipoFacturaNC:", idTipoFacturaNC);
// console.log("datosDevolucion.idTransaccion:", datosDevolucion.idTransaccion);
// console.log("response.data.cae:", response.data.cae);
// console.log("response.data.vto:", response.data.vto);
// console.log("datosDevolucion.condicionIVA:", datosDevolucion.condicionIVA);
// console.log("response.data.cbteNro:", response.data.cbteNro);
            await postTransaccionTipoFactura(
              idTipoFacturaNC,
              datosDevolucion.idTransaccion, // ID de la transacción de devolución
              response.data.cae,
              response.data.vto,
              datosDevolucion.condicionIVA || 5,
              response.data.cbteNro,
              notaCreditoData.PtoVta,
              response.data.fechaEmision || String(notaCreditoData.CbteFch),
            );
// console.log("Información de Nota de Crédito guardada en TransaccionTipoFactura");
          } else {
            console.warn("No se pudo determinar idTipoFactura para NC o falta idTransaccion");
          }
        } catch (saveError) {
          console.error("Error al guardar información de NC en TransaccionTipoFactura:", saveError);
          // No fallar la operación principal si hay error en el guardado
        }
        
             // Generar y guardar PDF de la Nota de Crédito
             try {
              const idTransaccionDevolucion = datosDevolucion.idTransaccion || Date.now();
              await abrirNotaCreditoAfip(response.data, notaCreditoData, idTransaccionDevolucion);
// console.log("PDF de Nota de Crédito generado y abierto exitosamente");
            } catch (pdfError) {
              console.error("Error al generar PDF de Nota de Crédito:", pdfError);
              // No fallar la operación principal si hay error en el PDF
              }
        
        return response.data;
      } else {
        throw new Error("No se recibió CAE de AFIP");
      }

    } catch (error) {
      console.error("Error al generar nota de crédito:", error);
      throw error;
    }
  };


  // Función para guardar comprobantes
  const guardarComprobante = async (idFactura, pdfBase64, tipo) => {
    try {
      const response = await axios.post(
        serverURL + "/transaccionAPI/guardarComprobante",
        { idFactura, pdfBase64, tipo }
      );
      return response.data;
    } catch (error) {
      console.error("Error guardando comprobante:", error);
      throw error;
    }
  };

  // Función para generar PDF AFIP de Nota de Crédito (reutilizando abrirFacturaHtml)
  const abrirNotaCreditoAfip = async (datosNC, payloadNC, idTransaccionDevolucion) => {
    try {
      // Importar dinámicamente las funciones de facturaAfipHtmlGenerator
      const { abrirFacturaPdf, generarFacturaPdfBlob } = await import('./facturaAfipHtmlGenerator.js');
      
      // Generar el PDF usando la lógica existente pero con datos de NC
      const blob = await generarFacturaPdfBlob(datosNC, payloadNC, getParametrosGlobales);
      
      // Convertir blob a base64 para guardar
      const pdfDataUrl = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      
      // Guardar en carpeta devoluciones como notaCredito
      await guardarComprobante(idTransaccionDevolucion, pdfDataUrl, 'notaCredito');
      
      // Abrir el PDF (igual que abrirFacturaPdf)
      await abrirFacturaPdf(datosNC, payloadNC, getParametrosGlobales);
      
      return { success: true, pdfDataUrl };
    } catch (error) {
      console.error("Error generando PDF AFIP de Nota de Crédito:", error);
      throw error;
    }
  };

  // ============================================================================
  // PORTAL DE CLIENTES - Funciones para autogestión de clientes
  // ============================================================================

  /**
   * Login de cliente con DNI/CUIT/CUIL
   */
  const loginCliente = async (dniCuitCuil, tenant) => {
    try {
      const response = await axios.post(
        `${serverURL}/api/cliente-portal/login`,
        { dniCuitCuil, tenant }
      );
      return response.data;
    } catch (error) {
      console.error("Error en login de cliente:", error);
      throw error;
    }
  };

  /**
   * Verificar si la sesión del cliente es válida
   */
  const verificarSesionCliente = async () => {
    try {
      const token = localStorage.getItem('clienteToken');
      if (!token) return false;

      const response = await axios.get(
        `${serverURL}/api/cliente-portal/verificar-sesion`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      return response.data.valid;
    } catch (error) {
      console.error("Error verificando sesión de cliente:", error);
      return false;
    }
  };

  /**
   * Obtener paquetes del cliente autenticado
   */
  const getMisPaquetesCliente = async () => {
    try {
      const token = localStorage.getItem('clienteToken');
      if (!token) throw new Error('No hay token de cliente');

      const response = await axios.get(
        `${serverURL}/api/cliente-portal/mis-paquetes`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo paquetes del cliente:", error);
      throw error;
    }
  };

  /**
   * Obtener cuotas de un paquete específico
   */
  const getMisCuotasCliente = async (idItem, idUbicacion) => {
    try {
      const token = localStorage.getItem('clienteToken');
      if (!token) throw new Error('No hay token de cliente');

      const response = await axios.get(
        `${serverURL}/api/cliente-portal/mis-cuotas/${idItem}/${idUbicacion}`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo cuotas del cliente:", error);
      throw error;
    }
  };

  /**
   * Crear preferencia de pago de Mercado Pago para una cuota
   */
  const crearPreferenciaPagoCliente = async (idCuentaCorriente) => {
    try {
      const token = localStorage.getItem('clienteToken');
// console.log("token:", token);
      if (!token) {
        throw new Error('No hay sesión de cliente activa');
      }

      const response = await axios.post(
        `${serverURL}/api/cliente-portal/crear-preferencia-pago`,
        { idCuentaCorriente },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;

    } catch (error) {
      console.error('Error al crear preferencia de pago:', error);

      // Manejar errores específicos
      if (error.response) {
        const status = error.response.status;
        const message = error.response.data?.error || 'Error al crear preferencia de pago';

        if (status === 401 || status === 403) {
          // Sesión expirada o no autorizado
          localStorage.removeItem('clienteToken');
          window.location.href = '/mispagos/login';
          throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
        } else if (status === 400) {
          // Error de validación (ej: cuota ya pagada, no es la siguiente)
          throw new Error(message);
        } else if (status === 429) {
          // Rate limit
          throw new Error('Demasiados intentos. Por favor, espera un momento.');
        }
      }

      throw new Error('Error al crear preferencia de pago. Por favor, intenta nuevamente.');
    }
  };

  /**
   * Obtener parámetros globales para el portal de clientes
   */
  const getParametrosGlobalesCliente = async (parametros = []) => {
    try {
      const token = localStorage.getItem('clienteToken');
      if (!token) throw new Error('No hay token de cliente');

      const params = new URLSearchParams();
      if (Array.isArray(parametros) && parametros.length > 0) {
        params.append('parametros', JSON.stringify(parametros));
      }

      const response = await axios.get(
        `${serverURL}/api/cliente-portal/parametros-globales?${params.toString()}`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      
      return response.data;
    } catch (error) {
      console.error("Error obteniendo parámetros globales del cliente:", error);
      throw error;
    }
  };

  // ============================================================================

  // item proveedor ***********************************************************************

  const postItemProveedor = async (idItem, idEntidad, costo) => {
    try {
      await axios.post(serverURL + "/itemAPI/postItemProveedor", {
        idItem: idItem,
        idEntidad: idEntidad,
        costo: costo,
      });
    } catch (error) {
      console.error("Error creating transaccion impuestos:", error);
    }
  };

  const getItemProveedor = async (idItem, idEntidad) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/getItemProveedor/${idItem}/${idEntidad}`,
      );
      return response.data; // Verifica que la respuesta esté correctamente formateada
    } catch (error) {
      console.error("Error al obtener el item proveedor:", error);
      return null; // En caso de error, retorna null para que el código sepa que no existe
    }
  };

  const updateItemProveedor = async (idItem, idEntidad, costo) => {
    try {
      await axios.put(
        serverURL + `/itemAPI/uptdateItemProveedor/${idItem}/${idEntidad}`,
        {
          costo: costo,
        },
      );
    } catch (error) {
      console.error("Error creating transaccion impuestos:", error);
    }
  };

  const updateItemPrecioListaId = async (
    idItem,
    idEntidad,
    idUbicacion,
    monto,
    tipoAjuste,
  ) => {
    // console.log("Datos enviados:", idItem, idEntidad, idUbicacion, monto, tipoAjuste);
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/updateItemPrecioListaId`,
        {
          idItem,
          idEntidad,
          idUbicacion,
          monto,
          tipoAjuste,
        },
      );
    } catch (error) {
      console.error("Error al crear el registro:", error);
      alert("Hubo un error al crear el registro.");
    }
  };

  const updatePreciosListaMultiple = async (idEntidades, monto, tipoAjuste, filtros = null) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/updatePreciosListaMultiple`,
        {
          idEntidades,
          monto,
          tipoAjuste,
          filtros, // Pasar filtros al backend
        },
      );

      // console.log("Nuevos registros creados:", response.data);
      const mensaje = filtros?.hayFiltrosActivos
        ? `Se actualizaron los precios de los productos filtrados para ${idEntidades.length} entidades.`
        : `Se actualizaron los precios de TODOS los productos para ${idEntidades.length} entidades.`;
      alert(mensaje);
    } catch (error) {
      console.error("Error al actualizar los precios:", error);
      alert("Hubo un error al actualizar los precios.");
    }
  };

  const updateAllPrices = async (tipoAjuste, valor) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/updateAllPrices`,
        {
          tipoAjuste, // "porcentaje" o "valor"
          valor, // Valor ingresado en el campo
        },
      );

      // console.log("Precios actualizados:", response.data);
      alert("Todos los precios han sido actualizados correctamente.");
    } catch (error) {
      console.error("Error al actualizar los precios:", error);
      alert("Hubo un error al actualizar los precios.");
    }
  };

  // Nueva función para actualizar precios respetando filtros actuales
  const updateFilteredPrices = async (
    tipoAjuste, 
    valor, 
    idEntidad, 
    idItem, 
    idUbicacion, 
    idTipoEntidad, 
    soloUltimos, 
    searchText, 
    incluirItemsSinPrecio,
    filtrosAtributos = {} // NUEVO: Filtros por atributos dinámicos  
    ) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/updateFilteredPrices`,
        {
          tipoAjuste,
          valor,
          idEntidad,
          idItem,
          idUbicacion,
          idTipoEntidad,
          soloUltimos: soloUltimos ? "true" : "false",
          searchText,
          incluirItemsSinPrecio: incluirItemsSinPrecio ? "true" : "false",
          filtrosAtributos: filtrosAtributos // NUEVO: Enviar filtros de atributos
        },
      );

// console.log("Precios filtrados actualizados:", response.data);
      alert(`${response.data.message || "Los precios han sido actualizados correctamente."}`);
    } catch (error) {
      console.error("Error al actualizar los precios filtrados:", error);
      const errorMsg = error.response?.data?.message || "Hubo un error al actualizar los precios.";
      alert(errorMsg);
    }
  };

  const copiarPreciosEntreEntidades = async (idCopiar, idPegar) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/copiarPreciosEntreEntidades`,
        {
          idCopiar,
          idPegar,
        },
      );
      // console.log("Precios copiados:", response.data);
      alert("Los precios han sido copiados correctamente.");
    } catch (error) {
      console.error("Error al copiar los precios:", error);
      alert("Hubo un error al copiar los precios.");
    }
  };

  // Función para obtener los ítems del proveedor
  const getListaMontosByEntidad = async (
    idEntidad,
    idItem,
    idUbicacion,
    idTipoEntidad,
    page,
    limit,
    soloUltimos,
    searchText, // Nuevo parámetro para búsqueda múltiple
    incluirItemsSinPrecio = false, // Nuevo parámetro para incluir items sin precio
    filtrosAtributos = {}, // NUEVO: Filtros por atributos dinámicos
  ) => {
    try {
      // Realizamos la petición GET para obtener los ítems asociados a ese proveedor
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getListaMontosByEntidad`,
        {
          params: {
            idEntidad: idEntidad || null,
            idItem: idItem || null,
            idUbicacion: idUbicacion || null,
            idTipoEntidad,
            page,
            limit,
            soloUltimos: soloUltimos ? "true" : "false",
            searchText: searchText || null, // Agregar parámetro de búsqueda
            incluirItemsSinPrecio: incluirItemsSinPrecio ? "true" : "false", // Nuevo parámetro
            filtrosAtributos: JSON.stringify(filtrosAtributos), // NUEVO: Enviar filtros de atributos como JSON
          },
        },
      );
      return response.data; // Devuelve los ítems encontrados
    } catch (error) {
      console.error("Error al obtener los ítems del proveedor:", error);
      return [];
    }
  };

  const getListaMontosByIdItem = async (idItem) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getListaMontosByIdItem`,
        {
          params: { idItem: idItem || null }, // Enviar como Query Param
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener las listas de montos:", error);
      return [];
    }
  };

  const getListaMontosByIdItemIdEntidad = async (
    idEntidad,
    idItem,
    idUbicacion,
  ) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getListaMontosByIdItemIdEntidad`,
        {
          params: { idEntidad, idItem, idUbicacion }, // Enviar como Query Param
        },
      );
      return response.data;
    } catch (error) {
      // Solo mostrar error si NO es 404 (404 es esperado cuando no hay precio configurado)
      if (error.response?.status !== 404) {
        console.error("Error al obtener las listas de montos:", error);
      }
      return [];
    }
  };

  const updateListaDeMonto = async ({
    idItem,
    idUbicacion,
    idEntidad,
    monto,
  }) => {
    try {
      // console.log(idItem, idUbicacion, idEntidad, monto)
      const response = await axios.post(
        `${serverURL}/transaccionAPI/updateListaDeMonto`,
        {
          idItem,
          idUbicacion,
          idEntidad,
          monto,
        },
      );
      // console.log("Respuesta del nuevo registro:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error al crear la lista de montos:", error);
      throw error;
    }
  };

  // Actualizar múltiples precios en batch para mejor performance
  const updateListaDeMontoBatch = async (updates) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/updateListaDeMontoBatch`,
        { updates }
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar lista de montos en batch:", error);
      throw error;
    }
  };

  const getCajaByMedioDePago = async ({
    startDate,
    endDate,
    medioDePagoId,
    tipoMedioDePagoId,
  }) => {
    try {
      // console.log(idItem, idUbicacion, idEntidad, monto)
      const data = await axios.get(
        `${serverURL}/transaccionAPI/getCajaByMedioDePago`,
        { params: { startDate, endDate, medioDePagoId, tipoMedioDePagoId } },
      );
      return data; // { movimientos, caja }
    } catch (error) {
      console.error("Error al crear la lista de montos:", error);
      throw error;
    }
  };

  // Actualizar el estado (activo/inactivo)
  const updateImpuestoEstado = async (impuestosEliminados) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/updateImpuestoEstado/`,
        {
          impuestosEliminados,
        },
      );
      alert("Estado del impuesto actualizado correctamente.");
      getImpuestos(); // Refrescar la lista
    } catch (error) {
      console.error("Error al actualizar el estado del impuesto:", error);
    }
  };

  // Modificar nombre y porcentaje del impuesto
  const updateImpuestoContenido = async (
    id,
    descripcion,
    porcentaje,
    checkedState,
  ) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/updateImpuestoContenido/${id}`,
        { descripcion, porcentaje, checkedState },
      );
      alert("Impuesto actualizado correctamente.");
      getImpuestos(); // Refrescar la lista
    } catch (error) {
      console.error("Error al actualizar el impuesto:", error);
    }
  };

  // Obtener el impuesto de un item específico
  const getImpuestoItem = async (idItem) => {
    try {
      const response = await axios.get(
        `${serverURL}/itemAPI/getImpuestoItem/${idItem}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener impuesto del item:", error);
      return {
        idItem: parseInt(idItem),
        idImpuesto: null,
        porcentaje: 21,
        descripcionImpuesto: "IVA General",
      };
    }
  };

  // Actualizar el impuesto de un item
  const updateImpuestoItem = async (idItem, idImpuesto, porcentaje) => {
    try {
      const response = await axios.put(
        `${serverURL}/itemAPI/updateImpuestoItem/${idItem}`,
        { idImpuesto, porcentaje },
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar impuesto del item:", error);
      throw error;
    }
  };

  // Obtener todos los impuestos disponibles
  const getImpuestosDisponibles = async () => {
    try {
      const response = await axios.get(
        `${serverURL}/itemAPI/getImpuestosDisponibles`,
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener impuestos disponibles:", error);
      return [];
    }
  };

  const getCondicionIvaByIdEntidad = async (idEntidad) => {
    try {
// console.log("idEntidad ", idEntidad);
      const response = await axios.get(
        `${serverURL}/adminAPI/getCondicionIvaByEntidad/${idEntidad}`,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error al obtener condición de IVA por ID de entidad:",
        error,
      );
      return null;
    }
  };

  // Función para obtener los impuestos válidos de AFIP para Argentina
  const getIvaAFIP = () => {
    return [
      {
        id: 1,
        idIva: 1,
        descripcion: "IVA 0%",
        porcentaje: 0,
        ivaAFIP: 3,
      },
      {
        id: 2,
        idIva: 1,
        descripcion: "IVA 10.5%",
        porcentaje: 10.5,
        ivaAFIP: 4,
      },
      {
        id: 3,
        idIva: 1,
        descripcion: "IVA 21%",
        porcentaje: 21,
        ivaAFIP: 5,
      },
      // {
      //   id: 4,
      //   idIva: 1,
      //   descripcion: "IVA 27%",
      //   porcentaje: 27,
      //   ivaAFIP: 6
      // },
      // {
      //   id: 5,
      //   idIva: 1,
      //   descripcion: "IVA 5%",
      //   porcentaje: 5,
      //   ivaAFIP: 8
      // },
      // {
      //   id: 6,
      //   idIva: 1,
      //   descripcion: "IVA 2.5%",
      //   porcentaje: 2.5,
      //   ivaAFIP: 9
      // }
    ];
  };

  // LOGICA NAVBAR ***********************************************************************
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(false); // Estado del tamaño del navbar

  // FACTURA PDF ***********************************************************************

  // Helper function to format numbers in ARS currency format
  const formatARS = (number) => {
    return Number(number).toLocaleString("es-AR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 3,
    });
  };

  const formatearFechaAfip = (fecha = new Date()) => {
    const fechaBase = fecha instanceof Date ? fecha : new Date(fecha)

    return Number(
      `${fechaBase.getFullYear()}${String(fechaBase.getMonth() + 1).padStart(2, "0")}${String(
        fechaBase.getDate(),
      ).padStart(2, "0")}`,
    )
  }

  const crearPayloadFacturaAfip = async ({
    tipoFacturaId,
    total,
    items,
    rawDoc,
    cuitGlobal = "",
    idCondicionIva = null,
    puntoVenta,
    descripcionEntidad = "",
    apellidoEntidad = "",
    telefono = "",
    email = "",
    direccion = "",
    localidad = "",
    provincia = "",
    idTransaccion,
    descripcionOverride = "",
    fechaEmision = new Date(),
    idMedioDePago = null,
  }) => {
    const datosDocumento = resolverDatosDocumentoAfip({
      tipoFacturaId,
      rawDoc,
      cuitGlobal,
    })

    if (datosDocumento.error) {
      throw new Error(datosDocumento.error)
    }

    const { neto, iva, ivaDetallado } = calcularTotalesFacturaAfip({
      tipoFacturaId,
      total,
      items,
      ivaAFIP: getIvaAFIP(),
    })

    const docTipoFinal = datosDocumento.docTipo
    const docNroFinal = datosDocumento.docNro
    const condicionIvaReceptorId = resolverCondicionIvaReceptor({
      idCondicionIva,
      docTipo: docTipoFinal,
    })
    const cbteTipo = FACTURA_ID_TO_CBTE[tipoFacturaId]

    if (!cbteTipo) {
      throw new Error("Tipo de comprobante invalido")
    }

    // Resolver condicionVenta e idFormaPagoAfip desde el medio de pago
    let condicionVenta = "CONTADO"
    let idFormaPagoAfip = null
    if (idMedioDePago) {
      const medio = await getMedioDePagoById(idMedioDePago)
      if (medio) {
        const idTipo = medio.idTipoMedioDePago ?? medio.tipo?.id
        const descripcion = medio.descripcion ?? medio.tipo?.descripcion ?? ""
        const formaPago = getFormaPagoAfip(idTipo, descripcion)
        if (formaPago) {
          condicionVenta = formaPago.label
          idFormaPagoAfip = formaPago.codigoAfip
        }
      }
    }

    return {
      PtoVta: puntoVenta,
      CbteTipo: cbteTipo,
      Concepto: 1,
      DocTipo: docTipoFinal,
      DocNro: docNroFinal,
      CbteDesde: null,
      CbteHasta: null,
      CbteFch: formatearFechaAfip(fechaEmision),
      ImpTotal: Number(total || 0),
      ImpTotConc: 0,
      ImpNeto: neto,
      ImpOpEx: 0,
      ImpIVA: iva,
      ImpTrib: 0,
      MonId: "PES",
      MonCotiz: 1,
      CondicionIVAReceptorId: condicionIvaReceptorId,
      ...(cbteTipo !== 11 ? { Iva: ivaDetallado } : {}),
      ItemsList: construirItemsAfip(items, descripcionOverride),
      DniCuitCliente: datosDocumento.documento,
      ApellidoNombre: `${descripcionEntidad || ""} ${apellidoEntidad || ""}`.trim(),
      nombreCliente: descripcionEntidad || "",
      apellidoCliente: apellidoEntidad || "",
      telefonoCliente: telefono || "",
      emailCliente: email || "",
      direccionCliente: direccion || "",
      localidadCliente: localidad || "",
      provinciaCliente: provincia || "",
      idTipoFacturaTransaccion: tipoFacturaId,
      idTransaccion,
      idCondicionIva: condicionIvaReceptorId,
      abrirPdf: false,
      descripcion: descripcionOverride || "",
      condicionVenta,
      ...(idFormaPagoAfip != null && { idFormaPagoAfip }),
    }
  }

  const crearYFacturarVentaManualAfip = async ({
    idEntidad,
    idItemServicio,
    idUbicacion,
    idMedioDePago,
    idTipoFactura,
    montoTotal,
    items,
    serviciosAdicionales = [],
    descripcionServicio,
    idUsuario,
    fechaEmision = new Date(),
    puntoVentaAfip,
  }) => {
    const entidadFactura = await getEntidadByID(idEntidad)

    if (!entidadFactura?.id) {
      throw new Error("No se pudo obtener la entidad para facturar")
    }

    const itemsList = Array.isArray(items) && items.length > 0 ? items : []
    const adicionalesList = Array.isArray(serviciosAdicionales) ? serviciosAdicionales : []

    const sumaItems = itemsList.reduce((sum, it) => sum + Number(it.monto || 0), 0)
    const sumaAdicionales = adicionalesList.reduce((sum, s) => sum + Number(s.monto || 0), 0)
    const montoTotalFinal = sumaItems + sumaAdicionales

    if (itemsList.length === 0 && adicionalesList.length === 0) {
      throw new Error("Debe indicar al menos un servicio o servicio adicional")
    }

    const itemsFactura = []

    for (const it of itemsList) {
      const servicioEncontrado = await getItemById(it.idItem)

      if (!servicioEncontrado?.id) {
        throw new Error(`No se pudo obtener el servicio seleccionado (id: ${it.idItem})`)
      }

      if (servicioEncontrado.esServicio !== true) {
        throw new Error("Solo se pueden facturar servicios en este flujo")
      }

      const impuestoItem = await getImpuestoItem(it.idItem).catch(() => null)
      itemsFactura.push({
        idItem: servicioEncontrado.id,
        codigo: servicioEncontrado.codigo,
        descripcion: servicioEncontrado.descripcion || servicioEncontrado.descripcionServicio || "",
        descripcionServicio: servicioEncontrado.descripcionServicio || "",
        cantidad: 1,
        unidad: "Unidad",
        precio: Number(it.monto || 0),
        porcentajeDescuento: 0,
        impuestoData: impuestoItem
          ? { ...impuestoItem, porcentaje: Number(impuestoItem.porcentaje ?? impuestoItem.porcentajeImpuesto ?? 21) }
          : { porcentaje: 21 },
      })
    }

    for (let i = 0; i < adicionalesList.length; i++) {
      const s = adicionalesList[i]
      const ivaPorc = Number(s.porcentajeIva ?? 21)
      itemsFactura.push({
        idItem: null,
        codigo: `ADICIONAL-${i + 1}`,
        descripcion: s.descripcion || "",
        descripcionServicio: s.descripcion || "", 
        cantidad: 1,
        unidad: "Unidad",
        precio: Number(s.monto || 0),
        porcentajeDescuento: 0,
        impuestoData: { porcentaje: ivaPorc },
      })
    }

    const condicionIvaEntidad = await getCondicionIvaByIdEntidad(idEntidad)

    // 1) Primero facturar en AFIP (sin crear transacción). Si falla, no se registra nada.
    const pvAfip = puntoVentaAfip || idUbicacion
    const afipPayload = await crearPayloadFacturaAfip({
      tipoFacturaId: idTipoFactura,
      total: montoTotalFinal,
      items: itemsFactura,
      rawDoc: entidadFactura?.dniCuitCuil || "",
      idCondicionIva: condicionIvaEntidad?.idCondicionIva || entidadFactura?.idCondicionIva || null,
      puntoVenta: pvAfip,
      descripcionEntidad: entidadFactura?.descripcion || "",
      apellidoEntidad: entidadFactura?.apellido || "",
      telefono: entidadFactura?.telefono || "",
      email: entidadFactura?.email || "",
      direccion: entidadFactura?.direccion || "",
      localidad: entidadFactura?.localidad || "",
      provincia: entidadFactura?.provincia || "",
      idTransaccion: null,
      descripcionOverride: "",
      fechaEmision,
      idMedioDePago,
    })

    const afipData = await enviarFacturaAfipSolo({
      ...afipPayload,
      subtotal: afipPayload.ImpNeto,
      iva: afipPayload.ImpIVA,
      puntoVenta: pvAfip,
    })

    // 2) Solo si AFIP autorizó: crear transacción, pago e items en el sistema
    const transaccionResponse = await postTransaccion(
      montoTotalFinal,
      11, // Factura Arca (informativo, no afecta ventas/ingresos/gastos)
      idEntidad,
      null,
      descripcionServicio || "",
      idUsuario,
      idUbicacion,
      1,
      0,
      0,
      null,
      fechaEmision,
    )

    const idTransaccion = transaccionResponse?.data?.id

    if (!idTransaccion) {
      throw new Error("No se pudo crear la transaccion de la factura")
    }

    const pagoResponse = await postCrearPago(1, 1, idMedioDePago, montoTotalFinal)
    const idPago = pagoResponse?.data?.id

    if (!idPago) {
      throw new Error("No se pudo crear el pago de la factura")
    }

    await postTransaccionPago(idTransaccion, idPago)
    for (const it of itemsList) {
      await postTransaccionItem(idTransaccion, it.idItem, 1, it.monto, 0)
    }

    await postTransaccionTipoFactura(
      afipPayload.idTipoFacturaTransaccion,
      idTransaccion,
      afipData.cae,
      afipData.vto,
      afipPayload.idCondicionIva,
      afipData.cbteNro,
      afipPayload.PtoVta || afipPayload.puntoVenta,
      afipData.fechaEmision || String(afipPayload.CbteFch),
    )

    // Registrar IVA por alícuota en cuentas (impuesto 21% id 1, 10.5% id 2, 0% id 3)
    const PORCENTAJE_TO_ID_IMPUESTO = { 21: 1, 10.5: 2, 0: 3 }
    const ivaByPorcentaje = {}
    for (const item of itemsFactura) {
      const p = Number(item.impuestoData?.porcentaje ?? 21)
      const precio = Number(item.precio || 0) * (item.cantidad || 1)
      if (p === 0) continue
      const base = precio / (1 + p / 100)
      const iva = base * (p / 100)
      ivaByPorcentaje[p] = (ivaByPorcentaje[p] || 0) + iva
    }
    for (const [porcentajeStr, montoIva] of Object.entries(ivaByPorcentaje)) {
      const porcentaje = Number(porcentajeStr)
      const idImpuesto = PORCENTAJE_TO_ID_IMPUESTO[porcentaje] ?? 1
      if (montoIva > 0) {
        await postTransaccionImpuesto(idTransaccion, idImpuesto, porcentaje, montoIva)
      }
    }

    // 3) Abrir PDF si corresponde
    if (afipPayload.abrirPdf === true) {
      try {
        await abrirFacturaHtml(
          afipData,
          { ...afipPayload, idTransaccion },
          getParametrosGlobales,
        )
      } catch (err) {
        console.error("Error al generar PDF de factura:", err)
      }
    }

    return {
      afipData,
      afipPayload,
      entidadFactura,
      itemsFactura,
      transaccionData: {
        ...(transaccionResponse?.data || {}),
        id: idTransaccion,
        idEntidad,
        idUbicacion,
        montoTotal: Number(montoTotalFinal || 0),
        descripcion: descripcionServicio,
        fecha: fechaEmision,
        fechaHoraCreacion: fechaEmision,
        idTipoFacturaTransaccion: idTipoFactura,
      },
    }
  }

  /** Solo envía a AFIP y devuelve { cae, vto, cbteNro }. No guarda nada en BD. */
  async function enviarFacturaAfipSolo(payload) {
    try {
      const res = await axios.post(`${serverURL}/api/afip/invoice`, payload)
      const data = res.data
      if (data?.success === false && data?.error) {
        throw new Error(data.error)
      }
      return data
    } catch (err) {
      const data = err?.response?.data
      const msg =
        (typeof data === "string" && data) ||
        data?.error ||
        data?.message ||
        err?.message ||
        "Error al facturar en AFIP"
      throw new Error(msg)
    }
  }

  async function enviarFacturaAfip(payload) {
    const data = await enviarFacturaAfipSolo(payload)

    await postTransaccionTipoFactura(
      payload.idTipoFacturaTransaccion,
      payload.idTransaccion,
      data.cae,
      data.vto,
      payload.idCondicionIva,
      data.cbteNro,
      payload.PtoVta || payload.puntoVenta,
      data.fechaEmision || String(payload.CbteFch),
    )

    if (payload.abrirPdf === true) {
      try {
        await abrirFacturaHtml(data, payload, getParametrosGlobales)
      } catch (error) {
        console.error("Error al generar PDF de factura:", error)
      }
    }

    return data
  }

  // ─── Puntos de Venta AFIP ─────────────────────────────────────────
  const getAfipSalesPoints = async (refresh = false) => {
    const url = refresh
      ? `${serverURL}/api/afip/sales-points?refresh=true`
      : `${serverURL}/api/afip/sales-points`;
    const response = await axios.get(url);
    return response.data;
  };

  const createAfipSalesPoint = async (nombreFantasia) => {
    const response = await axios.post(`${serverURL}/api/afip/create-sales-point`, { nombreFantasia });
    return response.data;
  };

  //##############################################################################################################################
  //##############################################################################################################################
  //##############################################################################################################################
  // SIRE — Retenciones ARCA (HTTP /retencionesAPI/retenciones*)
  //
  // Altas e “Informar SIRE” contra retencionesRoutes.js. axios ya usa withCredentials
  // vía interceptor (cookies tenant / usuario).
  const getRetencionesRegimenes = async () => {
    return axios.get(`${serverURL}/retencionesAPI/retenciones/regimenes`);
  };

  const postRetencionSire = async (payload) => {
    return axios.post(`${serverURL}/retencionesAPI/retenciones`, payload);
  };

  const postInformarRetencionSire = async (idTransaccion) => {
    return axios.post(
      `${serverURL}/retencionesAPI/retenciones/${idTransaccion}/informar-sire`,
      {},
    );
  };

  /** Dry-run: genera el payload SIRE sin enviarlo a AFIP. */
  const postDryRunSire = async (idTransaccion) => {
    return axios.post(
      `${serverURL}/retencionesAPI/retenciones/${idTransaccion}/informar-sire?dryRun=true`,
      {},
    );
  };

  /** Intenta autorizar sire-ws via automatización AFIP SDK (experimental). */
  const postAuthorizeSire = async () => {
    return axios.post(`${serverURL}/retencionesAPI/retenciones/authorize-sire`, {});
  };

  /** Llama al método dummy de sire-ws para verificar si está habilitado. */
  const postDummySire = async () => {
    return axios.post(`${serverURL}/retencionesAPI/retenciones/dummy-sire`, {});
  };

  // Función para calcular el subtotal con o sin descuento
  const calcularSubtotal = (items, vieneDe = null) =>
    items.reduce((sum, item) => {
      const precio = item.precio || 0;
      const cantidad =
        vieneDe == "devolucion"
          ? item.cantidadDevolver || 0
          : item.cantidad || 0;
      const descuento = item.porcentajeDescuento
        ? 1 - item.porcentajeDescuento / 100
        : 1;

      // console.log(sum + precio * cantidad * descuento);
      return sum + precio * cantidad * descuento;
    }, 0);

    const generarFacturaPDF = async (
      transaccionData,
      itemsTransaccion,
      entidades,
      tipoDeFactura,
      impuestos,
      deDondeViene = null,
      returnBase64 = false,
    ) => {
      
      const beigeBackground = [240, 235, 225]
      const darkNavy = [26, 26, 26]
      const orangeAccent = [245, 166, 35]
      const WHITE = [255, 255, 255]
      const TEXT_BLACK = [0, 0, 0]
      // ===========================================
      // PASO 1: INICIALIZACIÓN Y CONFIGURACIÓN BASE
      // ===========================================
      
      // Crear instancia del documento PDF
      const doc = new jsPDF();
      
      // Obtener dimensiones de la página para cálculos de layout
      const pageWidth  = doc.internal.pageSize.getWidth();   // Ancho total de la página
      const pageHeight = doc.internal.pageSize.getHeight();  // Alto total de la página
    
      // ===========================================
      // PASO 2: OBTENER DATOS EXTERNOS (LOGO Y CONFIGURACIÓN)
      // ===========================================
      
      // Obtener logo de la empresa desde la base de datos
      const logoURLbase64 = await axios.get(serverURL + `/adminAPI/logoURLbase64`);
// console.log("[PDF] logoURLbase64 fetched");
      const logoURLBD = logoURLbase64.data.logoURL.valorParametro;
    
      // Obtener parámetros globales del sistema (dirección y teléfono)
      const parametrosGlobales = await getParametrosGlobales([
        "afipsdk_domicilio",
        "afipsdk_telefono",
      ]);
      
      // Extraer datos de configuración con valores por defecto
      const direccion = parametrosGlobales.afipsdk_domicilio || "Dirección no configurada";
      const telefono  = parametrosGlobales.afipsdk_telefono  || "Teléfono no configurado";
    
      // ===========================================
      // PASO 3: CONFIGURACIÓN DE IMAGEN Y HEADER
      // ===========================================
      
      // Detectar formato de imagen del logo (PNG o JPEG)
      let imgFormat = "PNG";
      if (typeof logoURLBD === "string") {
        if (/^data:image\/jpe?g;base64,/i.test(logoURLBD)) imgFormat = "JPEG";
        else if (/^data:image\/png;base64,/i.test(logoURLBD)) imgFormat = "PNG";
      }
      
      // Agregar logo en la esquina superior izquierda
      // Posición: x=10, y=10, ancho=70px, alto=40px
      try { 
        doc.addImage(logoURLBD, imgFormat, 10, 10, 70, 40); 
      } catch(e){ 
        console.error("[PDF] Error adding logo image:", e); 
      }
    
      // ===========================================
      // PASO 4: INFORMACIÓN DEL DOCUMENTO (ESQUINA SUPERIOR DERECHA)
      // ===========================================
      
      // Título del documento según el tipo (Factura, Presupuesto, etc.) - más compacto
      doc.setFontSize(12);  // Reducido de 14 a 12
      if (deDondeViene === "devolucion")       doc.text(`Devolución Nº ${transaccionData.id}`, 100, 20);  // Y reducido de 23 a 20
      else if (deDondeViene === "presupuesto") doc.text(`Presupuesto Nº ${transaccionData.id}`, 100, 20);
      else if (deDondeViene === "compra")      doc.text(`Compra Nº ${transaccionData.id}`, 100, 20);
      else                                     doc.text(`Factura Nº ${transaccionData.id}`, 100, 20);
    
      // Información de la empresa (dirección, teléfono, fecha) - más compacto
      doc.setFontSize(8);  // Reducido de 10 a 8
      doc.text(`Dirección: ${direccion}`, 100, 26);  // Y reducido de 31 a 26
      doc.text(`Teléfono: ${telefono}`,   100, 32);  // Y reducido de 39 a 32
      doc.text(`Fecha: ${new Date().toLocaleDateString()}`, 100, 38);  // Y reducido de 47 a 38
    
      // ===========================================
      // PASO 5: INFORMACIÓN DEL CLIENTE/DESTINATARIO
      // ===========================================
      
      // Títulos de sección - más compacto
      doc.setFontSize(10);  // Reducido de 12 a 10
      doc.setFont("Helvetica", "bold");
      doc.text("Destinatario", 10, 50);                    // Título izquierda (Y reducido de 55 a 50)
      doc.text(`Información de pago:`, 100, 50);          // Título derecha (Y reducido de 55 a 50)
      
      // Información del cliente (lado izquierdo) - más compacto
      doc.setFont("Helvetica", "normal");
      doc.setFontSize(8);  // Reducido de 12 a 8
      doc.text(`Cliente: ${entidades.descripcion || "N/A"} ${entidades.apellido || ""}`, 10, 55);  // Y reducido de 61 a 55
      doc.text(`DNI/CUIT/CUIL: ${entidades.dniCuitCuil || "N/A"}`, 10, 60);  // Y reducido de 67 a 60
      doc.text(`Domicilio: ${entidades.direccion || "N/A"}`, 10, 65);  // Y reducido de 73 a 65
      doc.text(`${entidades.localidad || "N/A"} - ${entidades.provincia || "N/A"}`, 10, 68);  // Y reducido de 76 a 68
      doc.text(`${entidades.telefono || "N/A"}`, 10, 73);  // Y reducido de 82 a 73
    
      // ===========================================
      // PASO 6: INFORMACIÓN DE PAGOS (LADO DERECHO)
      // ===========================================
      
      // Procesar medios de pago (puede ser array o objeto único)
      const mediosDePago = Array.isArray(transaccionData.pagos)
        ? transaccionData.pagos.map(p => `${p.descripcion}: $${formatARS(p.monto || 0)}`)
        : transaccionData.pagos
          ? [`${transaccionData.pagos.descripcion}: $${formatARS(transaccionData.pagos.monto || 0)}`]
          : ["N/A"];
    
      // Mostrar cada medio de pago en líneas separadas - más compacto
      let currentYPosition = 55;  // Y reducido de 61 a 55
      mediosDePago.forEach((medio) => {
        doc.text(`${medio}`, 100, currentYPosition);
        currentYPosition += 4; // Espaciado reducido entre medios de pago (de 6 a 4)
      });
    
      // ===========================================
      // PASO 7: CALCULAR POSICIÓN DE INICIO DE TABLA
      // ===========================================
      
      // Determinar dónde empezar la tabla basado en el contenido anterior
      // El teléfono del cliente está en Y=73, así que la tabla debe empezar después
      const clienteEndY = 73;  // Última línea del cliente (teléfono)
      let startY = Math.max(clienteEndY + 5, currentYPosition + 5);  // Mínimo 5px después del contenido
    
      // ===========================================
      // PASO 8: CONFIGURACIÓN DE LA TABLA MANUAL
      // ===========================================
      // Esta tabla se dibuja "a mano" para tener control total sobre el diseño
    
      // ========== CONFIGURACIÓN DE DIMENSIONES ==========
      const MARGIN_X = 10;                    // Margen izquierdo de la tabla (reducido para ocupar más ancho)
      const TABLE_W  = pageWidth - MARGIN_X * 2;  // Ancho total de la tabla (página - márgenes)
    
      // ========== ANCHOS DE COLUMNAS (MODIFICAR AQUÍ PARA CAMBIAR PROPORCIONES) ==========
      const COL_W_PRICE = 30;                 // Ancho columna PRECIO (reducido)
      const COL_W_QTY   = 18;                 // Ancho columna CANTIDAD (reducido)
      const COL_W_DISC  = 20;                 // Ancho columna DESCUENTO (reducido)
      const COL_W_TOTAL = 30;                 // Ancho columna TOTAL (reducido)
      const COL_W_DESC  = TABLE_W - (COL_W_PRICE + COL_W_QTY + COL_W_DISC + COL_W_TOTAL); // DESCRIPCIÓN = resto del espacio (más espacio)
    
      // ========== COLORES Y ESTILOS (MODIFICAR AQUÍ PARA CAMBIAR APARIENCIA) ==========
      const HEADER_FILL  = [245, 245, 235];   // Color de fondo del header (beige claro)
      const BORDER_COLOR = [160, 160, 160];   // Color de los bordes (gris medio)
      const TEXT_COLOR   = [0, 0, 0];         // Color del texto (negro)
      const LINE_H       = 6;                 // Altura mínima de cada fila (reducida para menos espacio entre filas)
    
      doc.setTextColor(...TEXT_COLOR);
    
      // ========== FUNCIONES AUXILIARES ==========
      
      // Función para verificar si hay espacio suficiente, si no, crea nueva página
      const ensureSpace = (neededHeight) => {
        if (startY + neededHeight > pageHeight - 40) {
          doc.addPage();
          startY = 30;  // Posición Y en nueva página
        }
      };
    
      // Función para dibujar títulos de sección (ej: "Items Canjeados")
      const drawBlockTitle = (title) => {
        ensureSpace(10);
        doc.setFont("Helvetica", "bold");
        doc.text(title, 100, startY, { align: "center" });  // Centrado en x=100
        startY += 6;  // Avanzar posición Y
        doc.setFont("Helvetica", "normal");
      };
    
      // ========== FUNCIÓN PARA DIBUJAR HEADER DE TABLA ==========
      const drawHeader = () => {
        ensureSpace(14);  // Verificar espacio para header
        
        // Configurar colores y bordes (sin background para ahorrar tinta)
        doc.setDrawColor(...BORDER_COLOR);    // Color de borde
        doc.setLineWidth(0.5);                // Grosor de línea
        // Sin color de fondo para ahorrar tinta al imprimir
    
        // Configurar texto del header
        doc.setFont("Helvetica", "bold");
        doc.setFontSize(8);  // TAMAÑO DE FUENTE DEL HEADER (reducido para ocupar menos espacio)
        
        // ========== TEXTO DE CADA COLUMNA DEL HEADER ==========
        // Posiciones calculadas: MARGIN_X + suma de anchos de columnas anteriores
        doc.text("DESCRIPCIÓN", MARGIN_X + 4, startY + 8);  // Columna 1: Izquierda
        doc.text("PRECIO",     MARGIN_X + COL_W_DESC + COL_W_PRICE - 2, startY + 8, { align: "right" });  // Columna 2: Derecha
        doc.text("CANTIDAD",   MARGIN_X + COL_W_DESC + COL_W_PRICE + COL_W_QTY/2, startY + 8, { align: "center" });  // Columna 3: Centro
        doc.text("DESC.", MARGIN_X + COL_W_DESC + COL_W_PRICE + COL_W_QTY + COL_W_DISC/2, startY + 8, { align: "center" });  // Columna 4: Centro (cambiado a DESC.)
        doc.text("TOTAL",      MARGIN_X + COL_W_DESC + COL_W_PRICE + COL_W_QTY + COL_W_DISC + COL_W_TOTAL - 2, startY + 8, { align: "right" });  // Columna 5: Derecha
    
        // Dibujar borde del header
        doc.rect(MARGIN_X, startY, TABLE_W, 12, "S");  // "S" = solo borde
        startY += 12;  // Avanzar posición Y
        doc.setFont("Helvetica", "normal");
      };
    
      // ========== FUNCIÓN PARA DIBUJAR FILAS DE DATOS ==========
      const drawRows = (rows) => {
        // Configurar fuente pequeña para las filas de datos
        doc.setFontSize(8);  // Tamaño de fuente pequeño para ocupar menos espacio
        
        rows.forEach((r) => {
          // ========== CONFIGURACIÓN DE FILA ==========
          const descMaxWidth = COL_W_DESC - 8;  // Ancho máximo para descripción (con margen)
          const wrapped = doc.splitTextToSize(r.descripcion || "N/A", descMaxWidth);  // Dividir texto largo en líneas
          const rowHeight = Math.max(LINE_H, 4 + (wrapped.length - 1) * 4 + 2);  // Altura de fila reducida (mínimo LINE_H)
  
          ensureSpace(rowHeight + 2);  // Verificar espacio
  
          // ========== DIBUJAR LÍNEA SUPERIOR DE LA FILA ==========
          doc.setDrawColor(...BORDER_COLOR);
          doc.setLineWidth(0.3);  // Grosor de línea de fila
          doc.line(MARGIN_X, startY, MARGIN_X + TABLE_W, startY);
  
          // ========== DIBUJAR CONTENIDO DE CADA COLUMNA ==========
          
          // COLUMNA 1: DESCRIPCIÓN (izquierda, puede ser múltiples líneas)
          let textY = startY + 4;  // Posición Y inicial del texto (reducida)
          wrapped.forEach((line) => {
            doc.text(line, MARGIN_X + 4, textY);  // x = MARGIN_X + 4 (margen interno)
            textY += 4;  // Avanzar Y para siguiente línea (reducido)
          });
  
          // COLUMNA 2: PRECIO (derecha)
          doc.text(String(r.precio || ""), MARGIN_X + COL_W_DESC + COL_W_PRICE - 2, startY + 4, { align: "right" });
          
          // COLUMNA 3: CANTIDAD (centro)
          doc.text(String(r.cantidad || ""), MARGIN_X + COL_W_DESC + COL_W_PRICE + COL_W_QTY/2, startY + 4, { align: "center" });
          
          // COLUMNA 4: DESCUENTO (centro)
          doc.text(String(r.descuento || ""), MARGIN_X + COL_W_DESC + COL_W_PRICE + COL_W_QTY + COL_W_DISC/2, startY + 4, { align: "center" });
          
          // COLUMNA 5: TOTAL (derecha)
          doc.text(String(r.total || ""), MARGIN_X + COL_W_DESC + COL_W_PRICE + COL_W_QTY + COL_W_DISC + COL_W_TOTAL - 2, startY + 4, { align: "right" });
  
          startY += rowHeight;  // Avanzar a siguiente fila
        });
    
        // ========== LÍNEA INFERIOR DE CIERRE DE TABLA ==========
        doc.setDrawColor(...BORDER_COLOR);
        doc.setLineWidth(0.3);
        doc.line(MARGIN_X, startY, MARGIN_X + TABLE_W, startY);
        startY += 10;  // Espacio después de la tabla
      };
    
      // ---- Construcción de filas con TU MISMA LÓGICA (descuento incluido en el total) ----
      const impuestoItems = await getTransaccionImpuestoItems(transaccionData.id);
// console.log("impuestoItems: ", impuestoItems);
    
      let subtotal = 0;
    
      if (deDondeViene === "devolucion") {
        const { itemList = [], itemListCanjeables = [] } = itemsTransaccion;
    
        // Items Canjeados
        const rowsCanjeados = [];
        itemList.forEach((item) => {
          const descuento = Number(item.porcentajeDescuento) || 0;
          const cantidad  = Number(item.cantidad) || 0;
          const precio    = Number(item.precio) || 0;
          const totalFila = cantidad * precio * (1 - descuento / 100);
          if (cantidad !== 0) {
            rowsCanjeados.push({
              descripcion: item.descripcion || "N/A",
              precio:   `$${formatARS(precio)}`,
              cantidad: formatARS(cantidad),
              descuento: `${formatARS(descuento)}%`,
              total:    `$${formatARS(totalFila)}`
            });
          }
        });
    
        // Items Devueltos
        const rowsDevueltos = [];
        itemListCanjeables.forEach((item) => {
          const descuento = Number(item.porcentajeDescuento) || 0;
          const cantidad  = Number(item.cantidadDevolver) || 0;
          const precio    = Number(item.precio) || 0;
          const totalFila = cantidad * precio * (1 - descuento / 100);
          if (cantidad !== 0) {
            rowsDevueltos.push({
              descripcion: item.descripcion || "N/A",
              precio:   `$${formatARS(precio)}`,
              cantidad: formatARS(cantidad),
              descuento: `${formatARS(descuento)}%`,
              total:    `$${formatARS(totalFila)}`
            });
          }
        });
    
        const valor1 = calcularSubtotal(itemList);
        const valor2 = calcularSubtotal(itemListCanjeables, deDondeViene);
        subtotal = valor1 - valor2;
    
        if (rowsCanjeados.length > 0) {
          drawBlockTitle("Items Canjeados");
          drawHeader();
          drawRows(rowsCanjeados);
        }
        if (rowsDevueltos.length > 0) {
          drawBlockTitle("Items Devueltos");
          drawHeader();
          drawRows(rowsDevueltos);
        }
    
      } else {
        const arr = Array.isArray(itemsTransaccion) ? itemsTransaccion : [];
        const impuestosArr = Array.isArray(impuestoItems) ? impuestoItems : [];
    
        const rows = [];
        await Promise.all(
          arr.map(async (item) => {
            const itx = await getTransaccionItemByTransactionAndItem(
              transaccionData.id,
              item.idItem,
            );
    
            const descuento    = Number(item.porcentajeDescuento) || 0;
            const cantidad     = Number(item.cantidad) || 0;
            const precioSinIva = Number(itx?.precio) || 0;
    
            const impItem  = impuestosArr.find(imp => imp.idItem === item.idItem);
            const montoImp = Number(impItem?.montoTotal) || 0;
    
            const precioVisible =
              impItem && deDondeViene === "presupuesto"
                ? precioSinIva + montoImp
                : precioSinIva;
    
            const totalFila = cantidad * precioVisible * (1 - descuento / 100);
    
            rows.push({
              descripcion: item.descripcion || "N/A",
              precio:   `$${formatARS(precioVisible)}`,
              cantidad: formatARS(cantidad),
              descuento: `${formatARS(descuento)}%`,
              total:    `$${formatARS(totalFila)}`
            });
          })
        );
    
        subtotal = calcularSubtotal(arr);
    
        // Render tabla
        drawHeader();
        drawRows(rows);
      }
    
      // ==========
      //  FIN TABLA
      // ==========
    
      // Totales y descuentos (misma lógica)
      const montoDescuento = Number(transaccionData.montoDescuento) || 0;
      const porcentajeDescuento = Number(transaccionData.porcentajeDescuento) || 0;
    
      let totalAntesIVA = subtotal - montoDescuento;
      totalAntesIVA = totalAntesIVA * (1 - porcentajeDescuento / 100);
    
      let totalFinal = totalAntesIVA;
      let totalImpuestos = 0;
    
      let totalsY = startY;
      // espacio para totales
      if (totalsY + 40 > pageHeight - 40) { doc.addPage(); totalsY = 30; }
    
      /*doc.text(
        `Descuento: $${formatARS(montoDescuento)} + ${formatARS(porcentajeDescuento)}%`,
        20,
        totalsY
      );*/
  
      // Sin firma - eliminada para ahorrar espacio
  
      doc.text(
        `Descuento: ${formatARS(porcentajeDescuento)}%`,
        pageWidth - 20,
        totalsY,
        { align: "right" },
      );
  
      // TOTAL sin background, letra negra
      totalsY += 8;  // Reducido de 12 a 8
      doc.setTextColor(...TEXT_BLACK);  // Letra negra
      doc.setFont("Helvetica", "bold");
      doc.setFontSize(11.5);
      const totalMostrar = (tipoDeFactura == true) ? totalAntesIVA : totalFinal;
      doc.text(`TOTAL: $${formatARS(totalMostrar)}`, pageWidth - 20, totalsY, { align: "right" });
    
      // Mensaje adicional para presupuestos
      if (deDondeViene === "presupuesto") {
        doc.setTextColor(...TEXT_BLACK);
        doc.setFont("Helvetica", "normal");
        doc.setFontSize(9);
        doc.text(`Válido por 30 días`, pageWidth - 20, totalsY + 20, { align: "right" });
      }
  
      // restaurar texto negro
        doc.setTextColor(...TEXT_BLACK);
        doc.setFont("Helvetica", "normal");
    
      // QR WhatsApp - más cerca del total
      const qrX = 20;
      const qrY = totalsY + 15;  // Reducido de 50 a 15 para estar más cerca del total
      if (qrY + 60 > pageHeight - 20) { doc.addPage(); }
      // Limpiar el teléfono obtenido de parámetros globales (eliminar espacios, guiones, paréntesis)
      const phoneClean = telefono.replace(/[\s\-\(\)]/g, '');
      const waLink = `https://wa.me/${phoneClean}`;
      const qrDataUrl = await QRCode.toDataURL(waLink, { width: 150 });
    
      doc.addImage(qrDataUrl, "PNG", qrX, qrY, 40, 40);
      doc.setFontSize(9);
      doc.text("Escanea para chatear por WhatsApp", qrX + 50, qrY + 20);
    
      // Footer - Marca de agua del sistema
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);  // Color gris para marca de agua
      doc.setFont("Helvetica", "italic");
      doc.text("LUTENTE CLOUD - sistema de gestión", pageWidth / 2, pageHeight - 10, { align: "center" });
      doc.setTextColor(...TEXT_BLACK);  // Restaurar color negro
      doc.setFont("Helvetica", "normal");  // Restaurar fuente normal
    
    
      // Output
      let result;
      if (returnBase64 === 'blob') {
        const pdfBlob = doc.output('blob');
        result = pdfBlob;
      } else {
        const pdfBase64 = doc.output('datauristring');
// console.log(`[PDF] generated base64 length=${pdfBase64?.length || 0}`);
    
        if (!returnBase64) {
          let fileName
          switch (deDondeViene) {
            case "devolucion":  fileName = `Devolucion_${transaccionData.id}.pdf`; break;
            case "presupuesto": fileName = `Presupuesto_${transaccionData.id}.pdf`; break;
            case "compra":      fileName = `Compra_${transaccionData.id}.pdf`; break;
            default:            fileName = `Factura_${transaccionData.id}.pdf`; break;
          }
          doc.setProperties({ title: fileName, subject: "Comprobante", creator: "Sistema" })
          deliverPdf({ doc, fileName, targetWindow: null })
        }
        result = pdfBase64;
      }
    
      return result;
    };

  const generarRemitoPDF = async (
    transaccionData,
    itemsTransaccion,
    entidades,
    vendedorData,
    tipoDeFactura,
    impuestos,
  ) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const logoURLbase64 = await axios.get(
      serverURL + `/adminAPI/logoURLbase64`,
    );

    const logoURLBD = logoURLbase64.data.logoURL.valorParametro;

    // Obtener parámetros globales para dirección y teléfono
    const parametrosGlobales = await getParametrosGlobales([
      "afipsdk_domicilio",
      "afipsdk_telefono",
    ]);
    const direccion =
      parametrosGlobales.afipsdk_domicilio || "Dirección no configurada";
    const telefono =
      parametrosGlobales.afipsdk_telefono || "Teléfono no configurado";

    const tenant = Cookies.get("tenant"); // Obtén el tenant desde las cookies

    doc.addImage(logoURLBD, "PNG", 10, 10, 70, 40);

    doc.setFontSize(14);
    doc.text("Remito (Ticket no valido como factura)", 100, 15);
    doc.setFontSize(10);
    // Usar parámetros globales dinámicos
    doc.text(`Dirección: ${direccion}`, 100, 23);
    doc.text(`Teléfono: ${telefono}`, 100, 31);
    doc.text(`Fecha: ${new Date().toLocaleDateString()}`, 100, 39);
    doc.text(`Vendedor: ${vendedorData.nombre || "N/A"}`, 100, 47);

    doc.setLineWidth(0.5);
    doc.line(10, 50, pageWidth - 10, 50); // Línea separadora

    // **Información del cliente**
    doc.setFontSize(12);
    doc.setFont("Helvetica", "bold");
    doc.text("Información del Cliente", 20, 60);
    doc.setFont("Helvetica", "normal");
    // console.log(entidades);
    doc.text(
      `Cliente: ${entidades.descripcion || "N/A"} ${entidades.apellido || ""}`,
      20,
      70,
    );
    doc.text(`DNI/CUIT/CUIL: ${entidades.dniCuitCuil || "N/A"}`, 100, 70);
    doc.text(`Condición: Receptor`, 20, 80);
    doc.text(`Domicilio: ${entidades.direccion || "N/A"}`, 100, 80);
    doc.text(
      `${entidades.localidad || "N/A"} - ${entidades.provincia || "N/A"}`,
      105,
      85,
    );

    doc.setFontSize(12);
    doc.setFont("Helvetica", "normal");

    const tableColumn = [
      "#",
      "Código",
      "Descripción",
      "Cantidad",
      "Valor Unitario",
      "Descuento",
      "Subtotal",
    ];
    const tableRows = [];

    let totalCantidad = 0;
    let totalSubtotal = 0;

    itemsTransaccion.forEach((item, index) => {
      const descuento = item.porcentajeDescuento || 0;
      const precioConDescuento =
        (item.cantidad || 0) * (item.precio || 0) * (1 - descuento / 100);

      const itemData = [
        index + 1,
        item.codigo || "N/A",
        item.descripcion,
        item.cantidad || 0,
        `$${(item.precio || 0).toFixed(2)}`,
        `${descuento}%`,
        `$${precioConDescuento.toFixed(2)}`,
      ];
      tableRows.push(itemData);
      totalCantidad += item.cantidad || 0;
      totalSubtotal += precioConDescuento;
    });

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 95,
      styles: {
        fontSize: 10,
        halign: "center",
        cellPadding: 3,
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      headStyles: {
        fillColor: [240, 240, 240],
        textColor: [0, 0, 0],
      },
    });

    // **Totales sectorizados**
    const subtotal = calcularSubtotal(itemsTransaccion);
    const montoDescuento = Number(transaccionData.montoDescuento) || 0;
    const porcentajeDescuento =
      Number(transaccionData.porcentajeDescuento) || 0;

    let totalAntesIVA = subtotal - montoDescuento;
    totalAntesIVA = totalAntesIVA * (1 - porcentajeDescuento / 100);
    const iva = totalAntesIVA * 0.21;
    const totalFinal = totalAntesIVA + iva;

    const totalsY = doc.lastAutoTable.finalY + 10;
    doc.setDrawColor(0);
    doc.setFillColor(250, 250, 250);
    doc.rect(10, totalsY, pageWidth - 20, 40, "FD");

    doc.setFont("Helvetica", "bold");
    doc.text(`Subtotal: $${subtotal.toFixed(2)}`, 20, totalsY + 10);
    doc.text(
      `Descuento: $${montoDescuento.toFixed(2)} + ${porcentajeDescuento}%`,
      20,
      totalsY + 20,
    );
    if (tipoDeFactura == true) {
      doc.text(
        `Total a Pagar: $${totalAntesIVA.toFixed(2)}`,
        pageWidth - 20,
        totalsY + 10,
        { align: "right" },
      );
    } else {
      doc.text(
        `Total antes de IVA: $${totalAntesIVA.toFixed(2)}`,
        pageWidth - 20,
        totalsY + 10,
        { align: "right" },
      );
      doc.text(`IVA (21%): $${iva.toFixed(2)}`, pageWidth - 20, totalsY + 20, {
        align: "right",
      });
      doc.text(
        `Total a Pagar: $${totalFinal.toFixed(2)}`,
        pageWidth - 20,
        totalsY + 30,
        { align: "right" },
      );
    }

    // **Generar QR localmente**
    const qrX = 20;
    const qrY = totalsY + 50;
    // Limpiar el teléfono obtenido de parámetros globales (eliminar espacios, guiones, paréntesis)
    const phoneClean = telefono.replace(/[\s\-\(\)]/g, '');
    const waLink = `https://wa.me/${phoneClean}`;
    // **Simulación del código QR**
    const qrDataUrl = await QRCode.toDataURL(waLink, { width: 150 });

    // Lo añades directo
    doc.addImage(qrDataUrl, "PNG", qrX, qrY, 40, 40);
    doc.setFontSize(9);
    doc.text("Escanea para chatear por WhatsApp", qrX + 50, qrY + 20);

    // **Firma o mensaje final**
    doc.text("Firma del cliente: ____________________", 20, qrY + 60);
    doc.text(
      "Firma del vendedor: ___________________",
      pageWidth / 2,
      qrY + 60,
    );

    // **Guardar PDF**
    const remitoFileName = `Remito_${transaccionData.id}.pdf`
    doc.setProperties({ title: remitoFileName, subject: "Remito", creator: "Sistema" })
    deliverPdf({ doc, fileName: remitoFileName, targetWindow: null })
    const pdfDataUri = doc.output("datauristring");
    return { data: { pdfUrl: pdfDataUri } };
  };

  const enviarFacturaWhatsApp = async (idFactura, pdfBase64, phoneNumber, tipo = 'factura') => {
    try {
      const payload = {
        idFactura,
        pdfBase64,
        phoneNumber,
        tipo // 'factura' | 'presupuesto'
      };

      const response = await axios.post(
        serverURL + "/transaccionAPI/enviarWhatsAppLink", // Usar la ruta correcta
        payload,
      );

      return response.data;
    } catch (error) {
      console.error("Error enviando factura por WhatsApp:", error);
      throw error;
    }
  };

  const enviarMail = async (
    idFactura,
    pdfBase64,
    toEmail,
    tipo = "factura",
  ) => {
    try {
      let payloadPdf = pdfBase64;
      if (
        typeof payloadPdf === "string" &&
        /^data:application\/pdf/i.test(payloadPdf)
      ) {
        const idx = payloadPdf.indexOf(",");
        payloadPdf = idx !== -1 ? payloadPdf.slice(idx + 1) : payloadPdf;
      }
// console.log(        `[Email] preparing send id=${idFactura}, tipo=${tipo}, to=${toEmail}, base64Len=${payloadPdf?.length || 0}`,      );
      const response = await axios.post(
        `${serverURL}/transaccionAPI/enviarMail`,
        {
          idFactura,
          pdfBase64: payloadPdf,
          toEmail: toEmail,
          tipo,
        },
      );

// console.log("[Email] server response:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "[Email] Error enviando factura por Email:",
        error?.response?.status,
        error?.response?.statusText,
      );
      if (error?.response?.data) {
        console.error("[Email] server data:", error.response.data);
      }
      throw error;
    }
  };
  //Logica de usuarios

  // USUARIO / COOKIE  ************************// USUARIO / COOKIE  ************************************************************************************************************************************************
  // USUARIO / COOKIE  ************************// USUARIO / COOKIE  ************************************************************************************************************************************************
  // SE SETEAN ASI:
  // setCookie('tenant', userData.tenant);
  // EN EL BACKEND SE RECUPERAN ASI
  // req.cookies.tenant
  // EN EL FRONT END SE RECUPERAN ASI
  // Cookies.get('tenant')
  // ASI SE ELIMINAN
  // Cookies.remove('tenant');

  const [user, setUser] = useState("");
  const [tenantContext, setTenant] = useState("");
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [isSessionExpired, setIsSessionExpired] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const savedUser = localStorage.getItem("user");

    if (token && savedUser) {
      const userParsed = JSON.parse(savedUser);
      const userWithDefaults = {
        ...userParsed,
        token,
        accesosFuncionalidad: userParsed.accesosFuncionalidad || [],
      };
      setUser(userWithDefaults);
      setToken(token);
      
      // Precargar catálogos base al restaurar sesión
      getTipoEntidad();
      getCondicionIva();

      // 🔢 Cargar formato numérico al restaurar sesión desde localStorage
      const loadFormatoNumerico = async () => {
        try {
          const resultado = await getParametrosGlobales(["formatoNumerico"]);
          const valor = resultado?.formatoNumerico;
          if (typeof valor === "string" && valor.trim() !== "") {
            setFormatoNumericoGlobal(valor.trim());
// console.log("🔢 [Restaurar sesión] Formato numérico cargado:", valor.trim());
          } else {
            setFormatoNumericoGlobal(null);
// console.log("🔢 [Restaurar sesión] Formato numérico: autodetección (navegador)");
          }
        } catch (error) {
          console.error("Error obteniendo formato numérico global al restaurar sesión:", error);
          setFormatoNumericoGlobal(null);
        }
      };
      loadFormatoNumerico();
    } else if (token) {
      // Si no hay "user" pero sí token, usás el token básico (sin datos extra)
      const decodedToken = jwtDecode(token);
      setUser({ ...decodedToken, token });
      setToken(token);
    }
  }, [token]);

  // 🔒 Función para validar sesión de seguridad
  const checkSessionValidity = () => {
    const tenantCookie = Cookies.get("tenant"); // Cookie de seguridad (24hs)
    const savedUser = localStorage.getItem("user");
    const savedToken = localStorage.getItem("token");

    // Si NO hay usuario ni token, no hay sesión activa - no validar
    if (!savedUser && !savedToken) {
      setIsSessionExpired(false);
      return true;
    }

    // Si hay usuario/token pero NO hay cookie de seguridad = sesión expirada
    // Pero solo activar si realmente hay una sesión activa (hay user o token válido)
    if ((savedUser || savedToken) && !tenantCookie) {
      // Verificar si el token JWT es válido antes de marcar como expirado
      // Puede ser que la cookie se perdió pero el token aún es válido
      if (savedToken) {
        try {
          const decodedToken = jwtDecode(savedToken);
          const currentTime = Date.now() / 1000;
          
          // Si el token JWT también expiró, entonces sí es sesión expirada
          if (decodedToken.exp && decodedToken.exp < currentTime) {
            console.warn("⚠️ Sesión de seguridad expirada (cookie tenant no existe y token JWT expirado)");
            setIsSessionExpired(true);
            return false;
          }
          // Si el token JWT es válido pero falta la cookie, puede ser un problema temporal
          // No marcar como expirado inmediatamente, solo loguear
          console.warn("⚠️ Cookie tenant no encontrada pero token JWT válido - puede ser problema temporal");
          return true; // Permitir continuar, puede ser un problema temporal de cookies
        } catch (error) {
          console.error("Error al decodificar token:", error);
          // Si no se puede decodificar el token, sí es sesión expirada
          setIsSessionExpired(true);
          return false;
        }
      } else {
        // Hay usuario pero no token ni cookie - sesión expirada
        console.warn("⚠️ Sesión de seguridad expirada (cookie tenant no existe y no hay token)");
        setIsSessionExpired(true);
        return false;
      }
    }

    // Validar expiración del JWT
    if (savedToken) {
      try {
        const decodedToken = jwtDecode(savedToken);
        const currentTime = Date.now() / 1000;
        
        if (decodedToken.exp && decodedToken.exp < currentTime) {
          console.warn("⚠️ Token JWT expirado");
          setIsSessionExpired(true);
          return false;
        }
      } catch (error) {
        console.error("Error al decodificar token:", error);
        setIsSessionExpired(true);
        return false;
      }
    }

    // Si llegamos aquí, la sesión es válida
    setIsSessionExpired(false);
    return true;
  };

  // 🔄 Validación periódica de sesión (cada 60 segundos)
  useEffect(() => {
    // Solo validar si hay usuario logueado
    if (!user) {
      setIsSessionExpired(false);
      return;
    }

    // Ejecutar con un pequeño delay para asegurar que las cookies estén establecidas
    const initialTimeout = setTimeout(() => {
      checkSessionValidity();
    }, 1000); // Esperar 1 segundo antes de la primera validación

    // Luego ejecutar cada minuto
    const interval = setInterval(() => {
      // Solo validar si hay usuario logueado
      if (user) {
        checkSessionValidity();
      }
    }, 60000); // 60 segundos

    // 🆕 Detectar cuando la página vuelve a ser visible (después de suspensión)
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && user) {
        // Cuando la página vuelve a ser visible, esperar un poco más para que las cookies se restablezcan
        // y luego validar de forma más permisiva
        setTimeout(() => {
          const tenantCookie = Cookies.get("tenant");
          const savedUser = localStorage.getItem("user");
          const savedToken = localStorage.getItem("token");
          
          // Si hay usuario y token pero no hay cookie, esperar un poco más
          // Puede ser que las cookies aún no se hayan restablecido
          if (savedUser && savedToken && !tenantCookie) {
            // Esperar 2 segundos más y verificar nuevamente
            setTimeout(() => {
              const tenantCookieRetry = Cookies.get("tenant");
              if (!tenantCookieRetry) {
                // Si después de esperar aún no hay cookie, validar el token JWT
                // Si el token es válido, no marcar como expirado (puede ser problema temporal)
                try {
                  const decodedToken = jwtDecode(savedToken);
                  const currentTime = Date.now() / 1000;
                  
                  if (decodedToken.exp && decodedToken.exp < currentTime) {
                    // Token expirado = sesión realmente expirada
                    console.warn("⚠️ Sesión expirada después de suspensión: token JWT expirado");
                    setIsSessionExpired(true);
                  } else {
                    // Token válido pero cookie no disponible = problema temporal, no marcar como expirado
                    console.warn("⚠️ Cookie no disponible después de suspensión pero token válido - no expirar sesión");
                    setIsSessionExpired(false);
                  }
                } catch (error) {
                  console.error("Error al validar token después de suspensión:", error);
                  // Si hay error decodificando, no marcar como expirado inmediatamente
                  // Puede ser un problema temporal
                  setIsSessionExpired(false);
                }
              } else {
                // Cookie restaurada, sesión válida
                setIsSessionExpired(false);
              }
            }, 2000);
          } else {
            // Si hay cookie o no hay sesión, validar normalmente
            checkSessionValidity();
          }
        }, 500); // Esperar 500ms después de volver a ser visible
      }
    };

    // Agregar listener para cambios de visibilidad
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [user]);

  const setCookie = (name, value, persistent = false) => {
    if (persistent) {
      // Cookie persistente: 365 días
      Cookies.set(name, value, { expires: 365 });
    } else {
      // Cookie de seguridad: 1 día
      Cookies.set(name, value, { expires: 1 });
    }
  };
  const login = async (userData) => {
    try {
      // console.log(userData)
      const response = await axios.post(
        serverURL + "/loginAPI/login",
        userData,
      ); // Ajusta la URL según tu configuración

      const user = response.data.user;

      // 🔒 Cookie de seguridad (24hs) - usada para validación en backend
      setCookie("tenant", userData.tenant, false); // COOKIE TENANT SEGURIDAD
      setCookie("usuario", userData.usuario, false); // COOKIE USUARIO
      setCookie("idUsuario", response.data.user.id, false); // ID del usuario
      setCookie("nombreUsuario", response.data.user.usuario, false); // Nombre del usuario
      setCookie("rolUsuario", "", false); // Se actualizará más adelante

      // 🌐 Cookie persistente (365 días) - usada para URLs y navegación
      setCookie("tenantURL", userData.tenant, true); // COOKIE TENANT PERSISTENTE

      setTenant(userData.tenant); // Actualizar contexto
      localStorage.setItem("token", response.data.token);

      let usuarioConRol = user;

      const rolUsuario = await getRolDeUsuario(user.rol); // Suponiendo que devuelve un objeto tipo { id: 1, descripcion: 'Administrador' }
// console.log("rolUsuario", rolUsuario);
      const [accesosDelRol, accesosFuncionalidadDelRol] = await Promise.all([
        getRolAccesoByIdRol(user.rol),
        getRolSectorAccesoByIdRol(user.rol),
      ]);

      usuarioConRol = {
        ...user,
        rolUsuario: rolUsuario.descripcion, // agrega el rol al objeto user
        idRolUsuario: rolUsuario.id, // agrega el id del rol al objeto user
        accesos: accesosDelRol, // ← agregamos los accesos al objeto user
        accesosFuncionalidad: accesosFuncionalidadDelRol || [], // ← permisos granulares (componentes sector)
      };

// console.log("usuarioConRol", usuarioConRol);

      setCookie("rolUsuario", usuarioConRol.rolUsuario, false); // Guarda el rol del usuario en la cookie (seguridad)
      localStorage.setItem("user", JSON.stringify(usuarioConRol));
      setUser(usuarioConRol);
      setIsSessionExpired(false); // Resetear estado de sesión expirada
      
      // Precargar catálogos base después del login exitoso
      getTipoEntidad();
      getCondicionIva();

      // 🔢 Cargar formato numérico después del login exitoso
      try {
        const resultado = await getParametrosGlobales(["formatoNumerico"]);
        const valor = resultado?.formatoNumerico;
        if (typeof valor === "string" && valor.trim() !== "") {
          setFormatoNumericoGlobal(valor.trim());
// console.log("🔢 [Login] Formato numérico cargado:", valor.trim());
        } else {
          setFormatoNumericoGlobal(null);
// console.log("🔢 [Login] Formato numérico: autodetección (navegador)");
        }
      } catch (error) {
        console.error("Error obteniendo formato numérico global:", error);
        setFormatoNumericoGlobal(null);
      }
    } catch (error) {
      console.error(
        "Error de inicio de sesión:",
        error.response?.data?.message || error.message,
      );
      throw error; // Lanza el error para manejarlo en el componente
    }
  };

  const getRolDeUsuario = async (idRol) => {
    try {
      const usuarioRol = await axios.get(
        serverURL + "/loginAPI/usuarioRol",
        { params: { idRol: idRol } }, // <- pasás como query param
      ); // Ajusta la URL según tu configuración

      return usuarioRol.data;
    } catch (error) {}
  };

  const logout = () => {
    // 🌐 Usar cookie persistente para navegación (tenantURL)
    const tenantURL = Cookies.get("tenantURL"); // Cookie persistente
    const tenantForNav = tenantURL || "default"; // Fallback si no existe

    // Limpiar datos de sesión
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    
    // Limpiar cookies de seguridad (24hs)
    Cookies.remove("tenant");
    Cookies.remove("usuario");
    Cookies.remove("idUsuario");
    Cookies.remove("nombreUsuario");
    Cookies.remove("rolUsuario");
    
    // 🔢 Limpiar formato numérico al hacer logout
    setFormatoNumericoGlobal(null);
    
    // NO eliminar tenantURL (cookie persistente) para mantener la URL correcta
    setUser(null);
    setIsSessionExpired(false);
    navigate(`/${tenantForNav}/login`);
  };

  // "CONSTRUCTOR" ***********************************************************************

  // RETURN DEL CONTEXT ***********************************************************************
  // RETURN DEL CONTEXT ***********************************************************************
  // RETURN DEL CONTEXT ***********************************************************************
  return (
    <ErpContext.Provider
      value={{
        ///VALUES NEGOCIOS
        ubicaciones,
        postUbicacion,
        getUbicacion,
        updateUbicacion,
        deleteUbicacion,
        //VALUES NEGOCIOS
        postNegocio,
        getNegocio,
        updateNegocio,
        deleteNegocio,
        negocios,
        //VALUES TIPOENTIDAD
        postTipoEntidad,
        getTipoEntidad,
        updateTipoEntidad,
        deleteTipoEntidad,
        tipoEntidades,
        //VALUES CONDICION IVA
        getCondicionIva,
        getCondicionIvaByEntidad,
        condicionIva,
        //VALUES ENTIDAD
        postEntidad,
        getEntidad,
        entidades,
        getUsuario,
        postUsuario,
        updateUsuario,
        deleteUsuarioSoft,
        usuarios,
        updateEntidadEmail,
        verificarEliminacionCliente,
        deleteEntidadCliente,
        postMoneda,
        getMoneda,
        updateMoneda,
        deleteMoneda,
        monedas,
        getTipoMedioDePago,
        postTipoMedioDePago,
        updateTipoMedioDePago,
        deleteTipoMedioDePago,
        tipoMedioDePago,
        getMedioDePago,
        postMedioDePago,
        updateMedioDePago,
        deleteMedioDePago,
        medioDePago,
        medioDePagoConDescripcion,
        getMedioDePagoConDescripcion,
        getCategoriaTransaccion,
        postCategoriaTransaccion,
        updateCategoriaTransaccion,
        deleteCategoriaTransaccion,
        medioDePagoIdTipoEspecifico,
        getMedioDePagoIdTipoEspecifico,
        categoriaTransaccion,
        getSubCategoriaTransaccion,
        postSubCategoriaTransaccion,
        updateSubCategoriaTransaccion,
        deleteSubCategoriaTransaccion,
        subCategoriaTransaccion,
        getTipoTransaccion,
        postTipoTransaccion,
        updateTipoTransaccion,
        deleteTipoTransaccion,
        postTransaccionPago,
        postCrearPago,
        tipoTransaccion,
        deleteItem,
        transaccionItemsPostDelete,
        getTransaccionItemsByTransactionId,
        deleteTransaccionItemNoLista,
        getItem,
        postItem,
        item,
        getItemTresLetras,
        arrayItemTresLetras,
        itemTresLetras,
        arrayItemTresLetras,
        getGruposTresLetras,
        gruposTresLetras,
        itemUbicacionFilter,
        getItemUbicacionFilter,
        getItemUbicacion,
        postItemUbicacion,
        updateItemUbicacion,
        itemUbicacion,
        updateItem,
        updateItemUbicaciones,
        // Funciones de eliminación masiva
        updateItemUbicacionEliminado,
        getItemUbicacionesByItemId,
        bulkDeleteItems,
        getTransaccionItem,
        postTransaccionItem,
        transaccionItem,
        getTransaccion,
        postTransaccion,
        postTransferenciaInterna,
        getClientesPorGrupoYDestino,
        contarPasajerosLiberados,
        postCuentaCorrienteCuotas,
        postCuentaCorrienteCuotasDetalle,
        getCuentaCorrienteCuotas,
        getPlanCuotaPasajeroByIdEntidad,
        getPlanCuotaPasajeroByTransaccionIds,
        updateCuentaCorrienteCuota,
        revertirPagoCuota,
        getPlanCuotas,
        postPlanCuotas,
        aplicarPlanCuotas,
        transaccion,
        transaccionTransformed,
        getTransaccionTransformed,
        entidadesClientesTresLetras,
        getEntidadesClientesTresLetras,
        getTransaccionTransformedVentas,
        getTransaccionTransformedVentasAllData,
        getTransaccionTransformedCompras,
        getTransaccionTransformedPresupuesto,
        getTransaccionTransformedPresupuestosAllData,
        putTransaccion,
        updateTransaccionItem,
        getTransaccionItemByTransactionAndItem,
        updateEntidad,
        getTransaccionItemID,
        generarFacturaPDF,
        getCuentaCorriente,
        getCuentaCorrienteTransformed,
        cuentaCorrienteTransformed,
        postCuentaCorriente,
        updateCuentaCorriente,
        cuentasCorrientes,
        fetchFilteredTransactions,
        getDeletedItemUbicacion,
        getTransaccionFilter,
        transaccionFilter,
        getEntidadByID,
        getItemById,
        postTransaccionDevolucion,
        validarDevolucionCanje,
        postTransaccionItemDevolucion,
        generarRemitoPDF,
        user,
        login,
        logout,
        checkSessionValidity,
        tenantContext,
        isSessionExpired,
        setIsSessionExpired,
        formatoNumericoGlobal,
        updateItemAtributo,
        itemAtributo,
        getItemAtributo,
        itemAtributoNoEliminados,
        getItemAtributoNoEliminados,
        itemAtributoServicioNoEliminados,
        getItemAtributoServicioNoEliminados,
        impuestos,
        arrayImpuestos,
        getImpuestos,
        postImpuestos,
        postTransaccionImpuesto,
        getEntidadFilterTipoEntidad,
        getProveedoresConCuentaCorriente,
        getDetalleProveedorCuentaCorriente,
        revertirServicioBOM,
        revertirTransaccionProveedor,
        deleteEntidadProveedor,
        getCountServiciosByProveedor,
        postItemProveedor,
        getItemProveedor,
        updateItemProveedor,
        getListaMontosByEntidad,
        getEntidadByDNI,
        existeProveedorConDNI,
        getEntidadByTipoEntidad,
        entidadesTipoEntidad,
        itemAndItemUbicacion,
        getItemAndItemUbicacion,
        getItemAndItemUbicacionServicios,
        getActividadesByDestino,
        updateEliminarEntidad,
        updateDevolverEntidad,
        updateImpuestoEstado,
        updateImpuestoContenido,
        isNavbarCollapsed,
        setIsNavbarCollapsed,
        getItemUbicacionFilterByUbicacion,
        tiposFacturas,
        getTiposFacturas,
        postTransaccionTipoFactura,
        getTransaccionFacturadaData,
        ivaHardcoded,
        getTransaccionMontoTotalByTipoTransaccion,
        enviarFacturaWhatsApp,
        getTop10ItemVentas,
        enviarMail,
        getTop3ItemsLast7Days,
        postListaMonto,
        getItemByCodigoItem,
        updateAllPrices,
        updateFilteredPrices,
        updateItemPrecioListaId,
        updatePreciosListaMultiple,
        getListaMontosByIdItem,
        updateListaDeMonto,
        updateListaDeMontoBatch,
        getListaMontosByIdItemIdEntidad,
        getEstadoCompra,
        postTransaccionCompraEstado,
        postTransaccionCompraItem,
        getTransaccionItemIDEnCompras,
        updateTransaccionCompraItem,
        updateTransaccionCompraEstado,
        getTransaccionItemByTipoTransaccion,
        getClientePaqueteDetalle,
        getClientePaqueteMovimientos,
        getTransaccionItemByTipoTransaccionAllData,
        deleteTransaccionItem,
        deleteTransaccionCompraItem,
        updateIncluirImpuestos,
        getIncluirImpuestos,
        getCuentaCorrienteByIdEntidad,
        postTransaccionImpuestoItem,
        updateTransaccionImpuestoItem,
        getTransaccionImpuestoItems,
        updateDeleteTransaccion,
        copiarPreciosEntreEntidades,
        enviarFacturaAfip,
        crearYFacturarVentaManualAfip,
        getAfipSalesPoints,
        createAfipSalesPoint,
        getRetencionesRegimenes,
        postInformarRetencionSire,
        postDryRunSire,
        postAuthorizeSire,
        postDummySire,
        postRetencionSire,
        getCajaByMedioDePago,
        crearGrupoPaqueteApi,
        crearRecetaApi,
        eliminarBomApi,
        setCerradoPaqueteApi,
        setCanceladoPaqueteApi,
        createOrUpdateVendedorPaquete,
        getVendedorPaquete,
        getBomByIdItem,
        getPaquetesByServicio,
        getItemUbicacionStatsBatch,
        getRecetas,
        getRecetasViajes,
        getTablaRecetaDatos,
        getTablaRecetaTotales,
        getTablaRecetaFinancieros,
        getFechaHoraActualClient,
        getRolUsuario,
        postRolUsuario,
        updateRolUsuario,
        getUsuariosByRol,
        deleteRolYUsuarios,
        getMenuAcceso,
        getRolAccesoByIdRol,
        actualizarRolAccesos,
        getComponenteSector,
        getComponenteSectorByMenuAcceso,
        postComponenteSector,
        updateComponenteSector,
        deleteComponenteSector,
        getRolSectorAccesoByIdRol,
        actualizarRolSectorAccesos,
        tieneAccesoFuncionalidad,
        getSubCategoriaTransaccionByCategoria,
        getGastosTransacciones,
        revertirGasto,
        generarPdfGastos,
        generarPdfRecetas,
        updateTransaccionPago,
        deleteTransaccionPagoByTransaccion,
        deleteTransaccionPagoItem,
        getTransaccionesPagoFilter,
        getAndPostCajaDatos,
        getCajaAndRecalcularCaja,
        getParametrosGlobales,
        getParametrosGlobalesMenu,
        updateParametroGlobal,
        getCanalEntidad,
        getImpuestoItem,
        updateImpuestoItem,
        getImpuestosDisponibles,
        getIvaAFIP,
        exportarPLUsBalanza,
        getCondicionIvaByIdEntidad,
        generarNotaCredito,
        guardarComprobante,
        abrirNotaCreditoAfip,
        // Portal de Clientes
        loginCliente,
        verificarSesionCliente,
        getMisPaquetesCliente,
        getMisCuotasCliente,
        crearPreferenciaPagoCliente,
        getParametrosGlobalesCliente,
        // Servicio de sincronización WebSocket
        websocketSyncService,
      }}
    >
      {children}
    </ErpContext.Provider>
  );
};

